/*
  svnty-returns-desk.js: THE REQUEST FORM of the returns page (sections/svnty-returns-desk.liquid).
  Born 2026-08-24 in the parent store; ported 2026-09-19; rebuilt for SVNTY 2026-09-26 by RETURNS_SVNTY_Build
  (Design_Part8, R238). Every law below was paid for once and is kept where it lives; what changed in the rebuild:
    THE LANE SWITCH   the form goes live on its own section setting (data-desk-live), never on the tracking flag; while it is off
                      Find prepares the email (THE HONEST STATE) and nothing is faked. ?desk_api= points a QA lane at a fixture
                      server, on 127.0.0.1, localhost and in the theme editor only (a crafted link on the live domain must never
                      carry order and contact to another host).
    THE DIFFERENT ADDRESS (R214)  the checkout address is shown verbatim and read-only and sent untouched (pickup.mode
                      "delivery"); "Collect from a different address" opens the checkout's grammar, judged here by the desk's own
                      rules and sent as typed (pickup.mode "other" + pickup_address in the desk's shape). The governorates are the
                      checkout's own list, printed by the section; no lane route is needed for them.
    MANY PIECES (P27-7, the owner's order of 2026-10-09)  every line of the order is a checkbox; a ticked line opens its own editor
                      in place: the color swatches and the size chips of that product from live stock (hers marked, sold out struck),
                      the result line and the price difference, the quantity when the line holds more, and its reason (THE RISE list,
                      one per piece). One request carries every ticked piece. A change before it ships asks what changes, as chips.
                      The swap rail, the typed finder and "Add another piece" are retired.
    THE REQUEST, READ BACK  the aside restates the request live: the kind, each piece, what is wanted, the pickup, the money.
    NO-FADE           nothing is dimmed: a locked step is its legend and a line; a closed card is dashed words.

  THE CAPTCHA (a live finding in the parent store, 2026-08-29). The storefront's hCaptcha script listens for this form's `submit`
  event and, about 300 ms later, calls the NATIVE form.submit() itself; it never sees our preventDefault(). So the visible button
  is type="button" and starts the chain (startSubmit); nothing dispatches a submit event until the intake has RESOLVED, and then
  nothing does (R240f): the page never posts the store's form; a filed request ends on the page's own confirmation. The `submit` listener is a gate, not the chain.
  This module never calls form.submit().

  THE LANE (App Proxy /apps/svnty/returns): POST /lookup {order, contact} -> {token, order}; POST /order {token} -> {order};
  POST /intake/return (the request, filed as a real return before the mail goes; a transport failure stops the mail too);
  POST /intake/note (beside a return, an exchange or a cancel: a side record, started and never awaited; P22: a change of size, color
  or address before it ships IS the filing, awaited, and the confirmation mounts only on its 200).
  P22 THE PROOF BY REPLAY: the lane's interfaces are 02_architecture/backend/replay_2026-10-02/BUILD/BUILD_CONTRACT.md I1 to I9.
*/
(function () {
  'use strict';
  if (window.__svntyReturnsDeskInit) return;
  window.__svntyReturnsDeskInit = true;

  var root = document.querySelector('[data-svnty-rd]');
  if (!root) return;
  /* P35-2 (SEC-A-08): the hand-off is a read-once getter; it is read here, first, once, for THE FILED check and arrivalOrder() */
  var ARRIVAL = null;
  try { ARRIVAL = window.__svntyArrival || null; window.__svntyArrival = null; } catch (e) {}
  // Theme editor: the section is torn out and re-rendered. Release the once-guard so the fresh DOM gets its module.
  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target || (e.target.contains && e.target.contains(root))) window.__svntyReturnsDeskInit = false;
  });
  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };
  /* ---------- THE DEMO FENCE (RT-2, PARITY_GAPS 2026-09-19) ----------
     The demo used to write into the LIVE draft store. Touching the `?demo=1` form left
     `__order:"DEMO"`, `__line:"demo-1"` and the demo pickup block in `svnty:rd:draft:v3`, and the
     NEXT visit — without the flag, before any order was verified — came back with Reason "Runs
     small" prefilled, the Exchange card pre-checked and "Demo Customer" sitting in the pickup-name
     cell, while the banner promised nothing was remembered. A synthetic order must never touch a
     real customer's storage: the demo now has a key of its own, and a real visit purges anything
     the old build left behind (both the demo key and a real draft stamped __order === 'DEMO').
     DEMO_VIEW is 0 on a real visit and 1-5 on the demo lane (see THE DEMO LANE at the foot). */
  var DEMO_VIEW = (function () {
    /* P16-9 THE DEMO FENCE: the lane opens on 127.0.0.1, localhost and in the theme editor only (QA_SURFACE's rule below); on the live
       domain `?demo=` is a plain visit, so no shareable link shows a #DEMO request under the store's name. */
    var qa = !!((window.Shopify && window.Shopify.designMode) || /^(127\.0\.0\.1|localhost)$/.test(location.hostname));
    var m = qa ? /[?&]demo=([1-5])(?:&|$)/.exec(location.search || '') : null;
    return m ? Number(m[1]) : 0;
  })();
  var DEMO = DEMO_VIEW > 0;
  var REAL_DRAFT_KEY = 'svnty:rd:draft:v3';
  var DEMO_DRAFT_KEY = 'svnty:rd:demo-draft:v3';
  /* The VIEW is part of the demo key: each of the five is a clean state. Without it, walking the
     switcher carried view 3's choices into view 4 (a draft doing exactly its job, in the wrong place for
     a demo whose whole purpose is to show one state honestly). The un-numbered key is still purged on a
     real visit, so a draft written by the build before this one cannot survive either. */
  var DRAFT_KEY = DEMO ? DEMO_DRAFT_KEY + ':' + DEMO_VIEW : REAL_DRAFT_KEY;
  var LEGACY_DRAFT_KEYS = ['svnty:rd:draft:v2'];
  // H-02, amended by the owner 2026-08-29: the draft is still an ALLOWLIST; the AWB and every hidden verification field stay
  // out of it. What rides in it is what the customer would otherwise type twice: the note, the chosen line, the WANT options,
  // and (P2-7, said as it is) a different pickup address she typed, its names and lines but never its phone. It lives beside
  // THE SESSION below: one tab, gone on a post, on "Look up another", or when the tab closes.
  // DECLARED HERE, above every caller: the shop-back restore runs long before the draft block below, and a `var` read
  // before its assignment is undefined — which used to throw and kill the module.
  var DRAFT_META = ['__kind', '__lane', '__return', '__joined', '__pieces', '__cancel', '__pickup', '__order', '__changed'];   // P27-7: __pieces (every piece's choice), __cancel
  var DRAFT_KEEP = { 'contact[Request]': 1, 'contact[Resolution]': 1, 'contact[Edit action]': 1, 'contact[body]': 1, 'contact[Policy consent]': 1 };   // P20: the consent comes back too
  /* THE SESSION (owner order, 2026-08-29): "a page refresh must not send the customer back to the order number."
     The desk token + the ORDER NUMBER ride in sessionStorage (v2, F17: never the snapshot, never the contact): ONE TAB,
     gone when the tab closes, when the request posts, on "look up another", and two hours after the lookup (the
     token's own life). Nothing here is trusted — every restore re-reads the order from the desk before a step
     unlocks, and a 401 drops the whole session. */
  var SESSION_KEY = 'svnty.rd.session.v1';
  var SESSION_TTL_MS = 2 * 60 * 60 * 1000;
  var MOTION = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth';   // L-02
  var REASONS_BY_KIND = { exchange: ['fit', 'piece'], refund: ['fit', 'piece'], faulty: ['problem'], cancel: ['order'] };

  function sget(k) { try { return JSON.parse(sessionStorage.getItem(k)); } catch (e) { return null; } }
  function sset(k, v) {
    try { sessionStorage.setItem(k, JSON.stringify(v)); return true; }
    catch (e) { emitXsStorageFailure(); return false; }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* P20 THE MEMORY OF THE FORM (the owner, 2026-10-01: "when they refresh, the info that they filled must come back as is ...
     and if they finished the whole form see what happens there"). Three small records beside THE SESSION and the draft, all in
     sessionStorage: ONE TAB, two hours from the last write, gone when the request is filed, on "Look up another" and when the
     tab closes; never localStorage, never a URL, never another host.
       THE CELLS   the order number she typed in step 1, WHICH contact the lane matched (vc) and the channel core proved (vb):
                   words, never a copy. The owner's amendment of H-02 / F17 (2026-10-01, R363: what she filled comes back after a
                   refresh) stands. P35-3: the order number and her choices come back from this tab; the contact comes back as the
                   server's own verified state ("Verified with •••• 678", svnty-core 0.8.2's contactMasked), proven by the two-hour
                   token and never read from storage (P35-2: a contact beside an order number is the whole key to the order, and
                   every script on the page can read this storage). A core that sends no mask (0.8.1) asks for the contact that
                   matched once, by name. The different address's phone is the one cell typed again (a phone beside an order number).
       THE PLACE   the step she stood on and where it stood on the screen, so a refresh puts her back once the steps reopen.
       THE FILED   a request that exists: the order number, the kind, the request's name and the lane's own words, so the
                   confirmation is still there after a refresh, a Back or a second visit (no contact, no address). */
  var CELLS_KEY = 'svnty:rd:cells:v1', PLACE_KEY = 'svnty:rd:place:v1', FILED_KEY = 'svnty:rd:filed:v1';
  function sdel(k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  function fresh(k) {
    var r = sget(k);
    if (!r || r.v !== 1 || !isFinite(Number(r.t)) || r.t > Date.now() + 60000 || Date.now() - r.t > SESSION_TTL_MS) { if (r) sdel(k); return null; }
    return r;
  }
  /* P22 THE FILED RECORD IS ASKED AGAIN (FAKE F7): the card a refresh, a Back or a second visit mounts was the lane's answer at the
     moment of filing, so the status route is asked once more with the request's own token (kept in THE FILED record for its two
     hours, as THE SESSION kept it). A request the lane still lists stays; one it no longer knows (a test row neutralised, a
     rehearsal row after the switch) takes the card away and gives the form back. A lane that cannot be reached, or a token that
     lapsed, leaves the saved card: what was filed was filed. A change before it ships is a note, never a row of the status route:
     its card stands. A rehearsal filing has no name on the page, so it is known by its lane and the minute it was made. */
  function recheckFiled(rec) {
    var base = String((QA_API ? '' : (root.getAttribute('data-owner-url') || '').trim()) || DESK || '').replace(/\/$/, '');
    if (!rec || !rec.tok || !rec.lane || !base) return;
    var opts = { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin', body: JSON.stringify({ token: rec.tok }) };
    var done = window.svntyWall ? window.svntyWall(opts, 8000) : function () {};
    fetch(base + '/status', opts).then(function (r) { done(); return r.ok ? r.json() : null; }).then(function (body) {
      if (!body || body.ok !== true || !Array.isArray(body.requests)) return;
      var known = body.requests.some(function (q) {
        if (rec.name) return String(q.rr || '') === String(rec.name);
        var made = Date.parse(q.made_at || ''), same = String(q.kind || '') === String(rec.kind || '') || String(q.resolution || q.kind || '') === String(rec.lane);
        return same && (!isFinite(made) || made >= Number(rec.t) - 600000);
      });
      if (known) return;
      sdel(FILED_KEY);
      try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
      location.reload();
    }).catch(function () { done(); });
  }

  /* ---------- success screen: type-specific next steps ---------- */
  /* THE CONFIRMATION (R240f, the ruling on image 12): the page never posts Shopify's contact form any more (its bot interstitial
     ended a filed request on an unbranded page); the desk's row and its push are the record and the notice, no mail is added. After a
     filing the page mounts this view itself from the section's inert template; the load-time branch stays for the old posted links. */
  /* P21 THE CARD LANDS UNDER THE HEADER, FOR REAL: the page travels up to the confirmation, and the way up brings the
     announcement bar back (34 px the scroll's own margin did not know), so the card's top edge stood 18 px under the header.
     Once the page rests the card is set 16 px under the header's real bottom; a card she scrolled into on purpose is left. */
  function landPosted(view, wait) {
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function set(last) {
      if (!view || !view.isConnected) return;
      var slab = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--svnty-headstack-h')) || 98;
      var b = view.getBoundingClientRect(), vh = window.innerHeight || 0, d = Math.round(b.top - (slab + 16));
      if (b.bottom < 120 || b.top > vh - 120) { try { view.scrollIntoView({ block: 'start', behavior: 'auto' }); } catch (e) {} }
      else if (d < -2 && d > -80) { try { window.scrollBy({ top: d, left: 0, behavior: calm ? 'auto' : 'smooth' }); } catch (e) { window.scrollBy(0, d); } }
      if (!last) setTimeout(function () { set(true); }, 600);
    }
    setTimeout(function () { set(false); }, wait);
  }
  function mountPosted(posted, rec) {
    // P20: `rec` is THE FILED record of a request this tab already sent (a refresh, a Back, a second visit): the same card, the same words
    var draft = rec ? { __kind: rec.kind, __lane: rec.lane, __return: rec.name, __joined: rec.joined, __words: rec.words, __order: rec.order, __changed: rec.changed } : (sget(DRAFT_KEY) || {});
    /* P22 THE STORED REQUEST: the lane answered the request filed earlier under this id (changed: true), so nothing of what was typed
       since is shown as filed: no kind's next step is picked from the form, the words say which request this is */
    var changed = draft.__changed === '1';
    var kind = changed ? '' : (draft.__kind || '');
    $$('[data-rd-next-for]').forEach(function (li) { li.hidden = kind ? li.getAttribute('data-rd-next-for') !== kind : false; });
    /* P18-1 (F2): a line that does not belong to one kind leaves with it (a cancel before shipping holds no piece to keep ready) */
    $$('[data-rd-next-not]').forEach(function (li) { li.hidden = !!kind && li.getAttribute('data-rd-next-not') === kind; });
    // THE LANE: when the request became a real return, the confirmation names it.
    var filedLane = draft.__lane || '', filedName = draft.__return || '';
    /* P22 (DEFECTS P3-3, FAKE F6): nothing is confirmed at the filing, a person decides it first; a faulty piece is a claim, never
       "your exchange" (its replacement rides the exchange lane) */
    if (filedName && (filedLane === 'exchange' || filedLane === 'refund')) {
      var lede = $('[data-rd-posted-lede]', posted);
      if (lede) lede.textContent = draft.__joined === '1'
        ? 'Your request joins ' + filedName + ', already open for this order. A person on our team reviews it and emails you the decision.'
        : (kind === 'faulty' ? 'Your claim is filed as ' : filedLane === 'exchange' ? 'Your exchange is filed as ' : 'Your return is filed as ') + filedName + '. A person on our team reviews it and emails you the decision.';
    }
    if (changed) { var ledeX = $('[data-rd-posted-lede]', posted); if (ledeX) ledeX.textContent = 'Your earlier request was already filed. This is it.' + (filedName ? ' It is filed as ' + filedName + '. A person on our team reviews it and emails you the decision.' : ''); }
    /* D12-3 THE CANCEL DOOR: the desk's own words for the order's state at the moment it answered, and the request's name */
    if (filedLane === 'cancel') {
      var ledeC = $('[data-rd-posted-lede]', posted);
      if (ledeC) ledeC.textContent = (String(draft.__words || '').trim() || 'Your cancellation request is with the team.') +
        (filedName ? (draft.__joined === '1' ? ' It joins ' + filedName + ', already open for this order.' : ' It is filed as ' + filedName + '.') : '') + ' The answer comes by email.';
    }
    /* P20 AFTER THE FORM IS FINISHED: the request's own facts stay with this tab (two hours), so a refresh never shows an empty
       form over a filed request; the cells and the place die with the draft. A demo files nothing and keeps nothing. */
    if (!DEMO && !rec && (kind || draft.__lane)) sset(FILED_KEY, { v: 1, t: Date.now(), order: String(draft.__order || ''), kind: kind, lane: String(draft.__lane || ''), name: String(draft.__return || ''), joined: draft.__joined === '1' ? '1' : '', words: String(draft.__words || '').slice(0, 300),
      tok: verified && verified.token ? String(verified.token) : '', changed: changed ? '1' : '' });   // P22 (F7): the request's own token, so a return to the page asks the lane again
    sdel(CELLS_KEY); sdel(PLACE_KEY);
    var again = posted.querySelector('[data-rd-again]');
    if (again) {
      if (DEMO) { var againRow = again.closest('.svnty-rd__again'); if (againRow) againRow.hidden = true; }
      else again.addEventListener('click', function () {
        sdel(FILED_KEY);
        try { history.replaceState(null, '', location.pathname + location.search + '#svnty-returns-desk-form'); } catch (e) {}
        location.reload();
      });
    }
    // The request exists now: the draft and the verified session both die here.
    try { sessionStorage.removeItem(DRAFT_KEY); sessionStorage.removeItem(DEMO_DRAFT_KEY); for (var dv = 1; dv <= 5; dv++) sessionStorage.removeItem(DEMO_DRAFT_KEY + ':' + dv); sessionStorage.removeItem(SESSION_KEY); } catch (e) {}
    try { LEGACY_DRAFT_KEYS.forEach(function (k) { sessionStorage.removeItem(k); }); } catch (e) {}
    try {
      var completedXs = sessionStorage.getItem('svnty:xs:active:v2') || '';
      if (completedXs) localStorage.removeItem('svnty:xs:v2:' + completedXs);
      sessionStorage.removeItem('svnty:xs:active:v2');
      localStorage.removeItem('svnty:xs:v2');
      localStorage.removeItem('svnty:xs:v1');
    } catch (e) {}
    try { posted.focus({ preventScroll: true }); } catch (e) {}
  }
  var posted = $('[data-rd-posted]');
  if (posted) { mountPosted(posted); return; }

  var form = root.querySelector('form');
  if (!form) return;
  /* THE LANE SWITCH and THE QA LANE (read here since P22: THE FILED record below asks the lane before the rest of the module runs;
     the rules are THE LANE SWITCH's, written where THE VERIFIED DESK begins) */
  var QA_SURFACE = !!((window.Shopify && window.Shopify.designMode) || /^(127\.0\.0\.1|localhost)$/.test(location.hostname));
  var QA_API = (function () {
    if (!QA_SURFACE) return '';
    try { var v = new URLSearchParams(location.search).get('desk_api') || ''; return /^https?:\/\/(127\.0\.0\.1|localhost)(:\d{2,5})?(\/[\w\/-]*)?$/.test(v) ? v.replace(/\/$/, '') : ''; }
    catch (e) { return ''; }
  })();
  var DESK_LIVE = !!QA_API || root.getAttribute('data-desk-live') === 'true';
  var DESK = QA_API || (DESK_LIVE ? (root.getAttribute('data-desk-url') || '') : '');
  /* P20 AFTER THE FORM IS FINISHED: this tab filed a request less than two hours ago, so the page opens on its confirmation, the
     card the filing mounted, never on an empty form that looks as if nothing was sent. A link that arrives for ANOTHER order
     (the mail's ?order= or #order=) opens the form for that order; "Start another request" on the card gives the form back. */
  var filedRec = DEMO ? null : fresh(FILED_KEY);
  if (filedRec) {
    var arriving = '';
    try {
      arriving = String((ARRIVAL && ARRIVAL.order) || new URLSearchParams(location.search).get('order') ||
        (/^#order=/.test(location.hash) ? new URLSearchParams(location.hash.slice(1)).get('order') : '') || '').replace(/^\s*#/, '').trim();
    } catch (e) {}
    if (arriving && arriving !== String(filedRec.order || '')) { sdel(FILED_KEY); filedRec = null; }
  }
  if (filedRec) {
    var filedTpl = root.querySelector('[data-rd-demo-confirm]');
    if (filedTpl && filedTpl.content && form.parentNode) {
      form.parentNode.insertBefore(filedTpl.content.cloneNode(true), form);
      var filedView = root.querySelector('[data-rd-posted]');
      if (filedView) {
        form.parentNode.removeChild(form);
        filedView.id = 'rd-order';
        mountPosted(filedView, filedRec);
        recheckFiled(filedRec);   // P22 (F7): the lane is asked whether it still knows the request
        /* a refresh or a Back onto the confirmation: the card is in sight (the form it replaced was taller or shorter) */
        try {
          var navE = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
          if (navE && (navE.type === 'reload' || navE.type === 'back_forward') && location.hash === '#rd-order') {
            landPosted(filedView, 700);
          }
        } catch (e) {}
        return;
      }
    }
  }
  var world = $('[data-rd-world]');
  if (world) world.value = (document.body.getAttribute('data-world') || 'original');

  /* ---------- THE REQUEST'S KIND, and what changes before it ships (P27-7) ---------- */
  var photonote = $('[data-rd-photonote]');
  var reasonField = $('[data-rd-reason]');   // hidden contact[Reason]: the first piece's reason, or the cancel's (the posted state)
  var editAction = $('[data-rd-edit-action]');   // hidden contact[Edit action]: the chip she chose (Change size | Change color | Change address | Cancel order)
  var resolutionBox = $('[data-rd-resolution]'), resolutionInputs = $$('[data-rd-resolution-choice]');
  var replaceInput = $('[data-rd-replace]'), refundInput = resolutionInputs.filter(function (x) { return x.value === 'Full refund'; })[0];
  var replaceAuto = false;   // P34-12: the page chose the full refund itself (her size and color sold out); it gives the replacement back once that changes
  var changeRow = $('[data-rd-change-row]'), changeBox = $('[data-rd-change]'), addressLine = $('[data-rd-address-line]');
  var cancelBox = $('[data-rd-cancel-box]'), cancelConfirm = $('[data-rd-cancel-confirm]'), cancelTitle = $('[data-rd-cancel-title]');
  var cancelReasonRoot = $('[data-rd-cancel-reason]'), cancelReasonErr = $('[data-rd-cancel-reason-err]');
  var linesRow = $('[data-rd-lines-row]'), linesBox = $('[data-rd-lines]'), linesErr = $('[data-rd-lines-err]'), giftsBox = $('[data-rd-gifts]');
  var linesLabel = $('[data-rd-lines-label]'), linesHint = $('[data-rd-lines-hint]');
  var pieceTpl = root.querySelector('template[data-rd-piece-tpl]');
  var fields = {}; $$('[data-rd-field]').forEach(function (el) { fields[el.getAttribute('data-rd-field')] = el; });
  var verified = null;   // { token, order }
  var lostSettled = false;   // P34-12: the status view lists her lost return as settled (lostReturnSettled); the window line drops its promise
  var verifiedContact = '';    // the contact the lane matched the order with (the second one when the first did not match)
  /* P35-3 THE NEVER-LOSE RESTORE (03_design/research/P35_THEME_REFUTE_2026-10-20.md section b; svnty-core 0.8.2). verifiedBy: the
     channel core says the session was proven with ('email' | 'phone'; '' from a core that does not say, 0.8.1). contactMasked: core's
     own mask of that contact, shown read-only after a refresh. tokenProof: the session came back by its two-hour token and core reads
     the contact itself, so the check and the intake send none. askContact: a core that sends no mask (0.8.1) needs the contact once
     more, asked by name (never "fill this in first" while the token holds). useAnother: she chose to verify with another contact.
     preferEmail: "verify with the email on your order" asks the lane with the email first. */
  var verifiedBy = '', contactMasked = '', tokenProof = false, askContact = '', useAnother = false, preferEmail = false;

  /* No card checked = no request yet (''), never a silent exchange (P1-11). */
  function currentKind() { var r = $('[data-rd-type] input:checked'); return r ? r.getAttribute('data-rd-kind') : ''; }
  function addressEdit() { return currentKind() === 'cancel' && editAction.value === 'Change address'; }
  function isCancelOrder(kind) { return kind === 'cancel' && editAction.value === 'Cancel order'; }
  function afterDelivery(k) { return k === 'exchange' || k === 'refund' || k === 'faulty'; }
  /* the kinds that name pieces: every kind after the delivery, and a change of size or color before it ships */
  function piecesKind() { var k = currentKind(); return afterDelivery(k) || (k === 'cancel' && (editAction.value === 'Change size' || editAction.value === 'Change color')); }
  /* what each piece's editor offers: swap (color and size), size, color (then size), return, faulty */
  function editorMode() {
    var k = currentKind();
    if (k === 'exchange') return 'swap';
    if (k === 'cancel') return editAction.value === 'Change color' ? 'color' : editAction.value === 'Change size' ? 'size' : '';
    return k === 'refund' ? 'return' : k === 'faulty' ? 'faulty' : '';
  }
  function needsTarget(mode) { return mode === 'swap' || mode === 'size' || mode === 'color'; }

  /* THE REASONS, by path (the owner's order: one per piece, regrouped, nothing cut): an exchange takes fit, the piece and the order; a
     return the same and "I changed my mind"; a faulty piece the problem group only; a change before it ships the order group; the whole
     order canceled its own. "Something else" always, last. The values are the lane's (svnty-core REASON_WORDS). */
  var G = { fit: 'Fit', piece: 'The piece', order: 'The order', problem: 'A problem', other: 'Anything else' };
  var R_FIT = [['fit', 'Runs small', 'It runs small'], ['fit', 'Runs large', 'It runs large'], ['fit', 'Length', 'The length is not right']];
  var R_PIECE = [['piece', 'Color not as expected', 'The color is not what I expected'], ['piece', 'Fabric or quality', 'The fabric or the quality']];
  var R_MIND = [['piece', 'Changed my mind', 'I changed my mind']];
  var R_SIZE = ['order', 'Ordered the wrong size', 'I ordered the wrong size'], R_COLOR = ['order', 'Ordered the wrong color', 'I ordered the wrong color'];
  /* P28-1 THE WRONG SIZE AND COLOR TOGETHER (the owner, 2026-10-09): one reason for a piece whose target differs in both; the page picks it
     by itself when both change (autoReason), she may still change it. The same words in svnty-core REASON_WORDS, the desk and the acknowledgement. */
  var R_BOTH = ['order', 'Ordered the wrong size and color', 'I ordered the wrong size and color'];
  var R_MISTAKE = ['order', 'Ordered by mistake', 'I ordered by mistake'], R_ADDRESS = ['order', 'Address changed', 'My address changed'];
  var R_OTHER = [['other', 'Other', 'Something else']];
  var REASONS = {
    exchange: R_FIT.concat(R_PIECE, [R_SIZE, R_COLOR, R_BOTH], R_OTHER),
    refund: R_FIT.concat(R_PIECE, R_MIND, [R_SIZE, R_COLOR, R_BOTH], R_OTHER),
    faulty: [['problem', 'Arrived damaged', 'It arrived damaged'], ['problem', 'Wrong item received', 'I received the wrong piece'], ['problem', 'Manufacturing fault', 'A manufacturing fault']].concat(R_OTHER),
    change: [R_SIZE, R_COLOR, R_BOTH, R_MISTAKE].concat(R_OTHER),
    cancel: [R_MISTAKE, R_SIZE, R_COLOR, R_BOTH, R_ADDRESS].concat(R_OTHER)
  };
  var REASON_LABEL = {}; Object.keys(REASONS).forEach(function (k) { REASONS[k].forEach(function (r) { REASON_LABEL[r[1]] = r[2]; }); });
  function reasonKey() { var k = currentKind(); return k === 'cancel' ? (isCancelOrder(k) ? 'cancel' : 'change') : k; }
  function reasonOptions(key) { return (REASONS[key] || []).map(function (r) { return { value: r[1], label: r[2], group: G[r[0]] }; }); }
  function reasonAllowed(key, v) { return (REASONS[key] || []).some(function (r) { return r[1] === v; }); }
  function reasonLabelOf(v) { return REASON_LABEL[v] || String(v || ''); }

  /* ---------- THE STORE'S MONEY: the shop's own format; whole pounds drop the ".00" as the cards do. `n` is in pounds. ---------- */
  var MONEY_FORMAT = root.getAttribute('data-money-format') || 'EGP {{amount}}';
  function groupThousands(s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
  function money(n) {
    var v = Number(n); if (!isFinite(v)) return '';
    var neg = v < 0, cents = Math.round(Math.abs(v) * 100), whole = String(Math.floor(cents / 100)), frac = String(cents % 100);
    if (frac.length < 2) frac = '0' + frac;
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(MONEY_FORMAT), key = m ? m[1] : 'amount', amount;
    if (key === 'amount_no_decimals') amount = groupThousands(String(Math.round(cents / 100)), ',');
    else if (key === 'amount_with_comma_separator') amount = groupThousands(whole, '.') + ',' + frac;
    else if (key === 'amount_no_decimals_with_comma_separator') amount = groupThousands(String(Math.round(cents / 100)), '.');
    else if (key === 'amount_with_apostrophe_separator') amount = groupThousands(whole, "'") + '.' + frac;
    else amount = groupThousands(whole, ',') + '.' + frac;
    amount = amount.replace(/[.,]00$/, '');
    return (neg ? '-' : '') + (m ? MONEY_FORMAT.replace(m[0], amount) : 'EGP ' + amount);
  }

  /* ---------- THE PRODUCT READ: one at a time per handle, a 30 s freshness stamp, walled (Part30) ---------- */
  var PRODUCT_FRESH_MS = 30000, PRODUCT_TIMEOUT = 8000, productReads = {};
  function fetchLiveProduct(handle) {
    var key = String(handle || '');
    var hit = productReads[key];
    if (hit && (hit.inflight || Date.now() - hit.at < PRODUCT_FRESH_MS)) return hit.promise;
    var entry = { at: Date.now(), inflight: true, promise: null };
    var opts = { headers: { Accept: 'application/json' }, cache: 'no-store' };
    var done = withWall(opts, PRODUCT_TIMEOUT);
    var read = (window.SVNTYXs && window.SVNTYXs.fetchProduct) ? window.SVNTYXs.fetchProduct(key, opts.signal)
      : fetch('/products/' + encodeURIComponent(key) + '.js', opts).then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
    entry.promise = read.then(function (pj) { done(); entry.inflight = false; entry.at = Date.now(); return pj; },
      function (err) { done(); if (productReads[key] === entry) delete productReads[key]; throw err; });
    productReads[key] = entry;
    return entry.promise;
  }
  function productReadAt(handle) { var hit = productReads[String(handle || '')]; return new Date(hit && hit.at ? hit.at : Date.now()).toISOString(); }
  // The liquid `product | json` shape and /products/x.js differ: both are read the same way
  function normImg(pj) { if (pj.featured_image) return typeof pj.featured_image === 'string' ? pj.featured_image : pj.featured_image.src || ''; if (pj.featured_media && pj.featured_media.preview_image) return pj.featured_media.preview_image.src || ''; return ''; }
  function normOptions(pj) {
    var os = pj.options || [];
    if (os.length && typeof os[0] === 'string') {
      return os.map(function (n, i) {
        var seen = [];
        (pj.variants || []).forEach(function (v) { var val = v['option' + (i + 1)]; if (val != null && seen.indexOf(val) === -1) seen.push(val); });
        return { name: n, values: seen };
      });
    }
    return os.map(function (o) { return { name: o.name, values: (o.values || []).map(function (v) { return typeof v === 'string' ? v : (v.name || String(v)); }) }; });
  }
  function normVariants(pj) { return (pj.variants || []).map(function (v) { return { id: v.id, title: v.title, available: !!v.available, price: v.price, options: v.options || [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }) }; }); }
  /* THE SWATCH: the house card names every color of a product with its measured hex and its drawn mark (svnty-colour-hex), read once per
     handle from the card endpoint; a color the card cannot name keeps a plain chip */
  var colourHexes = {};
  function fetchColourHexes(handle, then) {
    if (!handle) return;
    if (colourHexes[handle] !== undefined) { if (colourHexes[handle] && then) then(); return; }
    colourHexes[handle] = null;
    /* P28-3 (the live walk's P1-1): a 429 or a fault on the swatch read is never silent and never sticky: the entry is cleared so the
       next render or "Try again" asks again, and one retry follows Retry-After (1 to 30 s); the read runs under the wall like the product read */
    var o = { credentials: 'same-origin' }, done = withWall(o, PRODUCT_TIMEOUT);
    fetch('/products/' + encodeURIComponent(handle) + '?section_id=svnty-card-fetch', o)
      .then(function (r) { done(); if (r.ok) return r.text(); var e = new Error('card_' + r.status); e.retryAfter = retryAfterOf(r); throw e; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html'), map = {}, n = 0;
        Array.prototype.forEach.call(doc.querySelectorAll('.svnty-card__sw[data-colour]'), function (b) {
          var m = /--sw:\s*([^;"]+)/.exec(b.getAttribute('style') || ''); if (!m) return;
          var svg = b.querySelector('svg.svnty-swv');
          map[String(b.getAttribute('data-colour')).toLowerCase()] = { hex: m[1].trim(), name: b.getAttribute('data-svnty-name') || '', svg: svg ? document.importNode(svg, true) : null };
          n++;
        });
        if (n) { colourHexes[handle] = map; if (then) then(); }
      }).catch(function (e) {
        done();
        delete colourHexes[handle];
        var wait = Math.min(Math.max((e && e.retryAfter) || 2, 1), 30) * 1000, k = '_r' + handle;
        if (!fetchColourHexes[k]) { fetchColourHexes[k] = 1; setTimeout(function () { fetchColourHexes(handle, then); }, wait); }
      });
  }

  /* ---------- MANY PIECES (P27-7, the owner's order of 2026-10-09) ----------
     Every piece of the order is a line she can tick (a second tap adds, a tap again takes it out); each ticked line opens its own
     editor under it. One request carries every ticked piece (the desk files one request per order and its lines). Each piece keeps
     what she chose while it is unticked, so a tick back finds it as it was; only the ticked ones are sent. */
  var pieces = [], picked = [];
  var pieceSeq = 0;
  function pieceOf(lineId) { for (var i = 0; i < pieces.length; i++) if (pieces[i].id === lineId) return pieces[i]; return null; }
  function onPieces() { return picked.map(pieceOf).filter(Boolean); }
  function haveParts(l) {
    var parts = l.variantTitle ? String(l.variantTitle).split(' / ').map(function (p) { return p.trim(); }).filter(Boolean) : [];
    return parts.length ? parts : (l.options || []).map(function (op) { return String(op.value); }).filter(Boolean);
  }
  function openWords(l) {
    var n = String(l.openReturn || ''), st = String(l.openReturnStatus || '');
    if (/^(#|RR-)/.test(n)) return 'Request ' + n + ' is already open on this piece' + (st === 'approved' ? ' (approved)' : '');
    return 'A request is already open on this piece';
  }
  /* how many of the line can be part of this request: the line's own, less the pieces Shopify has not shipped when the request comes after
     the delivery (PARTLY SHIPPED, svnty-core 0.7.0 `unshipped`) */
  function maxQty(p) {
    var q = Math.max(0, Math.floor(Number(p.line.quantity) || 0));
    if (afterDelivery(currentKind()) && Number(p.line.unshipped) > 0) q -= Math.floor(Number(p.line.unshipped));
    return Math.max(0, q);
  }
  /* why a line cannot be ticked for this request, in words ('' = it can) */
  function lineBlock(p) {
    var l = p.line, k = currentKind();
    if (l.openReturn) return openWords(l);
    if (afterDelivery(k) && maxQty(p) < 1) return 'Not shipped yet: it can come back once it is delivered';
    if (needsTarget(editorMode()) && !(l.pickHandle || l.handle)) return 'No longer sold in this version' + (k === 'exchange' ? ': ask for a refund instead, or write to us' : ': write to us to change it');
    return '';
  }
  function buildPieces() {
    pieces = []; picked = []; pieceSeq += 1;
    linesBox.textContent = '';
    if (!verified || !pieceTpl || !pieceTpl.content) return;
    verified.order.lines.forEach(function (l, i) {
      var frag = pieceTpl.content.cloneNode(true), el = frag.querySelector('[data-rd-piece]');
      var uidp = 'p' + pieceSeq + '-' + i;
      Array.prototype.forEach.call(el.querySelectorAll('[id], [for], [aria-controls], [aria-labelledby], [aria-describedby]'), function (n) {
        ['id', 'for', 'aria-controls', 'aria-labelledby', 'aria-describedby'].forEach(function (a) { var v = n.getAttribute(a); if (v && v.indexOf('__') !== -1) n.setAttribute(a, v.split('__').join('-' + uidp)); });
      });
      var p = { i: i, id: String(l.lineId || ''), line: l, el: el, btn: el.querySelector('[data-rd-line]'), ed: el.querySelector('[data-rd-editor]'),
        on: false, qty: 1, sel: {}, reason: '', note: '', product: null, loadFailed: false, loading: false, msg: '', seq: 0 };
      var parts = haveParts(l);
      el.setAttribute('data-rd-piece', p.id); p.btn.setAttribute('data-rd-line', String(i));
      var pic = el.querySelector('[data-rd-line-pic]');
      if (l.image) { var img = document.createElement('img'); img.alt = ''; img.src = l.image; img.width = 56; img.height = 70; img.decoding = 'async'; pic.appendChild(img); }
      el.querySelector('[data-rd-line-title]').textContent = String(l.productTitle || '');
      el.querySelector('[data-rd-line-sub]').textContent = parts.join(' / ');
      el.querySelector('[data-rd-line-qty]').textContent = Number(l.quantity) > 1 ? '×' + l.quantity : '';
      p.ed.setAttribute('aria-label', String(l.productTitle || 'The piece') + (parts.length ? ', ' + parts.join(' / ') : ''));
      p.picker = el.querySelector('[data-rd-ed-reason]');
      linesBox.appendChild(frag);
      if (window.SVNTYPicker) window.SVNTYPicker.setup(p.picker);
      wirePiece(p);
      pieces.push(p);
    });
    renderGifts();
  }
  /* THE GIFT CARD on the order: never a piece for a pickup, said so (svnty-core 0.7.0 giftCards) */
  function renderGifts() {
    var gs = verified && verified.order && Array.isArray(verified.order.giftCards) ? verified.order.giftCards : [];
    giftsBox.textContent = '';
    gs.forEach(function (g) {
      var li = document.createElement('li'); li.className = 'svnty-rd__gift';
      var t = document.createElement('p'); t.className = 'svnty-rd__gift-title'; t.textContent = String(g.title || 'Gift card');
      var w = document.createElement('p'); w.className = 'svnty-rd__gift-why';
      w.textContent = 'A gift card does not come back through this page. Write to ' + (root.getAttribute('data-support') || 'onlineshop@svntyeg.com') + ' about it.';
      li.appendChild(t); li.appendChild(w); giftsBox.appendChild(li);
    });
    giftsBox.hidden = !gs.length;
  }
  function paintPiece(p) {
    var why = lineBlock(p);
    if (why && p.on) setOn(p, false, true);
    p.btn.setAttribute('aria-checked', p.on ? 'true' : 'false');
    if (why) p.btn.setAttribute('aria-disabled', 'true'); else p.btn.removeAttribute('aria-disabled');
    p.el.classList.toggle('is-blocked', !!why);
    p.el.classList.toggle('is-on', p.on);
    var w = p.el.querySelector('[data-rd-line-why]'); w.textContent = why; w.hidden = !why;
    p.btn.setAttribute('aria-expanded', p.on ? 'true' : 'false');
    p.ed.setAttribute('aria-hidden', p.on ? 'false' : 'true');
    if (p.on) p.ed.removeAttribute('inert'); else p.ed.setAttribute('inert', '');
  }
  function setOn(p, on, quiet) {
    p.on = !!on;
    var at = picked.indexOf(p.id);
    if (p.on && at === -1) picked.push(p.id);
    if (!p.on && at !== -1) picked.splice(at, 1);
    if (!quiet) paintPiece(p);
    syncReplace();   // P34-12: the claim's replacement follows the pieces ticked
    /* the editor's clip opens once it has landed, so THE RISE list inside it is never cut (it hangs over what follows) */
    clearTimeout(p.settle); p.el.classList.remove('is-settled');
    if (p.on) { ensureProduct(p); renderEditor(p); p.settle = setTimeout(function () { if (p.on) p.el.classList.add('is-settled'); }, 340); }
  }
  function wirePiece(p) {
    p.btn.addEventListener('click', function () {
      if (p.btn.getAttribute('aria-disabled') === 'true') return;
      setOn(p, !p.on);
      if (linesErr) linesErr.textContent = '';
      persistSoon(); syncSubmitNote();
    });
    p.btn.addEventListener('keydown', function (e) {
      if (['ArrowUp', 'ArrowDown'].indexOf(e.key) === -1) return;
      var all = pieces.map(function (x) { return x.btn; }), at = all.indexOf(p.btn);
      var next = all[(at + (e.key === 'ArrowUp' ? -1 : 1) + all.length) % all.length];
      if (next) { e.preventDefault(); next.focus(); }
    });
    var opts = p.el.querySelector('[data-rd-ed-opts]');
    opts.addEventListener('change', function (e) {
      var b = e.target; if (!b || b.type !== 'radio' || b.disabled || !p.product) return;
      var name = b.getAttribute('data-opt'), v = b.value;
      p.sel[name] = v; p.msg = '';
      if (name === p.ci) colourPicked(p, v);
      autoReason(p);
      renderOpts(p); renderResult(p); renderReason(p); renderNote(p);
      persistSoon(); syncSubmitNote();
    });
    p.el.querySelector('[data-rd-ed-status]').addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-rd-ed-retry]')) return;
      p.loadFailed = false; ensureProduct(p, true); renderEditor(p);
    });
    Array.prototype.forEach.call(p.el.querySelectorAll('[data-rd-ed-step]'), function (b) {
      b.addEventListener('click', function () {
        p.qty = Math.max(1, Math.min(maxQty(p) || 1, p.qty + (Number(b.getAttribute('data-rd-ed-step')) || 0)));
        renderQty(p); renderResult(p); persistSoon(); syncSubmitNote();
      });
    });
    p.picker.addEventListener('svnty:picker:change', function (e) {
      p.reason = String((e.detail && e.detail.value) || ''); p.autoReason = false; p.autoFrom = '';
      var err = p.el.querySelector('[data-rd-ed-reason-err]'); if (err) err.textContent = '';
      p.picker.classList.remove('is-invalid');
      renderNote(p); persistSoon(); syncSubmitNote();
    });
    var note = p.el.querySelector('[data-rd-ed-note]');
    note.addEventListener('input', function () { p.note = String(note.value || '').slice(0, 200); persistSoon(); syncSubmitNote(); });
  }
  /* the product of a piece: the line's current version (an archived line names its successor, pickHandle), read live. P34-12: a faulty
     claim reads it too, for one fact: is her own size and color in stock for "Replace the same piece" (replaceOf); no swatches then */
  function ensureProduct(p, force) {
    var stockOnly = editorMode() === 'faulty';
    if (!(needsTarget(editorMode()) || stockOnly) || p.loading) return;
    if (stockOnly && (p.line.archived || !p.line.variantId)) return;   // no live variant of hers to read: the team checks the stock (replaceOf)
    // P28-3 (lane A's R2b): a loaded product still asks for its swatches again (a cached or in-flight handle returns at once; a failed one is re-read)
    if (p.product && !force) { if (!stockOnly) fetchColourHexes(String(p.line.pickHandle || p.line.handle || ''), function () { renderOpts(p); }); return; }
    var h = String(p.line.pickHandle || p.line.handle || ''); if (!h) return;
    p.loading = true; var seq = ++p.seq;
    if (!stockOnly) fetchColourHexes(h, function () { if (p.product) renderOpts(p); });
    fetchLiveProduct(h).then(function (pj) {
      if (seq !== p.seq) return;
      p.loading = false; p.loadFailed = false;
      p.product = { handle: pj.handle, title: pj.title, image: normImg(pj), options: normOptions(pj), variants: normVariants(pj) };
      setupProduct(p);
      if (stockOnly && needsTarget(editorMode())) fetchColourHexes(h, function () { if (p.product) renderOpts(p); });   // she moved to an exchange while it was read
      syncReplace(); renderEditor(p); syncSubmitNote();
      if (placeDue) { duePlace(); setTimeout(function () { duePlace(); endPlace(); }, 300); }
    }).catch(function () {
      if (seq !== p.seq) return;
      p.loading = false; p.loadFailed = true; syncReplace(); renderEditor(p); syncSubmitNote();
    });
  }
  /* THE REPLACEMENT NEEDS STOCK (P34-12, RTN-02's cousin): "Replace the same piece" sends her own size and color again, so it is offered only
     while that variant is in stock: the live product read, else the lane's own word at the lookup (availableNow, svnty-core's availableForSale),
     and the lane's refusal at Send (soldOut) above both. 'in' | 'out' | '' (not known: an archived piece, or a variant Shopify deleted, has no
     live variant of hers, so the team checks the stock, as svnty-core does, and the result line says so) */
  function replaceOf(p) {
    var vid = String(p.line.variantId || '');
    if (p.line.archived || !vid) return '';
    if (p.soldOut) return 'out';
    if (p.product) { var v = p.product.variants.filter(function (x) { return String(x.id) === vid; })[0]; return v && v.available ? 'in' : 'out'; }
    return p.line.availableNow === true ? 'in' : p.line.availableNow === false ? 'out' : '';
  }
  function titlesOf(ps) { return ps.map(function (p) { return String(p.line.productTitle || 'A piece'); }).filter(function (t, i, a) { return a.indexOf(t) === i; }).join(', '); }
  /* one resolution for the whole claim: a ticked piece whose own size and color is sold out closes the Replace card in words (the kind
     cards' grammar: dashed, the title muted, the reason in ink, never an opacity) and the full refund is chosen; the replacement comes back
     by itself only when the page chose the refund, never over her own choice */
  function syncReplace() {
    if (!replaceInput || !refundInput) return;
    var isFaulty = currentKind() === 'faulty', was = replaceInput.checked;
    var out = isFaulty ? onPieces().filter(function (p) { return replaceOf(p) === 'out'; }) : [];
    replaceInput.disabled = !isFaulty || out.length > 0;
    setCardWhy(replaceInput.closest('.svnty-rd__card'), !out.length ? '' : onPieces().length <= 1 ? 'Your size and color are sold out right now' : 'Sold out right now in your size and color: ' + titlesOf(out));
    if (out.length && replaceInput.checked) { refundInput.checked = true; replaceAuto = true; }
    else if (!out.length && isFaulty && replaceAuto && refundInput.checked) { replaceInput.checked = true; replaceAuto = false; }
    if (was !== replaceInput.checked) { onPieces().forEach(renderResult); syncSubmitNote(); persistSoon(); }
  }
  /* the words when the replacement sold out between the page's read and the filing */
  function soldSendWords(sold) {
    var who = onPieces().length <= 1 || !sold.length ? 'Your size and color' : titlesOf(sold) + ' in your size and color';
    return who + ' sold out before the claim was sent, so the claim is now for a full refund. Check it and send again.';
  }
  /* the options she has, as the product reads them now (the line's own variant first; a value renamed since the order falls back to the
     variant's own options) */
  function setupProduct(p) {
    var pr = p.product, ci = '', si = '';
    pr.options.forEach(function (o) { var n = String(o.name || '').toLowerCase(); if (!ci && /colou?r/.test(n)) ci = o.name; if (!si && /size/.test(n)) si = o.name; });
    p.ci = ci; p.si = si; p.have = {};
    var hv = pr.variants.filter(function (v) { return String(v.id) === String(p.line.variantId); })[0];
    if (hv) pr.options.forEach(function (o, i) { if (hv.options[i] != null) p.have[o.name] = String(hv.options[i]); });
    else {
      var parts = haveParts(p.line);
      pr.options.forEach(function (o) { parts.forEach(function (v) { if (o.values.indexOf(v) !== -1) p.have[o.name] = v; }); });
    }
    // a choice restored from the draft keeps only the values this product still has
    Object.keys(p.sel).forEach(function (k) { var o = pr.options.filter(function (x) { return x.name === k; })[0]; if (!o || o.values.indexOf(p.sel[k]) === -1) delete p.sel[k]; });
    seedSel(p);
  }
  /* what the editor starts from: the color she has stays chosen for an exchange and a size change; a color change starts open */
  function seedSel(p) {
    if (!p.product) return;
    var mode = editorMode();
    p.product.options.forEach(function (o) {
      if (o.name === p.si) return;
      if (o.name === p.ci && mode === 'color') return;
      if (!p.sel[o.name] && p.have[o.name]) p.sel[o.name] = p.have[o.name];
    });
    if (mode === 'size' && p.ci && p.have[p.ci]) p.sel[p.ci] = p.have[p.ci];   // a size change keeps her color
  }
  function variantsWith(p, sel) {
    var pr = p.product;
    return pr.variants.filter(function (v) { return pr.options.every(function (o, i) { return !sel[o.name] || String(v.options[i]) === sel[o.name]; }); });
  }
  /* the wanted options: what she chose, and what she has for every option she was never asked about */
  function effSel(p) {
    var s = {};
    p.product.options.forEach(function (o) { if (p.sel[o.name]) s[o.name] = p.sel[o.name]; else if (o.name !== p.si && o.name !== p.ci && p.have[o.name]) s[o.name] = p.have[o.name]; });
    return s;
  }
  function target(p) {
    if (!p.product || !needsTarget(editorMode())) return null;
    var s = effSel(p);
    if (!p.product.options.every(function (o) { return s[o.name]; })) return null;
    return variantsWith(p, s)[0] || null;
  }
  function inStock(p, sel) { return variantsWith(p, sel).some(function (v) { return v.available; }); }
  /* a color tapped: her size comes with it when that color has it in stock; otherwise the size is chosen again, and the page says why */
  function colourPicked(p, colour) {
    if (!p.si) return;
    var keep = p.sel[p.si] || (editorMode() === 'color' ? p.have[p.si] : '');
    if (!keep) return;
    var s = effSel(p); s[p.ci] = colour; s[p.si] = keep;
    if (inStock(p, s)) { p.sel[p.si] = keep; return; }
    delete p.sel[p.si];
    p.msg = colourName(p, colour) + ' has no ' + keep + ' in stock right now. Choose another size.';
  }
  function colourName(p, v) { var m = colourHexes[p.product.handle]; var hit = m && m[String(v).toLowerCase()]; return (hit && hit.name) || String(v); }
  function words(p, sel) {
    var out = [];
    p.product.options.forEach(function (o) { if (sel[o.name]) out.push(o.name === p.ci ? colourName(p, sel[o.name]) : sel[o.name]); });
    return out.join(' · ');
  }
  function haveWords(p) { return p.product && Object.keys(p.have).length ? words(p, p.have) : haveParts(p.line).join(' · '); }
  function deltaOf(p) {
    var fv = target(p), paid = p.line.unitPrice != null ? Number(p.line.unitPrice) : NaN;
    if (!fv || !isFinite(Number(fv.price)) || !isFinite(paid)) return null;
    return Math.round(Number(fv.price) / 100 - paid) * Math.max(1, p.qty);
  }
  function radio(p, o, v, opts) {
    var id = 'rd-o-' + pieceSeq + '-' + p.i + '-' + (o.name === p.ci ? 'c' : o.name === p.si ? 's' : 'x') + '-' + opts.n;
    return '<input type="radio" id="' + esc(id) + '" name="rd-o-' + pieceSeq + '-' + p.i + '-' + esc(o.name) + '" value="' + esc(v) + '" data-opt="' + esc(o.name) + '"' +
      (opts.on ? ' checked' : '') + (opts.out ? ' disabled class="visually-disabled"' : '') + '>';
  }
  /* P28-1 THE "YOURS" TAG (the owner, 2026-10-09, step 3 on his iPhone): the value she already has wears a small paper tag seated on its top
     edge, one grammar on the size chip and the color swatch (the words "You have Green" stay in the legend; the screen reader hears
     ", you have this"); the chosen target is the ink chip or the ringed swatch, never a tag: the two can never be confused. */
  function yours(mine) { return mine ? '<span class="svnty-rd__yours" aria-hidden="true">Yours</span>' : ''; }
  /* THE ROWS: the color (the house swatch, the card's own hex and mark) then the size (the house chip); hers marked "you have", a sold out
     value struck and never chosen; an option with one value is not asked */
  function renderOpts(p) {
    var box = p.el.querySelector('[data-rd-ed-opts]'), mode = editorMode();
    if (!p.product || !needsTarget(mode)) { box.textContent = ''; box.hidden = true; return; }
    var hexes = colourHexes[p.product.handle] || null, html = '';
    var show = function (o) { return o.values.length > 1 && (o.name === p.si || (o.name === p.ci && mode !== 'size')); };
    p.product.options.forEach(function (o) {
      if (!show(o)) return;
      var isC = o.name === p.ci;
      var haveV = p.have[o.name] || '';
      var head = '<legend class="svnty-rd__optgroup-name"><span>' + esc(isC ? 'Color' : o.name === p.si ? 'Size' : o.name) + '</span>' +
        (haveV ? '<span class="svnty-rd__optgroup-have">You have ' + esc(isC ? colourName(p, haveV) : haveV) + '</span>' : '') + '</legend>';
      var vals = o.values.map(function (v, n) {
        var s = effSel(p); s[o.name] = v;
        if (!isC && p.ci && !s[p.ci] && p.have[p.ci]) s[p.ci] = p.have[p.ci];
        if (isC) delete s[p.si];
        var out = !inStock(p, s) && !(isC && v === haveV);
        // P28-1: the value she has is hers in every color (the legend says "You have XXL" whatever color is open); the full-variant match is the result line's
        var mine = v === haveV;
        var on = p.sel[o.name] === v;
        var sr = (mine ? ', you have this' : '') + (out ? ', sold out' : '');
        var input = radio(p, o, v, { n: n, on: on, out: out });
        var hit = isC && hexes ? hexes[String(v).toLowerCase()] : null;
        if (hit) {
          return input + '<label for="' + esc(input.match(/id="([^"]+)"/)[1]) + '" class="svnty-bubble' + (mine ? ' is-have' : '') + '" title="' + esc(hit.name || v) + '" style="--sw: ' + esc(hit.hex) + '"><span class="svnty-bubble__fill" aria-hidden="true" data-sw="' + esc(String(v).toLowerCase()) + '"></span>' + yours(mine) + '<span class="visually-hidden">' + esc((hit.name || v) + sr) + '</span></label>';
        }
        return input + '<label for="' + esc(input.match(/id="([^"]+)"/)[1]) + '" class="svnty-size-chip' + (mine ? ' is-have' : '') + '"><span class="svnty-size-chip__value">' + esc(isC ? colourName(p, v) : v) + '</span>' + yours(mine) + (sr ? '<span class="visually-hidden">' + esc(sr) + '</span>' : '') + '</label>';
      }).join('');
      html += '<fieldset class="svnty-rd__optgroup product-form__input product-form__input--pill svnty-option svnty-option--pill' + (isC && hexes ? ' svnty-option--colour' : '') + '">' + head +
        '<div class="svnty-option__values' + (isC && hexes ? ' svnty-option__values--bubbles' : '') + '">' + vals + '</div></fieldset>';
    });
    if (!html && mode === 'color') html = '<p class="svnty-rd__hint">This piece comes in one color.</p>';
    if (!html && mode === 'size') html = '<p class="svnty-rd__hint">This piece comes in one size.</p>';
    box.innerHTML = html; box.hidden = !html;
    // the swatch's own drawn mark (two-tone, stripe), cloned from the card, never parsed from text
    if (hexes) Array.prototype.forEach.call(box.querySelectorAll('[data-sw]'), function (f) { var hit = hexes[f.getAttribute('data-sw')]; if (hit && hit.svg) f.appendChild(hit.svg.cloneNode(true)); });
  }
  function renderResult(p) {
    var r = p.el.querySelector('[data-rd-ed-result]'), mode = editorMode(), txt = '', bad = false;
    if (needsTarget(mode) && p.product) {
      var fv = target(p);
      if (p.msg) { txt = p.msg; bad = true; }
      else if (fv && String(fv.id) === String(p.line.variantId)) { txt = 'That is the ' + (mode === 'color' ? 'color' : mode === 'size' ? 'size' : 'size and color') + ' you have. Choose another.'; bad = true; }
      else if (fv && !fv.available) { txt = words(p, effSel(p)) + ' is sold out right now. Choose another.'; bad = true; }
      else if (fv) {
        var d = deltaOf(p);
        txt = haveWords(p) + ' → ' + words(p, effSel(p)) + (d == null ? '' : d > 0 ? ' · ' + money(d) + ' more' : d < 0 ? ' · ' + money(-d) + ' back to you' : ' · the same price');
      }
    }
    if (mode === 'faulty') {
      var res = $('[data-rd-resolution-choice]:checked');
      // P34-12: an archived piece's replacement is the team's check, and the words say so (never a promise on a stock nobody read)
      txt = res && res.value === 'Full refund' ? 'Refunded in full.' : 'Replaced with the same piece: ' + haveWords(p) + (replaceOf(p) === '' ? ', once our team confirms it is in stock.' : '.');
    }
    r.textContent = txt; r.hidden = !txt; r.classList.toggle('is-bad', bad);
  }
  function renderQty(p) {
    var row = p.el.querySelector('[data-rd-ed-qty-row]'), max = maxQty(p);
    p.qty = Math.max(1, Math.min(max || 1, p.qty || 1));
    row.hidden = !(max > 1);
    p.el.querySelector('[data-rd-ed-qty]').textContent = String(p.qty);
    Array.prototype.forEach.call(row.querySelectorAll('[data-rd-ed-step]'), function (b) { var s = Number(b.getAttribute('data-rd-ed-step')); b.disabled = s < 0 ? p.qty <= 1 : p.qty >= max; });
    var unsh = afterDelivery(currentKind()) && Number(p.line.unshipped) > 0 ? ' ' + p.line.unshipped + ' not shipped yet.' : '';
    p.el.querySelector('[data-rd-ed-qty-hint]').textContent = 'Up to ' + max + ' from this order line.' + unsh;
  }
  function renderNote(p) {
    var row = p.el.querySelector('[data-rd-ed-note-row]'), inp = p.el.querySelector('[data-rd-ed-note]');
    row.hidden = p.reason !== 'Other';
    if (inp.value !== p.note) inp.value = p.note;
  }
  /* P28-1: the target differs from hers in BOTH color and size */
  function bothChanged(p) {
    if (!p.product || !p.ci || !p.si || !needsTarget(editorMode())) return false;
    var s = effSel(p);
    return !!(s[p.ci] && s[p.si] && p.have[p.ci] && p.have[p.si] && s[p.ci] !== p.have[p.ci] && s[p.si] !== p.have[p.si]);
  }
  /* P28-1 THE AUTO-PICK: both changed -> "I ordered the wrong size and color" when she has named no reason yet, or named the wrong size or
     the wrong color alone (a refinement of her own words), or the page set it; when the target no longer differs in both, the page takes
     back only what it set, restoring the words she had. Her own choice in the list (the picker's change) is never overwritten. */
  function autoReason(p) {
    var key = reasonKey(), both = bothChanged(p);
    if (both && reasonAllowed(key, R_BOTH[1]) && (!p.reason || p.autoReason || p.reason === R_SIZE[1] || p.reason === R_COLOR[1])) {
      if (!p.autoReason) p.autoFrom = p.reason;
      p.reason = R_BOTH[1]; p.autoReason = true;
    } else if (!both && p.autoReason) { p.reason = p.autoFrom || ''; p.autoReason = false; p.autoFrom = ''; }
  }
  function renderReason(p) {
    var pk = p.picker.svntyPicker; if (!pk) return;
    var key = reasonKey();
    if (p.reasonKey !== key) { pk.setOptions(reasonOptions(key)); p.reasonKey = key; }
    if (p.reason && !reasonAllowed(key, p.reason)) p.reason = '';
    pk.setValue(p.reason);
  }
  function renderEditor(p) {
    var mode = editorMode(), st = p.el.querySelector('[data-rd-ed-status]');
    var msg = '';
    if (needsTarget(mode)) {
      if (p.loadFailed) msg = 'We could not load this piece’s sizes and colors. <button type="button" class="svnty-rd__link" data-rd-ed-retry>Try again</button>';
      else if (!p.product) msg = 'Loading the sizes and colors…';
      if (p.product) { seedSel(p); autoReason(p); }
    }
    st.innerHTML = msg; st.hidden = !msg;
    renderOpts(p); renderResult(p); renderQty(p); renderReason(p); renderNote(p);
  }
  function renderPieces() { pieces.forEach(function (p) { paintPiece(p); if (p.on) { ensureProduct(p); renderEditor(p); } }); }

  /* a piece's problem, by name (null = ready) */
  function pieceProblem(p) {
    var mode = editorMode(), t = String(p.line.productTitle || 'this piece');
    if (needsTarget(mode)) {
      var opts = p.el.querySelector('[data-rd-ed-opts]');
      if (p.loadFailed) return { el: p.el.querySelector('[data-rd-ed-retry]') || p.btn, msg: 'We could not load the sizes and colors of ' + t + '. Try again, or email ' + (root.getAttribute('data-support') || 'onlineshop@svntyeg.com') + ' with your order number.' };
      if (!p.product) return { el: p.btn, msg: 'The sizes and colors of ' + t + ' are still loading.' };
      var fv = target(p);
      var miss = p.ci && !effSel(p)[p.ci] ? 'color' : 'size';
      if (!fv) return { el: opts.querySelector('input:not(:disabled)') || p.btn, msg: 'Choose the ' + miss + ' you want for ' + t + '.' };
      if (String(fv.id) === String(p.line.variantId)) return { el: opts.querySelector('input:not(:disabled)') || p.btn, msg: 'For ' + t + ', choose a size or color you do not have.' };
      if (!fv.available) return { el: opts.querySelector('input:not(:disabled)') || p.btn, msg: 'That size of ' + t + ' is sold out. Choose another.' };
    }
    if (!p.reason) return { el: p.picker.querySelector('[data-picker-trigger]'), msg: 'Choose the reason for ' + t + '.', reason: true };
    return null;
  }
  /* the request's own problem, before any piece (null = the pieces decide) */
  function requestProblem() {
    var k = currentKind();
    if (k === 'cancel' && !editAction.value) return { el: $('[data-rd-change] input'), msg: 'Choose what should change.' };
    if (isCancelOrder(k)) {
      if (!cancelConfirm.checked) return { el: cancelConfirm, msg: 'Tick the box to cancel the whole order.' };
      if (!cancelReason()) return { el: cancelReasonRoot.querySelector('[data-picker-trigger]'), msg: 'Choose why you are canceling.', cancelReason: true };
      return null;
    }
    if (addressEdit()) return emailGate() ? { el: emailSwitch, msg: emailGateWords() } : null;   // P35-3 SEC-B-17
    if (piecesKind() && !onPieces().length) return { el: (pieces.filter(function (x) { return x.btn.getAttribute('aria-disabled') !== 'true'; })[0] || {}).btn, msg: 'Choose at least one piece.', lines: true };
    var pcs = onPieces();
    for (var i = 0; i < pcs.length; i++) { var pp = pieceProblem(pcs[i]); if (pp) { pp.piece = pcs[i]; return pp; } }
    return null;
  }
  function cancelReason() { var pk = cancelReasonRoot && cancelReasonRoot.svntyPicker; return pk ? String(pk.getValue() || '') : ''; }
  /* the posted reason: the first piece's, or the cancel's */
  function syncReasonField() {
    var k = currentKind(), v = '';
    if (isCancelOrder(k)) v = cancelReason();
    else if (addressEdit()) v = 'Address changed';
    else { var f = onPieces()[0]; v = f ? f.reason : ''; }
    reasonField.value = v;
  }
  /* a piece as the payload, the note and the review read it */
  function pieceOut(p) {
    var k = currentKind(), parts = haveParts(p.line), res = $('[data-rd-resolution-choice]:checked');
    var action = k === 'exchange' ? 'exchange' : k === 'refund' ? 'return' : k === 'faulty' ? (res && res.value === 'Full refund' ? 'refund' : 'replace') : 'change';
    var out = { lineId: p.id, variantId: String(p.line.variantId || ''), handle: String(p.line.handle || ''), title: String(p.line.productTitle || ''), haveParts: parts,
      have: parts.join(', '), quantity: Math.max(1, Math.min(maxQty(p) || 1, p.qty)), orderedQty: Number(p.line.quantity || 0), image: String(p.line.image || ''),
      action: action, reason: p.reason, reasonLabel: reasonLabelOf(p.reason), note: p.reason === 'Other' ? String(p.note || '').trim().slice(0, 200) : '', want: null };
    var fv = target(p);
    if (fv) { var d = deltaOf(p); out.want = { variantId: String(fv.id), handle: p.product.handle, title: p.product.title, label: words(p, effSel(p)).split(' · ').join(' / '),
      delta: d == null ? '' : String(d), avail: fv.available ? 'in stock' : 'sold out', mode: 'same piece, different option' }; }
    else if (action === 'replace') out.want = { variantId: out.variantId, handle: out.handle, title: out.title, label: parts.join(' / '), delta: '0', avail: replaceOf(p) === 'in' ? 'in stock' : 'not checked; replacement reviewed by team', mode: 'same piece, same option' };
    return out;
  }
  function allPieces() { return onPieces().map(pieceOut); }
  function pieceWords(p) {
    var t = p.title + ' · ' + (p.haveParts.join(' / ') || p.have) + ' · ×' + p.quantity;
    if (p.want && p.want.label && p.action !== 'replace') t += ' → ' + p.want.label;
    return t;
  }

  /* ---------- the kind decides the rest, in one pass ---------- */
  var LINES_WORDS = { exchange: 'Which pieces to exchange', refund: 'Which pieces to return', faulty: 'Which pieces are faulty, damaged or wrong', change: 'Which pieces to change' };
  function syncKind() {
    var k = currentKind(), isFaulty = k === 'faulty', isCancel = k === 'cancel';
    resolutionBox.hidden = !isFaulty;
    resolutionInputs.forEach(function (input) { input.disabled = !isFaulty; input.required = isFaulty; });
    syncReplace();
    if (changeRow) changeRow.hidden = !isCancel;
    if (!isCancel && editAction.value) { editAction.value = ''; $$('[data-rd-change] input').forEach(function (r) { r.checked = false; }); }
    var showLines = !!verified && piecesKind() && pieces.length > 0;
    linesRow.hidden = !showLines && !(verified && giftsBox && !giftsBox.hidden && afterDelivery(k));
    linesBox.hidden = !showLines;
    if (linesLabel) linesLabel.textContent = LINES_WORDS[isCancel ? 'change' : k] || 'Which pieces';
    if (addressLine) addressLine.hidden = !addressEdit();
    if (cancelBox) cancelBox.hidden = !isCancelOrder(k);
    if (cancelTitle && verified) cancelTitle.textContent = 'Yes, cancel the whole order ' + String(verified.order.name || '');
    if (cancelReasonRoot && cancelReasonRoot.svntyPicker && !cancelReasonRoot.svntyPicker.getOptions().length) cancelReasonRoot.svntyPicker.setOptions(reasonOptions('cancel'));
    photonote.hidden = !isFaulty;
    form.dataset.rdKind = k;
    syncPickup();
    renderPieces();
    syncSubmitNote();
  }
  /* one piece the request can name is ticked for her when she chooses a kind that names pieces (a tap takes it out) */
  function tickLone() {
    if (!verified || !piecesKind() || picked.length) return;
    var free = pieces.filter(function (p) { return !lineBlock(p); });
    if (free.length === 1) setOn(free[0], true);
  }
  $$('[data-rd-type] input').forEach(function (r) { r.addEventListener('change', function () { syncKind(); tickLone(); syncSubmitNote(); persistSoon(); }); });
  resolutionInputs.forEach(function (input) { input.addEventListener('change', function () { replaceAuto = false; renderPieces(); syncSubmitNote(); persistSoon(); }); });
  if (changeBox) changeBox.addEventListener('change', function (e) {
    var r = e.target; if (!r || r.type !== 'radio') return;
    editAction.value = r.value;
    // a size change keeps her color, a color change starts open: the seed follows the chip
    pieces.forEach(function (p) { if (p.product) { p.sel = {}; p.msg = ''; seedSel(p); } });
    syncKind(); tickLone(); syncSubmitNote(); persistSoon();
  });
  if (cancelConfirm) cancelConfirm.addEventListener('change', function () { var row = cancelConfirm.closest('.svnty-rd__toggle'); if (row) row.classList.remove('is-invalid'); persistSoon(); syncSubmitNote(); });
  if (cancelReasonRoot) cancelReasonRoot.addEventListener('svnty:picker:change', function () { if (cancelReasonErr) cancelReasonErr.textContent = ''; cancelReasonRoot.classList.remove('is-invalid'); persistSoon(); syncSubmitNote(); });
  (function () {
    var c = form.querySelector('[name="contact[Policy consent]"]');
    if (c) c.addEventListener('change', function () { var row = c.closest('.svnty-rd__consent'); if (row && c.checked) row.classList.remove('is-invalid'); if (c.checked && submitStatus && /return terms/.test(submitStatus.textContent)) submitError(''); });
  })();

  function val(name) { var el = form.querySelector('[name="contact[' + name + ']"]'); return el ? el.value : ''; }
  // Every typed or picked answer is persisted on one beat: one refresh, nothing lost.
  var persistTimer = null;
  function persist() { saveDraft(); saveCells(); }
  function persistSoon() { clearTimeout(persistTimer); persistTimer = setTimeout(persist, 250); }
  /* P20 THE CELLS (see THE MEMORY OF THE FORM at the head): written with the draft, read once at boot. `vc` names the contact
     the lane matched, so the request a refreshed page sends carries the contact that verified, not merely the first cell. */
  function saveCells() {
    if (DEMO) return;
    var old = sget(CELLS_KEY) || {};
    var c = { v: 1, t: Date.now(), order: val('Order').trim().slice(0, 24),   // P35-2 SEC-A-02: never the email, the phone or the pickup phone
      vc: verifiedContact ? (/@/.test(verifiedContact) ? 'email' : 'phone') : (verifiedBy || String(old.vc || '')), vb: verifiedBy };   // P35-3: words, never the contact
    if (!c.order) { sdel(CELLS_KEY); return; }
    sset(CELLS_KEY, c);
  }
  function restoreCells(linked) {
    var c = fresh(CELLS_KEY); if (!c) return;
    if ('email' in c || 'phone' in c || 'paPhone' in c) { delete c.email; delete c.phone; delete c.paPhone; sset(CELLS_KEY, c); }   // P35-2: a record written before the pass loses its contact
    [['Order', linked ? '' : c.order]].forEach(function (p) {
      var el = form.querySelector('[name="contact[' + p[0] + ']"]');
      if (el && p[1] && !el.value) el.value = String(p[1]);
    });
  }
  /* P20 THE PLACE: the step under the header and where its top stood, put back by duePlace() after a refresh. */
  var placeDue = false, placeHold = false, placeTouched = false, placeTick = false;
  function placeTarget(a) { return a === 'end' ? root : a === 'review' ? $('[data-rd-review]') : $('[data-rd-step="' + a + '"]'); }
  function savePlace() {
    if (DEMO || placeHold || !form.isConnected) return;
    var r = root.getBoundingClientRect(), vh = window.innerHeight || 0;
    if (r.top > vh) { sdel(PLACE_KEY); return; }
    var a = 'end', dy = r.bottom, edge = Math.max(160, Math.round(vh * 0.45));
    if (r.bottom > edge) {
      var list = [['1'], ['2'], ['3'], ['4']].concat(window.matchMedia && window.matchMedia('(min-width: 990px)').matches ? [] : [['review']]), best = null;
      list.forEach(function (it) { var el = placeTarget(it[0]); if (!el || !el.getClientRects().length) return; var t = el.getBoundingClientRect().top; if (t <= edge || !best) best = [it[0], t]; });
      if (best) { a = best[0]; dy = best[1]; }
    }
    sset(PLACE_KEY, { v: 1, t: Date.now(), a: a, dy: Math.round(dy), h: Math.round(r.height) });
  }
  function duePlace() {
    if (!placeDue || placeTouched) return;
    var p = fresh(PLACE_KEY); if (!p) return;
    var el = placeTarget(String(p.a)); if (!el || !el.getClientRects().length) return;
    var b = el.getBoundingClientRect(), d = Math.round((p.a === 'end' ? b.bottom : b.top) - Number(p.dy));
    if (Math.abs(d) > 2) { try { window.scrollBy({ top: d, left: 0, behavior: 'instant' }); } catch (e) { window.scrollBy(0, d); } }
  }
  function endPlace() { placeDue = false; placeHold = false; root.style.minHeight = ''; }
  window.addEventListener('scroll', function () { if (placeTick) return; placeTick = true; requestAnimationFrame(function () { placeTick = false; savePlace(); }); }, { passive: true });
  ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (n) { window.addEventListener(n, function () { if (placeDue || placeHold) { placeTouched = true; endPlace(); } }, { passive: true, capture: true }); });
  /* THE LAST KEYSTROKE: a refresh inside the draft's beat would lose it. Only while the order stands verified. */
  window.addEventListener('pagehide', function () { try { if (!form.isConnected) return; if (verified) saveDraft(); saveCells(); } catch (e) {} });
  form.addEventListener('input', persistSoon); form.addEventListener('change', persistSoon);

  /* ---------- THE REQUEST, READ BACK (the aside) ----------
     What will be sent, in the order the desk reads it: the order, the request, each piece with its change and its reason, where Bosta
     collects, and the money (the zone's fee from the page's one fee table, the price difference from what she paid). */
  var reviewList = $('[data-rd-review-list]');
  var KIND_WORDS = { exchange: 'Exchange', cancel: 'Change or cancel before it ships', refund: 'Return for a refund', faulty: 'Faulty, damaged or the wrong piece' };
  var CHANGE_WORDS = { 'Change size': 'change the size', 'Change color': 'change the color', 'Change address': 'change the delivery address', 'Cancel order': 'cancel the whole order' };
  function spans(arr) {
    return arr.filter(Boolean).map(function (x) { return typeof x === 'string' ? '<span>' + esc(x) + '</span>' : '<span class="' + x.c + '">' + esc(x.t) + '</span>'; }).join('');
  }
  /* P27-7 THE COURIER FEES, FROM ONE PLACE: the terms section prints one row per courier zone (data-rt-fee-row: the area, its
     governorates, the return fee, the exchange fee, the governorates Bosta does not collect from); the fee is the row that names the
     governorate Bosta collects from (the different address when she typed one, else the order's delivery address), by name or by the
     checkout's province code. No row: the words point at the table, never a guessed amount. */
  function feeKey(v) { return String(v || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/^\s*(al|el)\s+/, '').trim(); }
  function zoneFee() {
    var rows = document.querySelectorAll('[data-rt-fee-row]'); if (!rows.length) return null;
    var src = null;
    try { src = pickupEffective() === 'other' ? readOther() : checkoutAddr; } catch (e) { src = null; }
    if (!src) return null;
    var code = String(src.provinceCode || '').toUpperCase(), gname = '';
    GOVERNORATES.forEach(function (g) { if (code && String(g[1]).toUpperCase() === code) gname = String(g[0]); });
    var want = [feeKey(src.province), feeKey(gname), feeKey(src.city)].filter(Boolean);
    for (var w = 0; w < want.length; w++) {
      for (var i = 0; i < rows.length; i++) {
        var keys = String(rows[i].getAttribute('data-note') || '').split(',').map(feeKey);
        if (keys.indexOf(want[w]) > -1) {
          var ret = Number(rows[i].getAttribute('data-return')), ex = Number(rows[i].getAttribute('data-exchange'));
          var np = String(rows[i].getAttribute('data-no-pickup') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
          var hit = np.filter(function (x) { return feeKey(x) === want[w]; })[0] || '';
          return { area: rows[i].getAttribute('data-area') || '', ret: isFinite(ret) && ret > 0 ? ret : null, ex: isFinite(ex) && ex > 0 ? ex : null, noPickup: hit };
        }
      }
    }
    return null;
  }
  function noPickupWords(g) { return 'Bosta does not collect from ' + g + ' yet; write to us and we will arrange it.'; }
  function moneyWords(k, pcs) {
    var zf = (k === 'exchange' || k === 'refund') ? zoneFee() : null;
    var total = 0, known = 0;
    pcs.forEach(function (p) { if (p.want && p.want.delta !== '' && isFinite(Number(p.want.delta))) { total += Number(p.want.delta); known++; } });
    if (k === 'exchange') {
      var lines = [];
      if (zf && zf.noPickup) { lines.push({ t: noPickupWords(zf.noPickup), c: 'is-muted' }); if (known) lines.push(total > 0 ? 'Price difference: ' + money(total) + ' to pay' : total < 0 ? 'Price difference: ' + money(-total) + ' back to you' : 'No price difference'); return { dt: 'To pay', lines: lines }; }
      var fee = zf && zf.ex != null ? zf.ex : null;
      if (fee != null) lines.push('Exchange fee: ' + money(fee) + (zf.area ? ' (' + zf.area + ')' : ''));
      if (known) lines.push(total > 0 ? 'Price difference: ' + money(total) + ' to pay' : total < 0 ? 'Price difference: ' + money(-total) + ' back to you' : 'No price difference');
      if (fee != null && known) { var sum = total + fee; lines.push(sum > 0 ? 'To pay the courier: ' + money(sum) : sum < 0 ? 'Back to you: ' + money(-sum) : 'Nothing to pay'); }
      if (fee == null) lines.push({ t: 'Every exchange is paid: the exchange fee for your zone, in the fee table on this page, and any price difference, in cash to the courier in one visit.', c: 'is-muted' });
      else lines.push({ t: 'One visit: the courier brings the new piece and takes the one you have.', c: 'is-muted' });
      return { dt: 'To pay', lines: lines };
    }
    if (k === 'refund') {
      var pk = verified && verified.order && verified.order.payment ? String(verified.order.payment.kind || '') : '';
      /* P22 (I4, FAKE F4): a gift card, a mixed payment or a gateway the lane does not know never reads as the card she paid with */
      var route = pk === 'card' ? ' It goes back to the card you paid with.' : pk === 'cod' ? ' For a cash on delivery order, we agree the route with you by email when we approve the request.'
        : (pk === 'gift_card' || pk === 'mixed' || pk === 'unknown') ? ' We confirm the refund route by email.' : '';
      if (zf && zf.noPickup) return { dt: 'Refund', lines: [{ t: noPickupWords(zf.noPickup), c: 'is-muted' }, { t: 'Within 7 days of the piece reaching us.' + route, c: 'is-muted' }] };
      var courier = zf && zf.ret != null ? 'minus the return courier, ' + money(zf.ret) + (zf.area ? ' (' + zf.area + ')' : '') + '.' : 'minus the return courier, at the fee for your zone in the table on this page.';
      /* P18-3: an order that shipped free and no longer earns it gives the delivery back too (the rule is stated, never an amount guessed) */
      var feesBox = document.querySelector('[data-rt-fees]'), freeAt = feesBox ? String(feesBox.getAttribute('data-free') || '') : '';
      var freeLine = freeAt ? ' If the order shipped free and what you keep falls below ' + freeAt + ', the delivery we paid is deducted as well, at the delivery fee for your zone.' : '';
      return { dt: 'Refund', lines: [{ t: 'Within 7 days of the piece reaching us, ' + courier + freeLine + route, c: 'is-muted' }] };
    }
    if (k === 'faulty') return { dt: 'To pay', lines: ['Nothing: a faulty, damaged or wrong piece is collected at our cost.', { t: 'Settled within one week of your request, at no cost to you.', c: 'is-muted' }] };
    if (k === 'cancel' && known && total !== 0) return { dt: 'To pay', lines: [total > 0 ? 'Price difference: ' + money(total) + ' more, paid on delivery' : 'Price difference: ' + money(-total) + ' less'] };
    return null;
  }
  function renderReview() {
    if (!reviewList) return;
    var rows = [];
    function row(dt, dd, cls) { rows.push('<div class="svnty-rd__review-row' + (cls ? ' ' + cls : '') + '"><dt>' + esc(dt) + '</dt><dd>' + dd + '</dd></div>'); }
    if (!verified || !verified.order) {
      row('Order', spans([{ t: DESK ? 'Find your order to begin.' : 'Live checks are being switched on. Find prepares the email with your order number.', c: 'is-muted' }]));
      reviewList.innerHTML = rows.join(''); return;
    }
    var o = verified.order, k = currentKind();
    row('Order', spans([String(o.name || '') + (o.stage ? ' · ' + stageLabel(o) : '')]));
    var kindLine = KIND_WORDS[k] || '';
    if (k === 'faulty') { var r = $('[data-rd-resolution-choice]:checked'); if (r) kindLine += ': ' + (r.value === 'Full refund' ? 'a full refund' : 'a replacement'); }
    if (k === 'cancel' && CHANGE_WORDS[editAction.value]) kindLine += ': ' + CHANGE_WORDS[editAction.value];
    row('Request', spans([kindLine || { t: 'Choose what you need in step 2.', c: 'is-muted' }]));
    if (k === 'cancel' && !piecesKind()) {
      if (isCancelOrder(k)) { var cr = cancelReason(); row('Why', spans([cr ? reasonLabelOf(cr) : { t: 'Choose why in step 3.', c: 'is-muted' }])); }
      if (addressEdit()) { var ps0 = pickupSummary(); row('New address', spans([ps0 && ps0.where ? ps0.where : { t: 'Write it in step 4.', c: 'is-muted' }])); }
      reviewList.innerHTML = rows.join(''); return;
    }
    var pcs = allPieces();
    if (!k) { reviewList.innerHTML = rows.join(''); return; }
    var items = [];
    pcs.forEach(function (p) {
      items.push(pieceWords(p));
      var sub = [p.reason ? 'Reason: ' + p.reasonLabel : 'Reason: not chosen yet'];
      if (p.note) sub.push(p.note);
      if (p.want && p.want.delta !== '' && Number(p.want.delta)) sub.push(Number(p.want.delta) > 0 ? money(Number(p.want.delta)) + ' more' : money(-Number(p.want.delta)) + ' back to you');
      items.push({ t: sub.join(' · '), c: 'is-muted' });
    });
    row(pcs.length > 1 ? 'Pieces' : 'Piece', pcs.length ? spans(items) : spans([{ t: 'Choose the pieces in step 3.', c: 'is-muted' }]));
    var ps = pickupSummary();
    if (ps) row('Pickup', spans([ps.title, ps.where ? { t: ps.where, c: 'is-muted' } : null]));
    var m = moneyWords(k, pcs);
    if (m) row(m.dt, spans(m.lines), 'svnty-rd__review-row--money');
    reviewList.innerHTML = rows.join('');
  }

  /* ---------- THE HONEST STATE: the lane is off ----------
     Find cannot check anything, and the page never pretends it did: it says the checks are being switched on and hands her the
     email already written with her order number (her own mail app, her own words to fill in). */
  function dormantPrepare(order) {
    var support = root.getAttribute('data-support') || 'onlineshop@svntyeg.com';
    var no = String(order || '').replace(/^#/, '').trim();
    var em = String(val('email') || '').trim(), ph = String(val('Phone') || '').trim();
    var body = ['Order: #' + no, em ? 'Email: ' + em : null, ph ? 'Phone: ' + ph : null, '', 'What I need (an exchange, a refund, or a change before it ships):', '', '',
      'The piece, and the size and color I want instead:', '', '', 'Why:', ''].filter(function (l) { return l !== null; }).join('\n');
    var mail = 'mailto:' + support + '?subject=' + encodeURIComponent('Return or exchange, order #' + no) + '&body=' + encodeURIComponent(body);
    findStatus.classList.remove('is-bad');
    findStatus.textContent = 'Live order checks are being switched on, so your email is ready with the order number. ';
    /* P35-1 THE CLICK LEAK: the mail carries her order, email and phone, so it is a button (the same class and words), never an
       href a pixel's click event could record; the address is built here and handed to her mail app inside the tap */
    var a = document.createElement('button'); a.type = 'button'; a.className = 'svnty-rd__link'; a.setAttribute('data-rd-dormant-mail', ''); a.textContent = 'Open the email';
    a.addEventListener('click', function () { location.href = mail; });
    findStatus.appendChild(a);
    setFindState('dormant');
    if (dormantNotice) dormantNotice.hidden = false;
  }

  /* ---------- THE VERIFIED DESK (svnty-desk worker; contract 02_architecture/svnty-desk-worker-contract) ----------
     Nothing typed is trusted: order + phone/email are verified by the worker, which returns the pieces on the
     order (no PII). Steps 2-4 stay locked until then. HAVE is locked to the ordered variant; WANT comes from
     live stock. The typed picker is never offered as a fallback (a guess is a lie). */
  /* R3-38 (round 3): THE DORMANCY GATE. `DEMO` is 0 on a real visit, so the demo flag was never the
     fence it was described as: every load — demo or not — reached the live App Proxy and 404'd. The
     gate is the store setting, exactly as `assets/svnty-tracking.js:1306` does it. An empty DESK is
     already a first-class state in this file (`if (!DESK)` at the lookup, the session restore and the
     governorate read), so dormancy needs no new branch: it needs the url withheld. */
  /* THE LANE SWITCH (the rebuild): the section's own `desk_live` setting, never the tracking flag (tracking goes live a rung
     earlier; lighting it must not light a lane that does not answer yet). THE QA LANE: ?desk_api=<a local fixture server>, read
     on 127.0.0.1, localhost and in the theme editor only, and only when it names a local host: a crafted link on the live
     domain can never carry an order number and a contact to another host. */
  // QA_SURFACE, QA_API, DESK_LIVE and DESK are read at the head of the module (P22: THE FILED record asks the lane first)
  var dormantNotice = $('[data-rd-dormant]');
  if (dormantNotice && (DESK || DEMO)) dormantNotice.hidden = true;
  // P0-4: while the lane is off, a locked step says honestly when it opens (never "when your order is found": it cannot be)
  if (!DESK && !DEMO) $$('.svnty-rd__locked-line').forEach(function (p) { p.textContent = 'Opens once live order checks are on. Until then, Find prepares the email.'; });

  /* ---------- TURNSTILE (P1-5, contract 3.0) ----------
     The lane refuses /lookup and /intake/return without a fresh Turnstile token (SVNTY's own widget, Law 0). The site key is the
     section's setting (data-turnstile-sitekey); empty = no widget and no token (the lane decides). The widget runs managed and
     only shows itself when Cloudflare asks for an interaction; each token is used once. A 403 {error:"turnstile"} earns one
     silent retry with a fresh token, then words. The QA lane may name Cloudflare's public test key with ?desk_ts= (local only).
     The script is Cloudflare's own and loads only when a key is set.
     P17-1 (the audit's P2-9): a check that gave NO token is never sent twice (the lane refuses an empty token every time, so the
     second send only doubled her wait), and the wait for a token is the tracking page's 10 s, not 15: she hears the words in about
     10 s, under the same busy state. A real token refused keeps its one silent retry. */
  var TS_WAIT = 10000, TS_ASK_MAX = 120000;
  /* R392 THE PAGES WAIT FOR HER TICK (SVNTY_Design_Part31_CC2): Cloudflare is asking her (the widget's own
     before-interactive state) and the box is on screen (the seat has height), and no token has come: the page waits for her
     tick, up to two minutes, and never resets the box she is answering. No box (the invisible check, a seat with no height)
     keeps the old guards. */
  function tsAsking(el) { return !!el && el.classList.contains('is-asking') && el.offsetHeight > 0; }
  var TS_KEY = (function () {
    // the QA lane never talks to Cloudflare unless it asks for a key with ?desk_ts= (the guard's fixture takes no token)
    if (QA_API) { try { var q = new URLSearchParams(location.search).get('desk_ts') || ''; if (/^[\w-]{10,64}$/.test(q)) return q; } catch (e) {} return ''; }
    return (root.getAttribute('data-turnstile-sitekey') || '').trim();
  })();
  var tsWidget = null, tsLoading = null, tsWaiters = [];
  function tsLoad() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (tsLoading) return tsLoading;
    tsLoading = new Promise(function (resolve, reject) {
      var sc = document.createElement('script');
      sc.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      sc.async = true; sc.defer = true;
      sc.onload = function () { window.turnstile ? resolve(window.turnstile) : reject(new Error('ts_missing')); };
      sc.onerror = function () { tsLoading = null; reject(new Error('ts_load')); };
      document.head.appendChild(sc);
    });
    return tsLoading;
  }
  function tsSettle(token) { var w = tsWaiters; tsWaiters = []; w.forEach(function (fn) { fn(token || ''); }); }
  /* Resolves a fresh token, or '' when there is no key or the check could not run (the lane then answers 403 and the page says so). */
  function tsToken() {
    if (!TS_KEY) return Promise.resolve('');
    return tsLoad().then(function (ts) {
      return new Promise(function (resolve) {
        tsWaiters.push(resolve);
        var t0 = Date.now(), timer = setTimeout(function giveUp() {
          if (tsAsking($('[data-rd-ts]')) && Date.now() - t0 < TS_ASK_MAX) { status('Tick the box below to continue.'); timer = setTimeout(giveUp, 500); return; }   /* R392; P33 (P2-3): her own words while she is asked */
          tsSettle('');
        }, TS_WAIT);
        tsWaiters.push(function () { clearTimeout(timer); });
        var slot = $('[data-rd-ts]');
        if (!slot) { tsSettle(''); return; }
        slot.hidden = false;
        if (tsWidget == null) {
          tsWidget = ts.render(slot, { sitekey: TS_KEY, action: 'returns', appearance: 'interaction-only', execution: 'execute',
            callback: function (t) { tsSettle(t); }, 'error-callback': function () { tsSettle(''); }, 'expired-callback': function () {}, 'timeout-callback': function () { tsSettle(''); },
            'before-interactive-callback': function () { slot.classList.add('is-asking'); status('Tick the box below to continue.'); },
            'after-interactive-callback': function () { slot.classList.remove('is-asking'); status(''); } });   /* R392: the widget's own asking state; P33 (P2-3): the words follow it */
        } else { try { ts.reset(tsWidget); } catch (e) {} }
        try { ts.execute(slot); } catch (e) { tsSettle(''); }
      });
    }, function () { return ''; });
  }
  var findBtn = $('[data-rd-find]'), findLabel = $('[data-rd-find-label]'), findStatus = $('[data-rd-find-status]');
  var orderCard = $('[data-rd-order-card]');
  var nameField = form.querySelector('[data-rd-name]');   // hidden contact[name]: filled from the desk's greeting, never typed
  var lookupSeq = 0;
  function setLocked(on) {
    // THE FADED CARD LAW (owner 2026-08-30): a locked step shows no choice — a check under a fade reads as editable. The draft memory
    // still holds the kind; restoreChoices() puts it back the moment the order is verified again.
    if (on) $$('[data-rd-type] input').forEach(function (r) { r.checked = false; });
    $$('[data-rd-lockable]').forEach(function (fs) {
      fs.classList.toggle('is-locked', on); fs.disabled = on;
      fs.setAttribute('aria-disabled', on ? 'true' : 'false');
      if (on) fs.setAttribute('inert', ''); else fs.removeAttribute('inert');
    });
    var sb = $('[data-rd-submit]'); if (sb) sb.disabled = on;
    syncSubmitNote();
  }
  /* A disabled button must say why, in the same place, every time. */
  function syncSubmitNote() {
    var note = $('[data-rd-submit-note]'); if (!note) return;
    var text = '', k = currentKind();
    syncReasonField();
    if (!verified) text = DESK ? 'Find your order to send a request.' : 'Live order checks are being switched on: Find prepares the email.';
    else if (!k) text = $$('[data-rd-type] input').some(function (r) { return !r.disabled; }) ? 'Choose what you need in step 2.' : 'Nothing can be requested for this order right now. Write to us if something is wrong.';
    else { var pr = requestProblem(); text = pr ? pr.msg : ''; }
    note.textContent = text; note.hidden = !text;
    renderReview();
  }
  /* THE STATE OF STEP 1, in one attribute: idle · finding · found · restored · notfound · invalid · unreachable · expired.
     The copy lives with the caller; this is what CSS and the harness read. */
  function setFindState(state) { root.setAttribute('data-rd-find-state', state); }
  function status(msg, bad) { findStatus.textContent = msg || ''; findStatus.classList.toggle('is-bad', !!bad); }
  /* A failure AFTER the send is pressed belongs beside the button, not four steps up in the order status line.
     It is assertive (the customer is waiting on it) and takes focus, so a screen reader lands on the reason. */
  var submitStatus = $('[data-rd-submit-error]');
  function submitError(msg, focusIt) {
    if (!submitStatus) { if (msg) status(msg, true); return; }
    submitStatus.classList.remove('is-calm');   // every new message starts plain; submitFailure calms the ones that are calm
    submitStatus.textContent = msg || '';
    submitStatus.hidden = !msg;
    if (msg && focusIt) { try { submitStatus.focus({ preventScroll: true }); } catch (e) { submitStatus.focus(); } }
  }
  document.addEventListener('svnty:xs-storage-failed', function () {
    status('Your browser did not save this request draft or exchange choice. Continue on this page or try again in a normal tab.', true);
  });
  /* The order may hold either contact. We send the likelier one first, then the other on a 404 — a customer who
     typed both should never be told "no match" because the store has the email and we offered the phone. */
  /* P1-3 (the research lane): Arabic-Indic and Persian digits read as Latin in every cell the lookup reads (the order number,
     the phone), exactly as the pickup cells already do; JavaScript's \d is ASCII only, so a phone typed on an Arabic keypad
     used to fold to nothing and count as absent. The worker folds again: a browser is never trusted. */
  function foldDigits(v) {
    return String(v == null ? '' : v).replace(/[\u0660-\u0669]/g, function (d) { return String(d.charCodeAt(0) - 0x0660); })
      .replace(/[\u06F0-\u06F9]/g, function (d) { return String(d.charCodeAt(0) - 0x06F0); });
  }
  /* P17-1 (the audit's P2-4): THE ORDER NUMBER, JUDGED BEFORE IT LEAVES. An optional leading "#" and spaces (every width, and the
     invisible direction marks an Arabic keypad adds) fall away; what is left must be 3 to 10 digits, svnty-core's own lookup test.
     The old fold swallowed a "#" anywhere and sent whatever was left ("SV12" left the page and came back a 400 read as an outage). */
  var ORDER_SPACE = /[\s\u061C\u200B-\u200F\u202A-\u202E\u2066-\u2069]/g;
  function orderNumber() { return foldDigits(val('Order')).replace(ORDER_SPACE, '').replace(/^[#\uFF03]/, ''); }
  function orderValid(v) { return /^\d{3,10}$/.test(v); }
  // a phone is 9 to 15 digits once folded (svnty-core contact.js, the lane's own rule); an email is judged by the lane, as before
  function phoneValid(v) { var n = foldDigits(v).replace(/\D/g, '').length; return n >= 9 && n <= 15; }
  function contactValues() {
    var ph = foldDigits(val('Phone')).trim(), em = val('email').trim();
    var list = phoneValid(ph) && !(preferEmail && em) ? [ph, em] : [em, ph];   // P35-3: "verify with the email on your order" asks with the email first
    return list.filter(function (v, i) { return v && list.indexOf(v) === i; });
  }
  function contactValue() { return contactValues()[0] || ''; }
  /* P35-3 THE NEVER-LOSE RESTORE: the contact a request carries. A session restored by its token sends none (core 0.8.2 reads the
     order's own contact from the token); a lookup sends the one the lane matched; a 0.8.1 restore sends the one asked for again */
  function proofContact() {
    if (tokenProof) return '';
    if (verifiedContact) return verifiedContact;
    if (askContact === 'email') return val('email').trim();
    if (askContact === 'phone') return foldDigits(val('Phone')).trim();
    return contactValue();
  }
  /* the email cell is required only when no valid phone is typed and nothing else proves the session (P22 I1; P35-3) */
  function contactRequired() { return !tokenProof && !askContact && !phoneValid(val('Phone')); }
  /* P35-3 (core 0.8.1, no mask): the ask, once, by name; '' when what she typed or the token already answers it */
  function askWords() {
    if (!askContact || proofContact()) return '';
    return 'Type the ' + (askContact === 'email' ? 'email' : askContact === 'phone' ? 'phone' : 'phone or the email') + ' on the order once more to send. Your request is as you left it.';
  }
  /* P35-3: what /order answered after a refresh (body) and the cells' words (rc) become the session's proof. With core's mask the
     token alone proves it; without one (0.8.1) the cell the browser kept answers, else she is asked for that contact once */
  function restoredProof(body, rc) {
    body = body || {}; rc = rc || {};
    verifiedBy = body.verifiedBy === 'email' || body.verifiedBy === 'phone' ? body.verifiedBy : rc.vb === 'email' || rc.vb === 'phone' ? rc.vb : '';
    contactMasked = typeof body.contactMasked === 'string' ? body.contactMasked.slice(0, 80) : '';
    tokenProof = !!contactMasked; askContact = ''; useAnother = false;
    if (tokenProof) { verifiedContact = ''; return; }
    var kind = rc.vc === 'email' || rc.vc === 'phone' ? rc.vc : '';
    var ph = foldDigits(val('Phone')).trim(), em = val('email').trim();
    var kept = kind === 'phone' ? (phoneValid(ph) ? ph : '') : kind === 'email' ? (/@/.test(em) ? em : '') : '';
    if (kept) { verifiedContact = kept; return; }
    verifiedContact = ''; askContact = kind || 'either';
  }
  function lookupFingerprint() { return JSON.stringify({ order: orderNumber(), contact: contactValue() }); }
  function requestId() {
    var bytes = new Uint8Array(12);
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') window.crypto.getRandomValues(bytes);
    else for (var i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
    return 'rd_' + Array.prototype.map.call(bytes, function (byte) { var hex = byte.toString(16); return hex.length === 1 ? '0' + hex : hex; }).join('');
  }
  function fmtDate(iso) { try { var d = new Date(iso); return isFinite(d.getTime()) ? d.toLocaleDateString('en-US', { timeZone: 'Africa/Cairo', month: 'short', day: 'numeric', year: 'numeric' }) : ''; } catch (e) { return ''; } }   // THE US ENGLISH LAW, on Cairo's calendar (the desk counts Cairo days; P1-9): Sep 21, 2026
  // P22 (I2): a parcel no courier leg shows is "Shipped" (Shopify's word), never "With Bosta"; the courier down (stage UNKNOWN) is
  // "Not known yet", never the raw word and never "Being prepared"
  function stageLabel(o) { if (o && o.window && o.window.state === 'UNVERIFIABLE' && o.stage === 'SHIPPED') return 'Shipped'; if (o && o.stage === 'UNKNOWN') return 'Not known yet'; return { PREPARING: 'Being prepared', SHIPPED: 'With Bosta', DELIVERED: 'Delivered', RETURNING: 'On its way back', RETURNED: 'Back at SVNTY', LOST: 'Lost or damaged', CANCELLED: 'Canceled' }[o.stage] || o.stage; }
  /* THE 14-DAY CHECKER on the page: the worker computes the window from Bosta's delivery truth; the desk only renders
     it and gates the request kinds. Never computed here, never from the order date. */
  // The reason a request is closed is TEXT in the card, not a CSS content:attr() that no screen reader promises to read.
  function setCardWhy(card, text) {
    var slot = card && card.querySelector('[data-rd-card-why]'); if (!slot) return;
    slot.textContent = text || ''; slot.hidden = !text;
  }
  /* THE ONE VERDICT (stage hole, order #1005, 2026-08-29): the cards were cut from the window and the submit
     guard re-derived its own, laxer rule — a SHIPPED order showed "After delivery" on a greyed Exchange card
     and still sent as an exchange. There is now ONE function that decides what an order allows; the cards
     read it, and so does requestAllowed(). A card the customer cannot press is a request the desk refuses,
     in the same words. Pure: it renders nothing and touches no DOM. */
  /* P22 (I6): THE CAIRO DAYS of P17-1 left the page with its own count of the faulty 30 days: the lane sends faultyUntil, the one clock. */
  function windowVerdict(o) {
    var w = (o && o.window) || { state: 'UNKNOWN', open: false }; var msg = '';
    var kinds = { exchange: true, refund: true, cancel: false, faulty: true };
    var why = { cancel: 'Only before Bosta collects the parcel' };   // every closed card says why, in words
    /* P1-11 (the research lane): a faulty claim is about a piece she HAS (or one Bosta lost or damaged on the way), so it opens
       only on DELIVERED_OPEN, DELIVERED_CLOSED, LOST and DAMAGED; a parcel still being prepared, on the road, on its way back or
       already back offers no claim. P0-3: the law covers a faulty piece for 30 days from delivery, at no cost to her; past that
       the card says so and the email stays open. The server holds the same floor. */
    /* P22 (I6, GUESS G6): THE ONE CLOCK. The lane sends faultyUntil (23:59:59.999 Cairo on the 30th calendar day after the delivery)
       and the card reads it, never a count of its own; the lane judges again at Send. No faultyUntil: the card stays as the window says. */
    function faultyExpired() {
      var until = o && o.faultyUntil ? Date.parse(o.faultyUntil) : NaN;
      return isFinite(until) && until < Date.now();
    }
    /* THE COUNTED DAYS (QA P2-C): the lane counts Cairo calendar days, 14 on the delivery day and 0 on the last day, so the words
       agree with the 14-day policy: "last day today", "until tomorrow", "N days left". */
    var left = isFinite(Number(w.daysLeft)) ? Math.max(0, Math.round(Number(w.daysLeft))) : null;
    var leftWords = left === null ? '' : left === 0 ? 'Today is the last day' : left === 1 ? '1 day left, until tomorrow' : left + ' days left';
    /* P22 (I2, the lead's ruling 2026-10-02): THE COURIER DOWN IS READ FIRST. While the courier cannot be read nothing is asserted,
       not even "not picked up yet" (core answers stage and window UNKNOWN and canEditBeforePickup false for it): every card closed,
       the pre-ship change included, and she tries again */
    if (o && o.courierDown) { msg = 'We could not reach the courier just now. Try again in a few minutes.'; kinds.exchange = false; kinds.refund = false; kinds.cancel = false; kinds.faulty = false; why.exchange = why.refund = why.cancel = why.faulty = 'Courier not answering'; }
    else if (w.state === 'DELIVERED_OPEN') {
      msg = w.extended
        ? 'SVNTY extended your exchange and return window for this order until ' + fmtDate(w.closesAt) + '. ' + (leftWords || 'It is open') + '. A good gesture from us for the trouble with your delivery.'   /* THE EXCEPTION (Part25) */
        : (left === 0 ? 'Today is the last day of your exchange and return window (delivered ' + fmtDate(w.deliveredAt) + ').'
          : 'Exchange and return window open: ' + (leftWords || 'open') + ' (until ' + fmtDate(w.closesAt) + ', from delivery on ' + fmtDate(w.deliveredAt) + ').');
      // an "open" window the desk marks closed is a closed window, on the card as in the guard
      if (w.open !== true) { kinds.exchange = false; kinds.refund = false; why.exchange = why.refund = 'Window closed'; }
    }
    else if (w.state === 'DELIVERED_CLOSED') {
      var expired = faultyExpired();
      msg = 'The 14-day exchange and return window closed on ' + fmtDate(w.closesAt) + ' (delivered ' + fmtDate(w.deliveredAt) + '). '
        + (expired ? 'It is more than 30 days since delivery; if something is wrong with the piece, write to us.' : 'A faulty, damaged or wrong piece is still covered, at no cost to you, until 30 days from delivery.');
      kinds.exchange = false; kinds.refund = false; why.exchange = why.refund = 'Window closed';
      if (expired) { kinds.faulty = false; why.faulty = 'More than 30 days since delivery'; }
    }
    else if (w.state === 'PREPARING') { msg = 'Not picked up by Bosta yet: you can still change or cancel this order. Exchanges and returns open once it is delivered.'; kinds.cancel = !!(o && o.canEditBeforePickup); kinds.exchange = false; kinds.refund = false; kinds.faulty = false; why.exchange = why.refund = why.faulty = 'After delivery'; if (!kinds.cancel) why.cancel = 'Already with Bosta'; }
    else if (w.state === 'IN_TRANSIT') { msg = 'On its way with Bosta. Exchanges, returns and faulty pieces open the day it is delivered. To correct the address, the size or the color before it arrives, write to onlineshop@svntyeg.com within seven working days of your order confirmation.'; kinds.exchange = false; kinds.refund = false; kinds.faulty = false; why.exchange = why.refund = why.faulty = 'After delivery'; }
    else if (w.state === 'RETURNED') { msg = 'This parcel came back to SVNTY (refused or returned). Nothing to exchange from it; write to us if that was a mistake.'; kinds.exchange = false; kinds.refund = false; kinds.faulty = false; why.exchange = why.refund = why.faulty = 'Parcel returned'; }
    /* R-P1-D: her own return lost on its way to SVNTY is not hers to report: the refund or the exchange follows */
    else if (w.state === 'RETURN_LOST') { msg = 'Bosta reports the return you sent back as lost on its way to SVNTY. Nothing is needed from you: we settle the refund or the exchange and email you.'; kinds.exchange = false; kinds.refund = false; kinds.faulty = false; why.exchange = why.refund = why.faulty = 'Return lost by the courier'; }
    else if (w.state === 'RETURNING') { msg = 'This parcel is on its way back to SVNTY. Write to us if you still want the piece.'; kinds.exchange = false; kinds.refund = false; kinds.faulty = false; why.exchange = why.refund = why.faulty = 'Parcel returning'; }
    else if ((w.state === 'LOST' || w.state === 'DAMAGED')) {
      var refunded = !!(o && o.payment && o.payment.refunded), noPiece = !(o && o.lines && o.lines.length);
      kinds.exchange = false; kinds.refund = false; kinds.cancel = false; why.exchange = why.refund = 'Parcel lost';
      /* R-P1-D: a lost parcel on a canceled and refunded order, or one with no piece left to name, offers no claim: the words say what stands */
      if (o && o.stage === 'CANCELLED' && refunded) { msg = 'Bosta reported this parcel lost. We canceled the order and refunded anything you paid; write to us if the money has not reached you.'; kinds.faulty = false; why.faulty = 'Order canceled and refunded'; }
      else if (noPiece) { msg = 'Bosta reported this parcel lost or damaged. No piece is left to name on this order, so write to us with your order number and we make it right after a review.'; kinds.faulty = false; why.faulty = 'Write to us'; }
      else msg = 'Bosta reported this parcel lost or damaged. Choose the faulty-piece request below; the resolution is confirmed after review.';
    }
    else if (w.state === 'CANCELLED') { msg = 'This order was canceled.'; kinds.exchange = false; kinds.refund = false; kinds.faulty = false; why.exchange = why.refund = why.faulty = why.cancel = 'Order canceled'; }
    /* P22 (I2, DEFECTS P1-2, FAKE F2): the two states that were one. The courier not answering (courierDown) is "just now": every card
       closed, she tries again. UNVERIFIABLE (shipped, the courier answered, and no delivery can be seen) is never "just now": every card
       closed, the order is checked by hand. A state this page does not know reads as UNVERIFIABLE, never as an open door. (The courier
       down is read first, above every state: the lead's ruling of 2026-10-02, core answers UNKNOWN for it whatever Shopify says.) */
    else { msg = 'We cannot confirm the delivery of this order here. Write to ' + (root.getAttribute('data-support') || 'onlineshop@svntyeg.com') + ' with your order number and we check it by hand.'; kinds.exchange = false; kinds.refund = false; kinds.cancel = false; kinds.faulty = false; why.exchange = why.refund = why.cancel = why.faulty = 'Delivery not confirmed'; }
    /* P22-3 (core 0.6.0, DEFECTS P3-6): a return pickup Bosta lost no longer closes the order's window (core keeps it and sends
       order.returnLost); the page's own words for it lead the window line, the cards stay the window's */
    /* P34-12 (RTN-03's cousin 2): once the status view lists that return settled or closed (lostSettled), the promise is kept: the line goes */
    if (o && o.returnLost && w.state !== 'RETURN_LOST' && !lostSettled) msg = 'Bosta reports the return you sent back as lost on its way to SVNTY. Nothing is needed from you: we settle the refund or the exchange and email you.' + (msg ? ' ' + msg : '');
    /* R-P1-C: an exchange or a return pickup already moving at Bosta is a request in flight: never offered again on this order */
    var ar = o && o.activeReturn;
    if (ar && (ar.kind === 'EXCHANGE' || ar.kind === 'CRP')) {
      msg = (ar.kind === 'EXCHANGE' ? 'An exchange is already on its way for this order' : 'Your return pickup is already with Bosta') + (ar.awb ? ' (Bosta ' + ar.awb + ')' : '') + '. ' + (msg ? 'Follow it on the tracking page. ' : '') + 'Write to us for anything else on this order.';
      // P22 (I3, FAKE F5): the faulty card too: the lane refuses every kind while a request is in flight at Bosta
      kinds.exchange = false; kinds.refund = false; kinds.cancel = false; kinds.faulty = false;
      why.exchange = why.refund = why.cancel = why.faulty = ar.kind === 'EXCHANGE' ? 'An exchange is already moving' : 'A return pickup is already moving';
    }
    /* R94 / RT-4 (2026-09-19): THE OUTLET RULE stood here — a line whose `world` was 'outlet' had exchange
       AND refund force-closed with "Outlet pieces are final sale". The parent store has an Outlet world; SVNTY does not,
       so the rule could only ever shut a door that should be open, and it was dormant purely because the desk
       that returns `world` is unbuilt: it would have gone LIVE with rung 5. Deleted, not switched off — the
       delivery window is the whole verdict now. */
    return { w: w, kinds: kinds, why: why, msg: msg };
  }
  function renderWindow(o) {
    var verdict = windowVerdict(o), w = verdict.w, kinds = verdict.kinds, why = verdict.why, msg = verdict.msg;
    var el = $('[data-rd-window]');
    el.textContent = msg; el.hidden = !msg; el.classList.toggle('is-closed', w.state === 'DELIVERED_CLOSED' || w.state === 'RETURNED' || w.state === 'CANCELLED');
    /* P27-7 (the audit of states): a window that allows no exchange and no return ends on the way to the answers, the help center's
       returns topics (one quiet link, added after the words, never in place of them) */
    if (msg && !(o && o.courierDown) && kinds.exchange === false && kinds.refund === false) {
      var help = document.createElement('a'); help.className = 'svnty-rd__link svnty-rd__window-help'; help.href = '/pages/help-centre#returns'; help.textContent = 'Returns help';
      el.appendChild(document.createTextNode(' ')); el.appendChild(help);
    }
    $$('[data-rd-type] input').forEach(function (r) {
      var k = r.getAttribute('data-rd-kind'), on = kinds[k] !== false, card = r.closest('.svnty-rd__card');
      r.disabled = !on; card.classList.toggle('is-unavailable', !on);
      setCardWhy(card, on ? '' : (why[k] || 'Not available for this order'));
    });
    enforceEnabledKind();
  }
  /* A DISABLED CARD CAN NEVER BE THE CURRENT REQUEST. The default is Exchange, and on order #1005 it stayed
     checked underneath a greyed card. The check moves to the first kind still open, and the change event
     re-cuts everything downstream of the kind: the WANT block, the faulty resolution, the pickup cells, the
     summary note. Called from every path that can close a card. */
  /* P1-11 (the research lane): the old rule moved the check to the FIRST open card in DOM order, so an in-transit parcel landed
     on a pre-checked faulty claim. Now a closed card is unchecked; the exchange (the page's default) is chosen when it is open, a
     lone open door that is not a claim is chosen for her, and otherwise nothing is chosen and the submit note says what to do. */
  function enforceEnabledKind() {
    var checked = $('[data-rd-type] input:checked');
    if (checked && !checked.disabled) { syncSubmitNote(); return; }
    if (checked) checked.checked = false;
    var open = $$('[data-rd-type] input').filter(function (r) { return !r.disabled; });
    var ex = open.filter(function (r) { return r.getAttribute('data-rd-kind') === 'exchange'; })[0];
    // the page's own default is the exchange; a lone open door is chosen for her unless it is a claim (a faulty piece is hers to say)
    var pick = ex || (open.length === 1 && open[0].getAttribute('data-rd-kind') !== 'faulty' ? open[0] : null);
    if (!pick) { syncKind(); syncSubmitNote(); return; }
    pick.checked = true;
    pick.dispatchEvent(new Event('change', { bubbles: true }));
  }
  /* R94 / RT-4: this used to close exchange and refund on an 'outlet' line — a second copy of THE OUTLET
     RULE. SVNTY has one world; the delivery window is the only per-line policy there is. */
  function applySelectedLinePolicy() {
    renderWindow(verified.order);
  }
  function renderOrder(o) {
    $('[data-rd-order-name]').textContent = 'Order ' + o.name;
    $('[data-rd-order-stage]').textContent = stageLabel(o);
    var n = o.lines.length, units = o.lines.reduce(function (a, l) { return a + Math.max(1, Math.floor(Number(l.quantity) || 1)); }, 0);
    $('[data-rd-order-meta]').textContent = 'Placed ' + fmtDate(o.placedAt) + ' \u00b7 ' + (n === 0 ? 'no piece to request' : units + (units === 1 ? ' piece' : ' pieces')) + (o.canEditBeforePickup ? ' \u00b7 not picked up yet, so changes and cancellation are still possible' : o.awbs.length ? ' \u00b7 Bosta ' + o.awbs.map(function (a) { return a.number; }).join(', ') : '');
    orderCard.hidden = false;
    lostSettled = false;   // P34-12: a found order starts from the lane's own word; the status view may settle it
    loadRequests();   // D12-3 THE STATUS VIEW: the order's requests, under the card, when there are any
    fields.awb.value = o.awbs.map(function (a) { return a.number; }).join(',');
    buildPieces();
    renderWindow(o);
    // one piece the request can name: it is ticked for her (a tap takes it out)
    var free = pieces.filter(function (p) { return !lineBlock(p); });
    if (free.length === 1 && piecesKind() && !picked.length) { setOn(free[0], true); }
    syncKind();
  }
  function resetVerified() {
    lookupSeq += 1; verified = null;
    clearSession();
    orderCard.hidden = true; linesRow.hidden = true; linesBox.textContent = ''; pieces = []; picked = [];
    if (giftsBox) { giftsBox.textContent = ''; giftsBox.hidden = true; }
    ['verified', 'request_id', 'line_id', 'have_id', 'awb', 'world', 'ordered_qty', 'want_id', 'want_avail', 'want_handle', 'want_world', 'want_delta', 'xs', 'exchange_mode', 'lane', 'desk_return', 'pieces'].forEach(function (name) { if (fields[name]) fields[name].value = ''; });
    deskLane = ''; deskReturnName = ''; sessionVerifiedAt = 0;
    verifiedBy = ''; contactMasked = ''; tokenProof = false; askContact = ''; useAnother = false; syncVerifiedWith();   // P35-3
    if (nameField) nameField.value = '';
    submitError('');
    if (cancelConfirm) cancelConfirm.checked = false;
    if (cancelReasonRoot && cancelReasonRoot.svntyPicker) cancelReasonRoot.svntyPicker.setValue('');
    // A different order is a different address and a different set of pieces: both go with it.
    resetPickup();
    var s1 = $('[data-rd-step="1"]'); if (s1) s1.classList.remove('is-done');
    setLocked(true); status(''); setFindState('idle');
  }

  /* ---------- THE SESSION: the verified order survives a refresh, a back/forward and the shop-back trip ---------- */
  var sessionVerifiedAt = 0, restoreInFlight = false;
  function clearSession() { try { sessionStorage.removeItem(SESSION_KEY); } catch (e) {} }
  /* THE SESSION v2 (F17, 2026-08-29): Web Storage holds a RESTORE HANDLE, never the customer — the desk token (the
     2-hour proof), the order NUMBER, the request id and the clock. No snapshot, no name, no address, no email, no phone:
     every restore re-reads the order from the desk with the token and rebuilds the page in memory only. */
  function saveSession() {
    if (!verified || !verified.token) return;
    sset(SESSION_KEY, {
      v: 2, token: verified.token,
      orderName: String((verified.order && verified.order.name) || val('Order') || '').replace(/^#/, '').trim(),
      verifiedAt: sessionVerifiedAt || Date.now(),
      requestId: fields.request_id.value || ''
    });
  }
  function readSession() {
    var s = sget(SESSION_KEY);
    if (!s || s.v !== 2 || typeof s.token !== 'string' || !s.token) { if (s) clearSession(); return null; }   // a v1 blob (pre-F17) is dropped, never read
    if (!s.orderName) { clearSession(); return null; }
    var at = Number(s.verifiedAt);
    if (!isFinite(at) || at > Date.now() + 60000 || Date.now() - at > SESSION_TTL_MS) { clearSession(); return null; }
    return s;
  }
  function setContactField(name, value) {
    var el = form.querySelector('[name="contact[' + name + ']"]');
    if (el && value) el.value = value;
  }
  /* THE GREETING LINE and the unlock, from a snapshot the desk has just re-confirmed. Used by both doors:
     the customer pressing Find, and the page coming back to itself after a refresh. */
  function applyVerified(payload, restored) {
    verified = payload;
    fields.verified.value = 'desk-v1';
    if (!fields.request_id.value) fields.request_id.value = requestId();
    var o = payload.order;
    $('[data-rd-order]').value = String(o.name || '').replace(/^#/, '');
    // THE GREETING: the desk returns a first name (or ""); it names the order back to the customer and
    // travels on as the display name of the support mail, since the name is no longer typed.
    var greeting = String(o.greeting || '').trim();
    if (nameField) nameField.value = greeting;
    // WHERE BOSTA COLLECTS: the checkout address the lane returns with the verified order, shown as it came, set BEFORE the
    // order renders (the kind's change reads it). A second "Check again" re-shows it and never touches a typed address.
    applyCheckoutAddress(o.delivery);
    renderOrder(o); setLocked(false);
    // the status says what she can do: a found order that allows nothing right now never reads "filled in below"
    var anyOpen = windowVerdict(o).kinds; anyOpen = Object.keys(anyOpen).some(function (k) { return anyOpen[k] !== false; });
    var tail = !anyOpen ? 'Nothing can be requested for it right now; the note below says why.' : o.lines.length === 0 ? 'No piece is left to request on it; write to us if something is wrong.' : o.lines.length === 1 ? 'Your piece is ticked below.' : 'Tick the pieces below.';
    status(restored
      ? 'Order ' + o.name + (greeting ? ' for ' + greeting : '') + ' is still verified. ' + tail
      : 'Found it. Order ' + o.name + (greeting ? ' for ' + greeting : '') + '. ' + tail);
    setFindState(restored ? 'restored' : 'found');
    var s1 = $('[data-rd-step="1"]'); if (s1) s1.classList.add('is-done');
    if (dormantNotice) dormantNotice.hidden = true;
    findLabel.textContent = 'Check again';
  }
  /* A refresh, a back/forward, or the return from the store. The token is re-read against the desk before a single
     step unlocks — a stored session is a shortcut through the typing, never through the verification. */
  /* THE WALL on the two verification calls (Part30). Every other desk call already had one (GOV_TIMEOUT,
     INTAKE_TIMEOUT, NOTE_TIMEOUT); /lookup and the restore /order did not, so a request that never answered left
     "Checking" on a disabled button with no way back. 12 s - the same wall fileIntake keeps - and the abort lands
     in each call's own catch, which already says the retry words and gives the button back. Declared HERE, above
     both users, never borrowed from the constant further down the file (law 239: a `var` below is hoisted but
     still undefined when the code above runs). */
  var LOOKUP_TIMEOUT = 12000;
  /* THE WALL is the house's one now (assets/svnty-wall.js, loaded first from snippets/svnty-head.liquid): four
     files had grown their own copy of these eight lines and ten more had none. Same signature, same contract -
     write the signal onto `opts`, return the clear. It is a function DECLARATION, so it is hoisted whole and
     fetchLiveProduct far above may call it (law 239 is about `var`, not about this). The `||` arm is the honest
     degrade if the shared asset ever fails to load: no wall, exactly the old behaviour, never a TypeError. */
  function withWall(opts, ms) { return window.svntyWall ? window.svntyWall(opts, ms || LOOKUP_TIMEOUT) : function () {}; }
  function restoreVerified() {
    if (verified || restoreInFlight) return false;
    var s = readSession(); if (!s) return false;
    if (!DESK) { clearSession(); return false; }
    var typedOrder = val('Order').trim().replace(/^#/, '');
    // If the browser restored different typing, what is on screen wins and the stale session goes quietly.
    if (typedOrder && typedOrder !== s.orderName) { clearSession(); return false; }
    setContactField('Order', s.orderName);   // the contact cells stay as the browser left them — the email/phone are never written down (F17)
    if (s.requestId) fields.request_id.value = s.requestId;
    var seq = ++lookupSeq;
    restoreInFlight = true;
    findBtn.disabled = true; findLabel.textContent = 'Checking'; setFindState('finding'); status('Checking your order again…');
    var restoreOpts = {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      cache: 'no-store', body: JSON.stringify({ token: s.token })
    };
    var restoreDone = withWall(restoreOpts, LOOKUP_TIMEOUT);
    fetch(DESK.replace(/\/$/, '') + '/order', restoreOpts).then(function (r) {
      restoreDone();
      return r.text().then(function (text) {
        var body = null; try { body = JSON.parse(text); } catch (e) {}
        return { ok: r.ok, status: r.status, body: body || {} };
      });
    }).then(function (res) {
      if (seq !== lookupSeq) return;
      if (res.ok && res.body.order && Array.isArray(res.body.order.lines)) {
        sessionVerifiedAt = Number(s.verifiedAt);
        // P35-3 THE NEVER-LOSE RESTORE: the token proves the session (core's verifiedBy and contactMasked); nothing she typed is asked again
        restoredProof(res.body, fresh(CELLS_KEY));
        applyVerified({ token: s.token, order: res.body.order }, true);
        syncVerifiedWith();
        saveSession(); saveCells();
        restoreChoices();
        // P20: the words are true after a refresh (they said "Pick the piece below" over a piece already picked); P35-3: a 0.8.1 core asks once
        var og = String(res.body.order.greeting || '').trim(), ask = askWords();
        if (picked.length || ask) status('Order ' + res.body.order.name + (og ? ' for ' + og : '') + ' is still verified. ' + (ask || 'Your request is as you left it.'));
        duePlace(); setTimeout(duePlace, 400); setTimeout(endPlace, picked.length ? 6000 : 800);   // a chosen piece's options may land late: pick() puts her back once more and ends it
      } else if (res.status === 401 || res.status === 404) {
        endPlace();
        clearSession(); setFindState('expired');
        status('Your verification expired. Find the order again.', true);
      } else {
        setFindState('unreachable');
        status('We could not re-check the order. Try again.', true);
      }
    }).catch(function () {
      restoreDone();                                   // an abort lands here too: the wall's own road out
      if (seq !== lookupSeq) return;
      setFindState('unreachable');
      status('We could not re-check the order. Try again.', true);
    }).then(function () {
      restoreInFlight = false;
      if (seq === lookupSeq) { findBtn.disabled = false; findLabel.textContent = verified ? 'Check again' : 'Find my order'; }
    });
    return true;
  }
  /* The choices, in the order they depend on each other: the line, then the request kind, then everything the
     kind decides, then the WANT chips once the product's own options arrive. Nothing is ever auto-sent. */
  function restoreChoices() {
    var d = sget(DRAFT_KEY); if (!d || !verified) { syncSubmitNote(); return; }
    if (d.__order && d.__order !== String(verified.order.name || '').replace(/^#/, '')) { syncSubmitNote(); return; }
    var wantedKind = d['contact[Request]'];
    if (wantedKind) {
      var radio = $$('[data-rd-type] input').filter(function (r) { return r.value === wantedKind; })[0];
      if (radio && !radio.disabled && !radio.checked) radio.checked = true;
    }
    restoreDraft();
    // the change chip before it ships
    if (currentKind() === 'cancel' && editAction.value) { var chip = $$('[data-rd-change] input').filter(function (r) { return r.value === editAction.value; })[0]; if (chip) chip.checked = true; }
    else if (currentKind() !== 'cancel') editAction.value = '';
    // the cancel's confirm and its reason
    var cx = null; try { cx = JSON.parse(d.__cancel || 'null'); } catch (e) { cx = null; }
    if (cx && typeof cx === 'object') {
      if (cancelConfirm) cancelConfirm.checked = cx.c === 1;
      if (cancelReasonRoot && cancelReasonRoot.svntyPicker) { if (!cancelReasonRoot.svntyPicker.getOptions().length) cancelReasonRoot.svntyPicker.setOptions(reasonOptions('cancel')); cancelReasonRoot.svntyPicker.setValue(String(cx.r || '')); }
    }
    // every piece as she left it: the ticks in her order, each piece's quantity, wanted options, reason and note
    var px = null; try { px = JSON.parse(d.__pieces || 'null'); } catch (e) { px = null; }
    if (px && typeof px === 'object') {
      var st = px.s && typeof px.s === 'object' ? px.s : {};
      pieces.forEach(function (p) {
        var q = st[p.id]; if (!q || typeof q !== 'object') return;
        p.qty = Math.max(1, Math.floor(Number(q.qty) || 1));
        p.sel = {}; if (q.sel && typeof q.sel === 'object') Object.keys(q.sel).forEach(function (k) { if (typeof q.sel[k] === 'string') p.sel[k] = q.sel[k]; });
        p.reason = typeof q.reason === 'string' ? q.reason : ''; p.note = typeof q.note === 'string' ? q.note.slice(0, 200) : '';
      });
      var keep = (Array.isArray(px.picked) ? px.picked : []).map(function (id) { return pieceOf(String(id)); }).filter(function (p) { return p && !lineBlock(p); });
      if (keep.length) {   // her own ticks win over the one the page ticked for her; a draft with none leaves that one as it is
        pieces.forEach(function (p) { if (p.on) setOn(p, false); });
        keep.forEach(function (p) { setOn(p, true); });
      } else pieces.forEach(function (p) { if (p.on) renderEditor(p); });
    }
    syncKind();
  }
  /* THE STANDING ORDER (Part25): once an order is verified on this page, a later lookup that fails for the SAME order changes nothing —
     the card, the steps and the status keep the found state. Only a different order number (the change handler) or an expired token clears it. */
  function standsVerified(orderNo) { return !!(verified && verified.order && String(verified.order.name || '').replace(/^#/, '') === String(orderNo || '').replace(/^#/, '')); }
  function restateVerified() { var o = verified.order, g = String(o.greeting || '').trim(); status('Order ' + o.name + (g ? ' for ' + g : '') + ' is still verified. ' + (o.lines.length === 1 ? 'Your piece is ticked below.' : 'Tick the pieces below.')); setFindState('found'); setLocked(false); }
  /* P17-1 (the audit's P2-4): THE CELLS' OWN WORDS, in the tracking page's grammar: the words under the cell that is wrong, the
     cell marked invalid, focus on it, nothing sent. The section prints no slot for the find row, so each is made here once, at
     boot and empty (an empty .svnty-rd__err takes no room): no press ever meets a DOM write before its click (THE iOS TAP LAW). */
  var findCells = {};
  ['Order', 'email', 'Phone'].forEach(function (n) {
    var cell = form.querySelector('[name="contact[' + n + ']"]'); if (!cell || !cell.id) return;
    var err = document.createElement('p');
    err.className = 'svnty-rd__err'; err.id = cell.id + '-err';
    err.setAttribute('role', 'alert');   // P17-18 (the perf audit's P2-11): the words are announced; empty at boot, so nothing is read until one is written
    (cell.closest('.svnty-rd__row') || cell.parentNode).appendChild(err);
    cell.setAttribute('aria-describedby', ((cell.getAttribute('aria-describedby') || '') + ' ' + err.id).trim());
    findCells[n] = { cell: cell, err: err };
  });
  var FIND_WORDS = {
    order: 'Order numbers are 3 to 10 digits, as in your confirmation email.',
    phone: 'A phone number has 9 to 15 digits. Check it, or leave it empty.',
    email: 'That does not look like an email address. Use the one from your order.'
  };
  function findCellError(n, msg) {
    var f = findCells[n];
    status(''); setFindState('invalid');
    if (!f) { status(msg, true); return; }
    f.err.textContent = msg; f.cell.setAttribute('aria-invalid', 'true');
    try { f.cell.focus({ preventScroll: false }); } catch (e) { f.cell.focus(); }
  }
  function clearFindCell(n) { var f = findCells[n]; if (f && f.cell.getAttribute('aria-invalid') === 'true') { f.err.textContent = ''; f.cell.removeAttribute('aria-invalid'); } }
  /* P17-1 (the audit's P2-3): THE LOCK'S WORDS follow the lane's own seconds (retry_after in the body, or the Retry-After header,
     whichever is longer: a cap only ever shortens it). A contact locked for the day (core's 20 misses) hears "tomorrow", never
     "about an hour" hour after hour; a lock of up to an hour keeps the tracking page's words; a short burst keeps the page's own. */
  function retryAfterOf(r) { try { return parseInt(r.headers.get('retry-after'), 10) || 0; } catch (e) { return 0; } }
  function lockWords(res) {
    var secs = Math.max(Number(res.body && res.body.retry_after) || 0, Number(res.retryAfter) || 0);
    if (secs > 3600) return 'Too many tries right now. Try again tomorrow. Other phones and emails are not affected.';
    if (secs >= 90) return 'Too many tries right now. Try again in about ' + (secs >= 3300 ? 'an hour' : Math.ceil(secs / 60) + ' minutes') + '. Other phones and emails are not affected.';
    return 'Too many tries right now. Wait, then try again.';
  }
  function lookup() {
    // P17-1 (P2-2): a demo view looks nothing up; its order is already filled in below
    if (DEMO) { status('This is the demo view. Nothing is looked up from here.'); return; }
    var order = orderNumber(), contacts = contactValues(), phone = val('Phone').trim();
    ['Order', 'email', 'Phone'].forEach(clearFindCell);
    // P17-1 (P2-4): judged before anything leaves; each refusal is its cell's own words
    if (!order) { findCellError('Order', 'Enter your order number first.'); return; }
    if (!orderValid(order)) { findCellError('Order', FIND_WORDS.order); return; }
    if (phone && !phoneValid(phone)) { findCellError('Phone', FIND_WORDS.phone); return; }
    if (!contacts.length) { if (standsVerified(order)) { restateVerified(); return; } status('Add the phone or the email you used on the order.', true); return; }   // P35-3: a restored session is never told to add what the token proves
    if (!DESK) { dormantPrepare(order); return; }
    var seq = ++lookupSeq, fingerprint = lookupFingerprint();
    findBtn.disabled = true; setFindState('finding'); status('');   /* P33 (site audit P2-3): no "Checking" before a token exists; the words come after tsToken() */
    /* P0-5: the old local QA door (/qa/order with a header key) is retired from the page; QA runs through the fixture lane
       (?desk_api=, local only), so no route of that shape ever needs to exist behind the App Proxy. */
    var hdrs = { 'Content-Type': 'application/json', Accept: 'application/json' };
    function ask(contact, retried) {
      var tokened = false;
      return tsToken().then(function (tok) {
        findLabel.textContent = 'Checking'; status('Checking with the store…');   /* P33 (P2-3): the store is asked only now */
        // one wall per attempt: the quiet second try (the order filed under the other contact) gets its own 12 s
        var b = { order: order, contact: contact }; if (tok) b.turnstile = tok;
        tokened = !!tok;
        var opts = { method: 'POST', headers: hdrs, cache: 'no-store', credentials: 'same-origin', body: JSON.stringify(b) };
        var doneWall = withWall(opts, LOOKUP_TIMEOUT);
        return fetch(DESK.replace(/\/$/, '') + '/lookup', opts)
          // a lane that is not there answers an HTML page, not JSON: the body is read as text so a 404 stays a 404
          .then(function (r) { doneWall(); return r.text().then(function (text) { var j = null; try { j = JSON.parse(text); } catch (e) {} return { ok: r.ok, status: r.status, body: j || {}, contact: contact, retryAfter: retryAfterOf(r) }; }); },
                function (err) { doneWall(); throw err; });   // the abort reaches lookup()'s catch: "The store is not answering. Try again..."
      }).then(function (res) {
        // one silent re-challenge on a refused token (contract 3.0), then words; P17-1 (P2-9): a check that gave no token is not sent again
        if (res.status === 403 && res.body.error === 'turnstile' && !retried && tokened) return ask(contact, true);
        return res;
      });
    }
    ask(contacts[0] || '')
      .then(function (res) {
        // the order may be filed under the other contact: one quiet retry before we say "no match"
        if (res.status === 404 && contacts.length > 1 && seq === lookupSeq) return ask(contacts[1]);
        return res;
      })
      .then(function (res) {
        if (seq !== lookupSeq || fingerprint !== lookupFingerprint()) return;
        if (res.ok && res.body && res.body.order && typeof res.body.token === 'string' && Array.isArray(res.body.order.lines)) {
          sessionVerifiedAt = Date.now();
          verifiedContact = String(res.contact || '');
          // P35-3 (svnty-core 0.8.2 SEC-B-17): the channel this session was proven with; the typed contact is the proof, so no mask is shown
          verifiedBy = res.body.verifiedBy === 'email' || res.body.verifiedBy === 'phone' ? res.body.verifiedBy : '';
          contactMasked = ''; tokenProof = false; askContact = ''; useAnother = false; preferEmail = false;
          fields.request_id.value = requestId();
          applyVerified(res.body, false);
          syncVerifiedWith();
          saveSession(); saveCells();
          // THE CORRECTED CELL (Part30): an interactive lookup re-renders the order and re-prefills the pickup
          // cells from the desk. Her own draft - the corrected address, the chosen kind, the piece, the want -
          // is put back on top, so retyping one digit of the order number never silently undoes her edits.
          // Only her OWN order's draft: a draft carrying another order's line and address is left where it is
          // (an empty __order is a draft made before any verification, so it belongs to this one).
          var od = sget(DRAFT_KEY);
          if (od && (!od.__order || od.__order === String(res.body.order.name || '').replace(/^#/, ''))) restoreChoices();
          var firstRequest = $('[data-rd-type] input:not(:disabled)');
          if (firstRequest) { try { firstRequest.focus({ preventScroll: true }); } catch (e) { firstRequest.focus(); } }
          try { $('[data-rd-step="2"]').scrollIntoView({ block: 'start', behavior: MOTION }); } catch (e) {}
        } else if (standsVerified(order)) { restateVerified(); }   // THE STANDING ORDER: a late failure never talks over a verification that already holds
        else if (res.status === 404) { setFindState('notfound'); status('We could not match that order number with that phone or email. Check both against your confirmation email.', true); }
        // P17-1 (P2-4): the lane names the cell it refused (core's 400 {error:'bad_request', field}), never the outage words
        else if (res.status === 400 && res.body.error === 'bad_request' && (res.body.field === 'order' || res.body.field === 'contact')) {
          if (res.body.field === 'order') findCellError('Order', FIND_WORDS.order);
          else if (/@/.test(res.contact)) findCellError('email', FIND_WORDS.email);
          else findCellError('Phone', FIND_WORDS.phone);
        }
        else if (res.status === 429) { setFindState('unreachable'); status(lockWords(res), true); }
        else if (res.status === 403 && res.body.error === 'turnstile') { setFindState('unreachable'); status('The security check did not pass. Try again, or email ' + (root.getAttribute('data-support') || 'onlineshop@svntyeg.com') + ' with your order number.', true); }
        else { setFindState('unreachable'); status('The store is not answering. Try again, or email ' + (root.getAttribute('data-support') || 'onlineshop@svntyeg.com') + ' with your order number.', true); }
      })
      .catch(function () { if (seq !== lookupSeq) return; if (standsVerified(order)) { restateVerified(); return; } setFindState('unreachable'); status('The store is not answering. Try again, or email ' + (root.getAttribute('data-support') || 'onlineshop@svntyeg.com') + ' with your order number.', true); })
      .then(function () { if (seq === lookupSeq) { findBtn.disabled = false; findLabel.textContent = verified ? 'Check again' : 'Find my order'; } });
  }
  findBtn.addEventListener('click', lookup);
  // "Look up another" is the one deliberate start-over: the session, the draft and every choice go with it.
  $('[data-rd-order-change]').addEventListener('click', function () {
    clearDraft(); resetVerified();
    ['Order', 'Phone'].forEach(function (n) { var el = form.querySelector('[name="contact[' + n + ']"]'); if (el) el.value = ''; });
    verifiedContact = ''; preferEmail = false; sdel(CELLS_KEY); sdel(PLACE_KEY); saveCells();   // P20: the start-over takes the cells' memory with it (the email she keeps stays)
    $('[data-rd-order]').focus();
  });
  ['Order', 'Phone', 'email'].forEach(function (n) { var el = form.querySelector('[name="contact[' + n + ']"]'); if (el) el.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); lookup(); } }); });
  // a changed order/contact after verification invalidates it (the mail must never carry a stale name)
  ['Order', 'Phone', 'email'].forEach(function (n) {
    var el = form.querySelector('[name="contact[' + n + ']"]');
    if (el) el.addEventListener('input', function () {
      clearFindCell(n);   // P17-1 (P2-4): her typing answers the cell's words, as the pickup cells do
      /* P35-3: a refreshed phone session's reply email and the contact asked once more (core 0.8.1) belong to the session that holds;
         anything else typed here is a new verification */
      if (verified && ((n === 'email' && tokenProof && !useAnother && verifiedBy === 'phone') || (askContact && n !== 'Order'))) {
        if (submitStatus && !submitStatus.hidden) submitError('');
        if (askContact && !askWords()) { var vo = verified.order, vg = String(vo.greeting || '').trim(); status('Order ' + vo.name + (vg ? ' for ' + vg : '') + ' is still verified. Your request is as you left it.'); }
        return;
      }
      if (verified) { resetVerified(); return; }
      lookupSeq += 1;
      findBtn.disabled = false; findLabel.textContent = 'Find my order'; status('');
    });
  });
  setLocked(true);

  /* ---------- P35-3 THE VERIFIED CONTACT, SHOWN NOT KEPT ----------
     After a refresh the session holds by its token: the cells step aside for one read-only line, "Verified with •••• 678" (core's own
     mask), and "Use another contact" opens them again (typing there is a new verification). A phone session keeps the email cell
     open: it is where the desk replies when the order has no email (P22 I1). */
  var verifiedRow = $('[data-rd-verified-row]'), verifiedWith = $('[data-rd-verified-with]'), useAnotherBtn = $('[data-rd-use-another]');
  function contactRow(n) { var el = form.querySelector('[name="contact[' + n + ']"]'); return el && el.closest ? el.closest('.svnty-rd__row') : null; }
  function syncVerifiedWith() {
    var show = !!(verified && tokenProof && contactMasked && !useAnother);
    if (verifiedRow) verifiedRow.hidden = !show;
    if (verifiedWith) verifiedWith.value = show ? contactMasked : '';
    var er = contactRow('email'), pr = contactRow('Phone');
    if (er) er.hidden = show && verifiedBy !== 'phone';
    if (pr) pr.hidden = show;
  }
  function openContactCells(cell) {
    useAnother = true; syncVerifiedWith();
    var el = form.querySelector('[name="contact[' + cell + ']"]'); if (!el) return;
    try { el.focus({ preventScroll: false }); } catch (e) { el.focus(); }
  }
  if (useAnotherBtn) useAnotherBtn.addEventListener('click', function () { openContactCells('email'); });

  /* ---------- WHERE BOSTA COLLECTS (R214, the rebuild) ----------
     The checkout address is what Bosta delivered to, so it is the default and nothing about it is asked: the card shows it
     exactly as the lane returned it (order.delivery) and it leaves the page untouched with pickup.mode "delivery"; the lane
     reads the order's own shipping address again and uses that, never this copy. Under it, ONE control, "Collect from a
     different address", opens the checkout's grammar (Egypt locked, first name, last name, address, apartment, city,
     governorate, postal code, phone). That address is judged here by the desk's own rules (the desk judges it again: a browser
     is never trusted) and leaves as typed: the whitespace folded, the phone read as an Egyptian mobile, Arabic digits in the
     postal code and the phone read as Latin, every word kept exactly as typed, Arabic included (pickup.mode "other" plus
     pickup_address in the desk's shape). Hidden and disabled while off, so a half-typed form can never block or leak into a
     kept delivery address. An order the lane returns without an address has only the one road: the form is open and required.
     The governorates are the checkout's own list, printed by the section (no lane route is needed for them), in THE RISE.
     Nothing here is stored but through the draft, and never the phone. */
  var pickupRow = $('[data-rd-address-row]');
  var checkoutCard = $('[data-rd-checkout-card]'), checkoutLines = $('[data-rd-checkout-lines]'), checkoutTitle = $('[data-rd-checkout-title]');
  var checkoutBadge = $('[data-rd-checkout-badge]'), checkoutHint = $('[data-rd-checkout-hint]');
  var otherToggle = $('[data-rd-other-toggle]'), otherBox = $('[data-rd-other]');
  var pickupLabel = $('#rd-pickup-label'), otherRowEl = $('[data-rd-other-row]');
  var govRoot = $('[data-rd-gov-picker]');
  var govPicker = function () { return govRoot && govRoot.svntyPicker ? govRoot.svntyPicker : null; };
  var govTrigger = govRoot ? govRoot.querySelector('[data-picker-trigger]') : null;
  var paCell = {}; $$('[data-rd-pa]').forEach(function (el) { paCell[el.getAttribute('data-rd-pa')] = el; });
  var paErr = {}; $$('[data-rd-pa-err]').forEach(function (el) { paErr[el.getAttribute('data-rd-pa-err')] = el; });
  var PA_KEYS = ['firstName', 'lastName', 'address1', 'address2', 'city', 'province', 'zip', 'phone'];
  var PA_TEXT = ['firstName', 'lastName', 'address1', 'address2', 'city', 'zip', 'phone'];
  var PA_LIMITS = { firstName: 50, lastName: 50, address1: 120, address2: 120, city: 60 };
  var PA_WORDS = {
    firstName: 'Enter a first name.', lastName: 'Enter a last name.', address1: 'Enter the street and the building.',
    address1Short: 'Write the street and the building in full, at least 6 characters.', city: 'Enter a city.',
    province: 'Choose a governorate.', zip: 'A postal code has 5 digits.',
    phone: 'Enter an Egyptian mobile: 11 digits starting 010, 011, 012 or 015.'
  };
  var GOVERNORATES = (function () {
    try { var el = $('[data-rd-govs]'); var l = el ? JSON.parse(el.textContent) : []; return Array.isArray(l) ? l.filter(function (g) { return Array.isArray(g) && g[0] && g[1]; }) : []; }
    catch (e) { return []; }
  })();
  var checkoutAddr = null, otherOn = false;

  function paDigits(v) {
    return String(v == null ? '' : v).replace(/[٠-٩]/g, function (d) { return String(d.charCodeAt(0) - 0x0660); })
      .replace(/[۰-۹]/g, function (d) { return String(d.charCodeAt(0) - 0x06F0); });
  }
  function paClean(v) { return String(v == null ? '' : v).replace(/\s+/g, ' ').trim(); }
  /* Egyptian mobiles, written the way people write them: spaces, dashes, +20, 0020, Arabic digits (the desk reads them the same way). */
  function egMobile(v) {
    var d = paDigits(v).replace(/\D+/g, '');
    if (d.indexOf('0020') === 0) d = d.slice(4); else if (d.indexOf('20') === 0 && d.length === 12) d = d.slice(2);
    if (d.length === 10 && d.charAt(0) === '1') d = '0' + d;
    return /^01[0125]\d{8}$/.test(d) ? d : '';
  }
  function normalizePhone(value) { return egMobile(value) || paDigits(value).replace(/\D/g, ''); }
  function pickupActive() { var k = currentKind(); return (k !== 'cancel' && k !== '') || addressEdit(); }
  function initGovernorates() {
    var pk = govPicker(); if (!pk) return false;
    if (!pk.getOptions().length && GOVERNORATES.length) pk.setOptions(GOVERNORATES.map(function (g) { return { value: String(g[1]), label: String(g[0]) }; }));
    return true;
  }
  function govValue() { var pk = govPicker(); return pk ? String(pk.getValue() || '') : String((paCell.province && paCell.province.value) || ''); }
  function govLabel() {
    var pk = govPicker(); if (pk) return String(pk.getLabel() || '');
    var code = govValue(), hit = GOVERNORATES.filter(function (g) { return g[1] === code; })[0];
    return hit ? String(hit[0]) : '';
  }
  function readOther() {
    var a = {};
    PA_TEXT.forEach(function (k) { a[k] = paClean(paCell[k] ? paCell[k].value : ''); });
    a.provinceCode = govValue(); a.province = govLabel();
    return a;
  }
  function judgeOther(a) {
    var e = {};
    ['firstName', 'lastName', 'address1', 'address2', 'city'].forEach(function (k) { if (a[k].length > PA_LIMITS[k]) e[k] = 'Keep this under ' + (PA_LIMITS[k] + 1) + ' characters.'; });
    if (!a.firstName) e.firstName = PA_WORDS.firstName;
    if (!a.lastName) e.lastName = PA_WORDS.lastName;
    if (!a.address1) e.address1 = PA_WORDS.address1;
    else if (!e.address1 && a.address1.length < 6) e.address1 = PA_WORDS.address1Short;   // Bosta: the first line must be over 5 characters
    if (!a.city) e.city = PA_WORDS.city;
    if (!a.provinceCode) e.province = PA_WORDS.province;
    var zip = paDigits(a.zip).replace(/\s+/g, '');
    if (zip && !/^\d{5}$/.test(zip)) e.zip = PA_WORDS.zip;
    if (!egMobile(a.phone)) e.phone = PA_WORDS.phone;
    return e;
  }
  /* The words sit under their own cell, the cell says it is invalid, and the first bad one is where focus goes. */
  function paintOther(e) {
    var bad = [];
    PA_KEYS.forEach(function (k) {
      var on = !!(e && e[k]);
      if (paErr[k]) paErr[k].textContent = on ? e[k] : '';
      if (k === 'province') {
        if (govRoot) govRoot.classList.toggle('is-invalid', on);
        if (govTrigger) { if (on) { govTrigger.setAttribute('aria-invalid', 'true'); bad.push(govTrigger); } else govTrigger.removeAttribute('aria-invalid'); }
        return;
      }
      var el = paCell[k]; if (!el) return;
      if (on) { el.setAttribute('aria-invalid', 'true'); bad.push(el); } else el.removeAttribute('aria-invalid');
    });
    return bad;
  }
  function clearCellError(k) {
    if (paErr[k]) paErr[k].textContent = '';
    if (k === 'province') { if (govRoot) govRoot.classList.remove('is-invalid'); if (govTrigger) govTrigger.removeAttribute('aria-invalid'); return; }
    if (paCell[k]) paCell[k].removeAttribute('aria-invalid');
  }

  /* ---------- the checkout address, verbatim ---------- */
  function usableCheckout(d) {
    if (!d || typeof d !== 'object') return false;
    return !!(String(d.address1 || d.street || '').trim() && String(d.city || d.province || '').trim());
  }
  /* The lines as the checkout prints them. Each value is shown exactly as the lane returned it; only the joins are ours.
     A masked answer ({street, city}) is shown as it came. */
  function checkoutLinesOf(d) {
    function s(k) { return d[k] == null ? '' : String(d[k]); }
    if (!s('address1') && s('street')) return [s('street'), s('city')].filter(function (x) { return x.trim(); });
    var name = s('name') || [s('firstName'), s('lastName')].filter(function (x) { return x.trim(); }).join(' ');
    var place = [s('city'), s('province')].filter(function (x) { return x.trim(); }).join(', ') + (s('zip').trim() ? ' ' + s('zip') : '');
    return [name, s('company'), s('address1'), s('address2'), place, s('country') || 'Egypt', s('phone')].filter(function (x) { return x && x.trim(); });
  }
  function applyCheckoutAddress(d) {
    checkoutAddr = usableCheckout(d) ? JSON.parse(JSON.stringify(d)) : null;
    if (checkoutLines) {
      checkoutLines.textContent = '';
      if (checkoutAddr) checkoutLinesOf(checkoutAddr).forEach(function (line) { var sp = document.createElement('span'); sp.textContent = line; checkoutLines.appendChild(sp); });
    }
    if (checkoutCard) checkoutCard.classList.toggle('is-missing', !checkoutAddr);
    syncPickup();   // the title and the hint are written there, for every mode
  }

  /* P35-2 (SEC-B-01, svnty-core 0.8.2): a masked checkout address is shown, never copied. Its street and phone are a mask, so they are
     never prefilled, compared or mailed; the desk re-reads the real address from the order when the request is filed. */
  function maskedCheckout() { return !!(checkoutAddr && checkoutAddr.masked === true); }
  /* ---------- the state of the block, in one pass ---------- */
  var otherBeforeEdit = null, otherForced = false;
  /* P27-7 THE ADDRESS, PREFILLED AND EDITABLE: the cells open filled with the order's delivery address, so a change is an edit of what is
     there; an address left exactly as the order's still leaves as the delivery address (mode "delivery"), never as a typed copy */
  function prefillOther() {
    if (!checkoutAddr) return;
    var any = PA_TEXT.some(function (k) { return paCell[k] && String(paCell[k].value || '').trim(); }) || !!govValue();
    if (any) return;
    var d = checkoutAddr;
    var nm = String(d.name || '').trim().split(/\s+/);
    var first = String(d.firstName || (nm.length > 1 ? nm.slice(0, -1).join(' ') : nm[0] || '')), last = String(d.lastName || (nm.length > 1 ? nm[nm.length - 1] : ''));
    var set = maskedCheckout() ? { city: String(d.city || '') }   // P35-2 SEC-B-01: the city and the governorate only, never the masked street or phone
      : { firstName: first, lastName: last, address1: String(d.address1 || d.street || ''), address2: String(d.address2 || ''), city: String(d.city || ''), zip: String(d.zip || ''), phone: egMobile(d.phone) || String(d.phone || '') };
    Object.keys(set).forEach(function (k) { if (paCell[k]) paCell[k].value = set[k]; });
    initGovernorates();
    var code = String(d.provinceCode || '');
    if (!code && d.province) GOVERNORATES.forEach(function (g) { if (feeKey(g[0]) === feeKey(d.province)) code = String(g[1]); });
    if (govPicker() && code) govPicker().setValue(code);
  }
  function sameAsCheckout() {
    if (!checkoutAddr) return false;
    var a = readOther(), d = checkoutAddr;
    var c = function (v) { return paClean(paDigits(v)).toLowerCase(); };
    var code = String(d.provinceCode || '');
    if (!code && d.province) GOVERNORATES.forEach(function (g) { if (feeKey(g[0]) === feeKey(d.province)) code = String(g[1]); });
    /* P35-2 SEC-B-01: against a masked address only the city and the governorate compare. P35-3 (the refuter's P2): it is the order's
       own address only when every other cell is blank (the desk re-derives it on filing); a typed pickup phone, floor, name, street or
       postal code is a different address, judged in full (core refuses it on a phone session, in its own words) */
    if (maskedCheckout()) return ['firstName', 'lastName', 'address1', 'address2', 'zip', 'phone'].every(function (k) { return !c(a[k]); }) && c(a.city) === c(d.city) && String(a.provinceCode || '') === code;
    return c(a.firstName) === c(d.firstName) && c(a.lastName) === c(d.lastName) && c(a.address1) === c(d.address1 || d.street) && c(a.address2) === c(d.address2) &&
      c(a.city) === c(d.city) && String(a.provinceCode || '') === code && c(a.zip) === c(d.zip) && (egMobile(a.phone) || c(a.phone)) === (egMobile(d.phone) || c(d.phone));
  }
  /* the address that leaves: 'other' only when she changed something (or the order has none) */
  function pickupEffective() { return otherOn && !emailGate() && (!checkoutAddr || !sameAsCheckout()) ? 'other' : 'delivery'; }
  /* P35-3 SEC-B-17 THE LABEL PROOF (svnty-core 0.8.2): the phone is printed on the parcel's label, so a session proven with it files
     from the delivery address only; a different pickup address or a new delivery address needs the email on the order. The choice
     she made stays (otherOn and the draft are untouched) and comes back once the email proves the session. */
  var emailProof = $('[data-rd-email-proof]'), emailProofLead = $('[data-rd-email-proof-lead]'), emailSwitch = $('[data-rd-email-switch]');
  function emailGate() { return verifiedBy === 'phone'; }
  function emailGateWords() { return (addressEdit() ? 'To change the address, ' : 'To pick up from a different address, ') + 'verify with the email on your order.'; }
  if (emailSwitch) emailSwitch.addEventListener('click', function () {
    preferEmail = true; openContactCells('email');
    var em = String(val('email') || '').trim();
    status(em ? 'Press Find my order to verify with the email on your order.' : 'Type the email on your order, then press Find my order.');
  });
  function syncPickup() {
    var on = pickupActive();
    if (pickupRow) pickupRow.hidden = !on;
    /* the address change before it ships: the cells are the whole answer (the toggle steps aside), and her own pickup choice comes
       back when she leaves that edit */
    var editing = addressEdit();
    if (editing && otherBeforeEdit === null) { otherBeforeEdit = otherOn; otherOn = true; prefillOther(); }
    else if (!editing && otherBeforeEdit !== null) { otherOn = otherBeforeEdit; otherBeforeEdit = null; }
    var gate = emailGate();   // P35-3 SEC-B-17
    if (pickupLabel) pickupLabel.textContent = editing ? 'The new delivery address' : 'Where Bosta collects';
    if (otherRowEl) otherRowEl.hidden = editing || gate;
    if (emailProof) emailProof.hidden = !(on && gate);
    if (emailProofLead) emailProofLead.textContent = editing ? 'To change the address,' : 'To pick up from a different address,';
    if (checkoutTitle) checkoutTitle.textContent = !checkoutAddr ? 'No delivery address on this order' : editing ? 'Your delivery address now' : 'Your delivery address';
    if (checkoutHint) checkoutHint.textContent = editing && gate ? 'Your order goes here until the address is changed.' : editing ? 'Write the new address below, the way you would at checkout. It is changed only before Bosta collects the parcel.'
      : checkoutAddr ? 'Bosta delivered your order here, so the courier collects from here, exactly as you wrote it at checkout.' : gate ? 'This order has no delivery address.' : 'Write the address Bosta collects from below.';
    /* no address on the order: the different one is the only road. BUG FOUND BY THE WALL (2026-09-26): renderOrder() runs the
       kind's change (and so this function) BEFORE applyCheckoutAddress(), so every verified order passed through "no address"
       for an instant and the forced switch stuck: the checkout address showed while the send demanded the typed cells. A
       forced switch is now remembered as forced and released the moment the order's own address arrives. */
    var forced = !!verified && !checkoutAddr;
    if (forced && on && !otherOn) { otherOn = true; otherForced = true; }
    else if (!forced && otherForced) { otherOn = false; otherForced = false; }
    if (otherToggle) { otherToggle.checked = otherOn; otherToggle.disabled = !on || (forced && otherOn); }
    var cellsOn = on && otherOn && !gate;
    if (otherBox) otherBox.hidden = !otherOn || gate;
    PA_TEXT.forEach(function (k) { if (paCell[k]) paCell[k].disabled = !cellsOn; });
    initGovernorates();
    if (govPicker()) govPicker().setDisabled(!cellsOn); else if (govTrigger) govTrigger.disabled = true;
    if (checkoutCard) checkoutCard.classList.toggle('is-off', !!checkoutAddr && otherOn && !gate);
    if (checkoutBadge) checkoutBadge.textContent = !checkoutAddr ? 'Not on the order' : gate ? 'As at checkout' : (editing ? 'Being changed' : otherOn ? 'Not used' : 'As at checkout');
    syncPickupFields(on);
  }
  /* The mail's own words: the checkout's lines, whichever address it is. The machine copy travels in the intake payload. */
  function syncPickupFields(on) {
    var names = ['pickup_mode', 'pickup_name', 'pickup_phone', 'pickup_address', 'pickup_apartment', 'pickup_city', 'pickup_governorate', 'pickup_zip'];
    names.forEach(function (n) { if (fields[n]) fields[n].disabled = !on; });
    if (!on) { names.forEach(function (n) { if (fields[n]) fields[n].value = ''; }); return; }
    var src = { name: '', phone: '', address1: '', address2: '', city: '', province: '', zip: '' };
    if (pickupEffective() === 'other') {
      var a = readOther();
      src = { name: (a.firstName + ' ' + a.lastName).trim(), phone: egMobile(a.phone) || a.phone, address1: a.address1, address2: a.address2, city: a.city, province: a.province, zip: paDigits(a.zip) };
    } else if (checkoutAddr) {
      var d = checkoutAddr;
      src = { name: String(d.name || [d.firstName, d.lastName].filter(Boolean).join(' ') || ''), phone: String(d.phone || ''), address1: String(d.address1 || d.street || ''),
        address2: String(d.address2 || ''), city: String(d.city || ''), province: String(d.province || ''), zip: String(d.zip || '') };
      if (maskedCheckout()) { src.phone = ''; src.address1 = ''; }   // P35-2 SEC-B-01: the support mail never carries the mask
    }
    if (fields.pickup_mode) fields.pickup_mode.value = addressEdit() ? 'NEW DELIVERY ADDRESS before it ships, typed on the returns page' : pickupEffective() === 'other' ? 'A different address, typed on the returns page' : 'The delivery address on this order, as at checkout';
    if (fields.pickup_name) fields.pickup_name.value = src.name;
    if (fields.pickup_phone) fields.pickup_phone.value = src.phone;
    if (fields.pickup_address) fields.pickup_address.value = src.address1;
    if (fields.pickup_apartment) fields.pickup_apartment.value = src.address2;
    if (fields.pickup_city) fields.pickup_city.value = src.city;
    if (fields.pickup_governorate) fields.pickup_governorate.value = src.province;
    if (fields.pickup_zip) fields.pickup_zip.value = src.zip;
  }
  function pickupMode() { return pickupEffective(); }
  /* pickup v3, what leaves the page. "delivery": the checkout address as the lane returned it, every key untouched (and the v2
     flat keys beside it, so a v2 reader still reads it); "other": the typed address in the checkout's grammar. */
  function pickupPayload() {
    if (pickupEffective() === 'other') {
      var a = readOther();
      return { v: 3, mode: 'other', source: 'return_form', firstName: a.firstName, lastName: a.lastName, address1: a.address1, address2: a.address2,
        city: a.city, province: a.province, provinceCode: a.provinceCode, zip: paDigits(a.zip).replace(/\s+/g, ''), phone: egMobile(a.phone), country: 'Egypt', countryCode: 'EG' };
    }
    var d = checkoutAddr || {};
    var out = { v: 3, mode: 'delivery', source: 'shopify_checkout', address: checkoutAddr ? JSON.parse(JSON.stringify(checkoutAddr)) : null };
    ['firstName', 'lastName', 'address1', 'address2', 'city', 'province', 'provinceCode', 'zip', 'phone', 'country'].forEach(function (k) { out[k] = d[k] == null ? '' : d[k]; });
    return out;
  }
  /* The desk's own field, exactly the sibling store's shape: present ONLY for a different address. */
  function pickupAddressPayload() {
    if (pickupEffective() !== 'other' || !pickupActive()) return undefined;
    var a = readOther();
    return { firstName: a.firstName, lastName: a.lastName, address1: a.address1, address2: a.address2, city: a.city, province: a.province,
      zip: paDigits(a.zip).replace(/\s+/g, ''), phone: egMobile(a.phone) };
  }
  /* The one line the aside and the note read: which address, and where. */
  function pickupSummary() {
    if (!pickupActive()) return null;
    if (pickupEffective() === 'other') {
      var a = readOther(), place = [a.city, a.province].filter(Boolean).join(', ');
      return { mode: 'other', title: 'A different address', where: [a.address1, place].filter(Boolean).join(', ') };
    }
    if (!checkoutAddr) return { mode: 'none', title: 'Not chosen yet', where: '' };
    var d = checkoutAddr;
    return { mode: 'delivery', title: 'Your delivery address', where: [maskedCheckout() ? '' : String(d.address1 || d.street || ''), [d.city, d.province].filter(Boolean).join(', ')].filter(Boolean).join(', ') };   // P35-2 SEC-B-01: no masked street in the note
  }
  /* ---------- the refusal, by name ---------- */
  function pickupProblem() {
    if (!pickupActive()) return null;
    if (emailGate()) return addressEdit() || !checkoutAddr ? { el: emailSwitch, msg: emailGateWords() } : null;   // P35-3 SEC-B-17: the delivery address files
    if (!otherOn) return checkoutAddr ? null : { el: otherToggle, msg: 'Write the address Bosta collects from.' };
    if (checkoutAddr && sameAsCheckout()) return addressEdit() ? { el: paCell.address1, msg: 'That is the address on your order now. Change what is different.' } : null;
    var e = judgeOther(readOther());
    var bad = paintOther(e);
    if (!bad.length) return null;
    var first = PA_KEYS.filter(function (k) { return e[k]; })[0];
    return { el: bad[0], msg: 'Check the different address: ' + e[first].charAt(0).toLowerCase() + e[first].slice(1) };
  }
  function resetPickup() {
    checkoutAddr = null; otherOn = false; otherBeforeEdit = null; otherForced = false;
    PA_TEXT.forEach(function (k) { if (paCell[k]) paCell[k].value = ''; });
    if (govPicker()) govPicker().setValue('');
    paintOther({});
    if (checkoutLines) checkoutLines.textContent = '';
    if (checkoutCard) checkoutCard.classList.remove('is-missing', 'is-off');
    syncPickup();
  }
  if (otherToggle) otherToggle.addEventListener('change', function () {
    otherOn = otherToggle.checked; otherForced = false;
    if (otherOn) prefillOther();
    syncPickup();
    if (!otherOn) paintOther({});
    else if (paCell.firstName) { try { paCell.firstName.focus({ preventScroll: true }); } catch (e) { paCell.firstName.focus(); } }
    saveDraft(); syncSubmitNote();
  });
  if (govRoot) govRoot.addEventListener('svnty:picker:change', function () { clearCellError('province'); syncPickupFields(pickupActive()); saveDraft(); syncSubmitNote(); });
  PA_TEXT.forEach(function (k) {
    var el = paCell[k]; if (!el) return;
    el.addEventListener('input', function () {
      if (el.getAttribute('aria-invalid') === 'true') clearCellError(k);
      syncPickupFields(pickupActive()); syncSubmitNote();
    });
  });
  initGovernorates();

  /* ---------- draft + submit guard ---------- */
  // The allowlist itself lives at the top of the module (above the shop-back restore). Shopify's error re-render
  // echoes the email and the message body; the display name is not typed any more — it comes from the desk's
  // greeting after the order is verified again. Legacy drafts are purged.
  (function purgeLegacyDraft() {
    try { LEGACY_DRAFT_KEYS.forEach(function (k) { sessionStorage.removeItem(k); }); } catch (e) {}
    /* RT-2, the other half of THE DEMO FENCE: a REAL visit clears the demo's own key and, for a tab
       contaminated by the build that had no fence, any real draft still stamped with the demo order. */
    if (!DEMO) {
      try {
        sessionStorage.removeItem(DEMO_DRAFT_KEY);
        for (var v = 1; v <= 5; v++) sessionStorage.removeItem(DEMO_DRAFT_KEY + ':' + v);
      } catch (e) {}
      var stale = sget(REAL_DRAFT_KEY);
      if (stale && String(stale.__order || '') === 'DEMO') { try { sessionStorage.removeItem(REAL_DRAFT_KEY); } catch (e) {} }
    }
    var d = sget(DRAFT_KEY); if (!d) return;
    var dirty = Object.keys(d).some(function (k) { return DRAFT_META.indexOf(k) === -1 && !DRAFT_KEEP[k]; });
    if (!dirty) return;
    var clean = {};
    DRAFT_META.forEach(function (k) { clean[k] = d[k] || ''; });
    Object.keys(DRAFT_KEEP).forEach(function (k) { if (k in d) clean[k] = d[k]; });
    sset(DRAFT_KEY, clean);
  })();
  function saveDraft() {
    // P27-7: a beat that lands after the filing never writes the draft back over the confirmation; before the order is found there is no
    // choice to keep (the steps are shut), so nothing is written over the draft of the order she will find again
    if (!form.isConnected || !verified) return;
    // __lane / __return: the desk's answer, so the confirmation screen can name the filed return.
    // __pieces: every piece's choice (the ticks in order, the quantity, the wanted options, the reason, her note), PII-free.
    // __pickup: the cells the customer corrected, EXCEPT the phone, which is never written down (H-02).
    var st = {};
    pieces.forEach(function (p) { if (p.on || p.reason || Object.keys(p.sel).length) st[p.id] = { qty: p.qty, sel: p.sel, reason: p.reason, note: p.note }; });
    var data = {
      __order: verified && verified.order ? String(verified.order.name || '').replace(/^#/, '') : '',
      __kind: currentKind(), __lane: deskLane, __return: deskReturnName, __joined: deskJoined ? '1' : '', __words: cancelWords, __changed: deskChanged ? '1' : '',
      __pieces: JSON.stringify({ picked: picked.slice(), s: st }),
      __cancel: JSON.stringify({ c: cancelConfirm && cancelConfirm.checked ? 1 : 0, r: cancelReason() }),
      __pickup: JSON.stringify(pickupDraft())
    };
    $$('input, select, textarea', form).forEach(function (el) {
      if (!el.name || !DRAFT_KEEP[el.name]) return;
      if (el.type === 'radio' || el.type === 'checkbox') { if (el.checked) data[el.name] = el.value; } else data[el.name] = el.value;
    });
    sset(DRAFT_KEY, data);
  }
  function clearDraft() { try { sessionStorage.removeItem(DRAFT_KEY); } catch (e) {} }
  function pickupDraft() {
    var out = { v: 3, other: otherOn === true };
    if (otherOn) { var a = readOther(); ['firstName', 'lastName', 'address1', 'address2', 'city', 'zip'].forEach(function (k) { out[k] = a[k]; }); out.provinceCode = a.provinceCode; }
    return out;   // no phone, ever (H-02)
  }
  /* Only after the order is verified, and only her OWN order's draft: a typed address belongs to the order it was typed for. */
  function restorePickupDraft() {
    var d = sget(DRAFT_KEY); if (!d || !d.__pickup || !verified) return;
    if (d.__order && d.__order !== String((verified.order && verified.order.name) || '').replace(/^#/, '')) return;
    var p = null; try { p = JSON.parse(d.__pickup); } catch (e) { p = null; }
    if (!p || typeof p !== 'object' || p.v !== 3 || p.other !== true) return;   // an older draft's cells no longer fit; the checkout address stands
    ['firstName', 'lastName', 'address1', 'address2', 'city', 'zip'].forEach(function (k) { if (paCell[k] && typeof p[k] === 'string') paCell[k].value = p[k]; });
    initGovernorates(); if (govPicker() && p.provinceCode) govPicker().setValue(String(p.provinceCode));
    // P35-2 (SEC-A-02): the different address's phone is never written down, so it is typed again after a refresh
    otherOn = true; syncPickup();
  }
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      form.dataset.rdSubmitting = '0'; form.removeAttribute('aria-busy'); form.inert = false;
      var sb = $('[data-rd-submit]'); if (sb) sb.disabled = !verified;
      var lb = $('[data-rd-submit-label]'); if (lb) lb.textContent = submitDefaultLabel;
    }
    // out of the back/forward cache the module is alive and `verified` with it; after a real reload the stored session is what stands
    // between her and typing the order number again
    if (!verified) restoreVerified();
    syncSubmitNote();
  });
  function restoreDraft() {
    var data = sget(DRAFT_KEY); if (!data) return;
    $$('input, select, textarea', form).forEach(function (el) {
      if (!el.name || !(el.name in data) || !DRAFT_KEEP[el.name]) return;
      if (el.disabled) return;   // a request the order no longer allows is never restored into the form
      if (el.type === 'radio' || el.type === 'checkbox') el.checked = el.value === data[el.name]; else el.value = data[el.name];
    });
    restorePickupDraft();
  }
  // Server error round-trip: Shopify re-renders the form and echoes the email and the message body itself; we restore the
  // CHOICES only (the H-02 allowlist) and the order is verified again, since the address is never stored.
  if ($('.svnty-rd__errs')) { try { restoreDraft(); } catch (e) {} }
  syncKind();

  var submit = $('[data-rd-submit]'), submitLabel = $('[data-rd-submit-label]'), submitDefaultLabel = submitLabel.textContent;
  // The one native submit control on the page (visually hidden). Only the end of the chain ever presses it.
  /* The cards' own verdict, never a second rule (P22, I2: an order whose delivery cannot be seen keeps every door closed). */
  function requestAllowed(order, kind) {
    return windowVerdict(order).kinds[kind] === true;
  }
  /* MANY PIECES: every piece of the request must still be on the fresh order, as it was, with no request open on it. */
  function piecesStillMatch(order) {
    var ls = Array.isArray(order.lines) ? order.lines : [];
    var pcs = allPieces();
    if (!pcs.length) return currentKind() === 'cancel' && !piecesKind();
    return pcs.every(function (p) {
      var line = ls.filter(function (l) { return String(l.lineId || '') === p.lineId; })[0];
      var room = line ? Number(line.quantity || 0) - (afterDelivery(currentKind()) && Number(line.unshipped) > 0 ? Number(line.unshipped) : 0) : 0;
      return !!line && !line.openReturn && String(line.variantId || '') === String(p.variantId || '') && p.quantity >= 1 && p.quantity <= room;
    });
  }
  /* P34-12: the pieces to replace whose own size and color the fresh order reads sold out (marked, so the card closes in words) */
  function replaceGone(order) {
    var res = $('[data-rd-resolution-choice]:checked');
    if (currentKind() !== 'faulty' || !res || res.value === 'Full refund') return [];
    var ls = Array.isArray(order && order.lines) ? order.lines : [];
    var out = onPieces().filter(function (p) {
      var l = ls.filter(function (x) { return String(x.lineId || '') === p.id; })[0];
      return !!l && !l.archived && !!l.variantId && l.availableNow === false;
    });
    out.forEach(function (p) { p.soldOut = true; });
    return out;
  }
  /* the stock of every wanted size and color, read again before anything is filed */
  function recheckWants() {
    var wants = allPieces().filter(function (p) { return p.want && p.want.variantId && p.want.handle && p.action !== 'replace'; });
    return wants.reduce(function (chain, p) {
      return chain.then(function () {
        return fetchLiveProduct(p.want.handle).then(function (pj) {
          var v = (pj.variants || []).filter(function (x) { return String(x.id) === String(p.want.variantId); })[0];
          if (!v || v.available !== true) { var err = new Error('target_unavailable'); err.piece = p.title; throw err; }
        }, function () { throw new Error('target_check_failed'); });
      });
    }, Promise.resolve());
  }
  /* the mail's summary of every piece (contact[Pieces]); the single-piece fields carry the first piece */
  function fillMailPieces() {
    var pcs = allPieces();
    if (fields.pieces) fields.pieces.value = pcs.map(function (p, i) { return (i + 1) + ') ' + pieceWords(p) + (p.reason ? ' [' + p.reasonLabel + ']' : '') + (p.want && p.want.variantId ? ' [want variant ' + p.want.variantId + ']' : '') + ' [line ' + p.lineId + ']'; }).join('; ').slice(0, 1800);
    var f = pcs[0];
    ['line_id', 'have_id', 'ordered_qty', 'handle', 'url', 'want_id', 'want_handle', 'want_delta', 'want_avail', 'exchange_mode'].forEach(function (n) { if (fields[n]) fields[n].value = ''; });
    if (!f) return;
    fields.line_id.value = f.lineId; fields.have_id.value = f.variantId; fields.ordered_qty.value = String(f.orderedQty || '');
    fields.handle.value = f.handle; fields.url.value = f.handle ? location.origin + '/products/' + f.handle : '';
    if (f.want) { fields.want_id.value = f.want.variantId; fields.want_handle.value = f.want.handle; fields.want_delta.value = f.want.delta; fields.want_avail.value = f.want.avail; fields.exchange_mode.value = f.want.mode; }
  }
  function requestFingerprint() {
    var resolution = $('[data-rd-resolution-choice]:checked');
    return JSON.stringify({
      contact: lookupFingerprint(), kind: currentKind(), change: editAction.value, cancel: [cancelConfirm && cancelConfirm.checked, cancelReason()],
      pieces: allPieces().map(function (p) { return [p.lineId, p.quantity, p.want ? p.want.variantId : '', p.reason, p.note]; }),
      resolution: resolution && !resolution.disabled ? resolution.value : ''
    });
  }
  function submitFailure(message, reset, calm) {
    form.dataset.rdSubmitting = '0'; form.removeAttribute('aria-busy'); form.inert = false;
    submit.disabled = false; submitLabel.textContent = submitDefaultLabel;
    if (reset) resetVerified();   // clears the slot; the message is written after, with focus, on live DOM
    // focus only once `inert` is off: an inert subtree cannot hold it, and the message would be announced to nobody
    submitError(message, true);
    if (calm) submitStatus && submitStatus.classList.add('is-calm');
    else submitStatus && submitStatus.classList.remove('is-calm');
  }

  /* ---------- THE LANE: file the request as a real return before the mail goes ----------
     The customer's own choice decides the lane; the owner desk verifies the token through its
     binding to svnty-desk and writes the Shopify return. Prod runs dry (journal only, no return
     born) and answers dryRun:true — then the confirmation keeps today's wording. */
  /* LAW 0 (SVNTY is totally independent): SVNTY never calls a host that is not its own, and no
     hostname of any kind is printed in this theme. The returns lane is the store's OWN App Proxy —
     the `data-owner-url` attribute, and when it is empty, the same desk lane the rest of this file
     uses. The parent's worker-hostname fallback is deliberately deleted, not commented out. */
  function ownerUrl() {
    var pinned = QA_API ? '' : (root.getAttribute('data-owner-url') || '').trim();
    return pinned || DESK;
  }
  var INTAKE_TIMEOUT = 12000;
  var deskLane = '', deskReturnName = '', deskJoined = false, deskChanged = false;   // P22: deskChanged, the lane answered the STORED request
  function laneFor(kind) {
    if (kind === 'exchange') return 'exchange';
    if (kind === 'refund') return 'refund';
    if (kind !== 'faulty') return '';   // a pre-ship cancel is the note lane: email only, unchanged
    var picked = $('[data-rd-resolution-choice]:checked');
    return picked && picked.value === 'Full refund' ? 'refund' : 'exchange';
  }
  /* ---------- D12-3 THE CANCEL DOOR (the cancel fork's §5; svnty-public 0.5.0 POST /returns/cancel) ----------
     "Cancel the whole order" before the pickup is a request at the desk, not a note alone: the desk's verdict at this moment (Shopify's
     waybills, Bosta's fresh state; the store's rule: only before the courier holds it) answers 200 with the request's name and the state in
     its own words, or 409 with the words that say why not. Same human check, same wall, one silent Turnstile retry (contract 3.0). */
  var cancelWords = '';
  function fileCancel() {
    deskLane = 'cancel'; deskReturnName = ''; deskJoined = false; cancelWords = '';
    fields.lane.value = 'cancel'; fields.desk_return.value = '';
    if (!fields.request_id.value) fields.request_id.value = requestId();
    var payload = {
      token: verified.token,
      requestId: fields.request_id.value,
      contact: proofContact(),   // P35-3: '' when the token alone proves the session (core 0.8.2)
      reply_email: replyEmail(),   // P22 (I1): where the reply goes when the order has no email
      reason: cancelReason(),
      reason_label: reasonLabelOf(cancelReason()),
      note: String(val('body') || '').slice(0, 500)
    };
    function send(retried) {
      var tokened = false;
      return tsToken().then(function (tok) {
        if (tok) payload.turnstile = tok; else delete payload.turnstile;
        tokened = !!tok;
        var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
        var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, INTAKE_TIMEOUT) : null;
        var opts = {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          cache: 'no-store', credentials: 'same-origin', body: JSON.stringify(payload)
        };
        if (ctrl) opts.signal = ctrl.signal;
        return fetch(ownerUrl().replace(/\/$/, '') + '/cancel', opts).then(function (r) {
          return r.text().then(function (text) {
            if (timer) clearTimeout(timer);
            var body = null; try { body = JSON.parse(text); } catch (e) {}
            return { status: r.status, ok: r.ok, body: body || {} };
          });
        }, function (e) { if (timer) clearTimeout(timer); throw e; });
      }).then(function (res) {
        if (res.status === 403 && res.body.error === 'turnstile' && !retried && tokened) return send(true);   // P17-1 (P2-9): no token, no second send
        return res;
      });
    }
    return send(false).then(function (res) {
      if (res.ok && res.body.ok === true) {
        var name = String(res.body.rr || '');
        cancelWords = String(res.body.words || '');
        deskReturnName = res.body.dryRun === true ? '' : name;
        deskJoined = res.body.existing === true;
        fields.desk_return.value = res.body.dryRun === true ? 'dry-run' : (name + (deskJoined ? ' (joined, already open)' : ''));
        return res.body;
      }
      var err;
      if (res.status === 409) { err = new Error('cancel_refused'); err.reason = String(res.body.reason || ''); err.words = String(res.body.words || ''); throw err; }
      if (res.status === 401 || res.status === 422) { err = new Error('intake_unverified'); err.status = 401; err.proof = true; throw err; }   // P35-3: the contact was the proof
      if (res.status === 429) throw new Error('intake_rate_limited');
      if (res.status === 403 && res.body.error === 'turnstile') throw new Error('intake_turnstile');
      /* P17-1 (the audit's P2-6): a 503 {error:'unreachable'} is Shopify or the courier not answering behind the desk, never a paused
         lane: it takes the courier_down words (409's own road, the form kept). Only a 503 lane_off says the cancellations are paused. */
      if (res.status === 503 && res.body.error === 'unreachable') { err = new Error('cancel_refused'); err.reason = 'courier_down'; err.words = ''; throw err; }
      /* P22 (I7, DEFECTS P3-7): a lane switched off says so in the contract's words; the valve (busy) and any other 503 is the store
         being busy, never the courier and never "paused" */
      if (res.status === 503 && res.body.error === 'lane_off') throw new Error('lane_off');
      if (res.status === 503) throw new Error('cancel_busy');
      if (res.status === 400) { err = new Error('request_closed'); err.code = String(res.body.error || ''); err.field = String(res.body.field || ''); throw err; }
      throw new Error('intake_failed');
    }, function () { throw new Error('intake_failed'); });   // network, 5xx body read, timeout
  }
  /* THE STATUS VIEW (svnty-public 0.5.0 POST /returns/status): the order's requests of the last 90 days, under the order card, in words;
     none, or a lane that does not answer, shows nothing (the QA fixture lane has no /status). */
  var REQUEST_KIND_WORDS = { cancel: 'Cancellation', exchange: 'Exchange', refund: 'Refund', faulty: 'Faulty piece', 'return': 'Return' };
  var REQUEST_STATE_WORDS = { pending: 'Being reviewed', approved: 'Approved', declined: 'Declined' };
  /* P22 (I8, DEFECTS P2-8, REHEARSAL H4): where an approved request stands, in the desk's own stage (stageOf); a request decided while
     the desk rehearsed (filed_live 0) changed nothing in Shopify or at Bosta, so it reads "Being reviewed", whatever was decided */
  var REQUEST_STAGE_WORDS = { review: 'Being reviewed', pickup_booked: 'Pickup booked', collected: 'Collected by Bosta', back: 'Back at SVNTY', checked: 'Checked', settled: 'Settled', closed: 'Closed' };
  /* THE LOST RETURN, SETTLED (P34-12, RTN-03's cousin 2): Bosta's word that her return was lost stays true, but the window line's promise
     under it ("we settle the refund or the exchange and email you") is kept once the store settled it. The status rows name no waybill, so
     it is settled when a live approved return (never a cancellation, never a rehearsal) reads Settled or Closed and none is still between
     its pickup and its settlement (that one may be the lost pickup) */
  var PICKUP_BAND = { pickup_booked: 1, collected: 1, back: 1, checked: 1 };
  function lostReturnSettled(rows) {
    var live = (rows || []).filter(function (q) { return q && q.status === 'approved' && String(q.kind || '') !== 'cancel' && !(q.filed_live === 0 || q.filed_live === '0' || q.filed_live === false); });
    return live.some(function (q) { return q.stage === 'settled' || q.stage === 'closed'; }) && !live.some(function (q) { return PICKUP_BAND[String(q.stage || '')] === 1; });
  }
  var requestsSeq = 0;
  function loadRequests(tries) {
    /* P17-1 (the audit's P2-2): THE DEMO FENCE holds here too. The demo order's token is "demo", so a status read from a demo view
       could only reach the live lane and come back 401: no request leaves a demo page. */
    if (DEMO) return;
    var box = $('[data-rd-requests]'); if (!box) return;
    box.hidden = true; box.innerHTML = '';
    if (!DESK || !verified || !verified.token) return;
    var seq = ++requestsSeq;
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 8000) : null;
    var opts = { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin', body: JSON.stringify({ token: verified.token }) };
    if (ctrl) opts.signal = ctrl.signal;
    /* P28-3 (the live walk's P1-2): a 429 or a fault on the requests list retries once after Retry-After (1 to 30 s), then says so with a
       Try again; an expired token (401) stays silent as before (the lookup's own words cover it) */
    fetch(ownerUrl().replace(/\/$/, '') + '/status', opts).then(function (r) { if (r.ok) return r.json(); var e = new Error('status_' + r.status); e.retryAfter = retryAfterOf(r); throw e; }).then(function (body) {
      if (timer) clearTimeout(timer);
      if (seq !== requestsSeq || !verified || !body || body.ok !== true || !Array.isArray(body.requests) || !body.requests.length) return;
      var settledNow = lostReturnSettled(body.requests);
      if (verified.order && verified.order.returnLost && settledNow !== lostSettled) { lostSettled = settledNow; renderWindow(verified.order); }
      /* P17-27 (svnty-core 0.4.2): an approved cancel reads the order itself: "Canceled" once the order is canceled, else
         "Approved"; " · Refunded" only for a card payment Shopify shows refunded; never a refund word on a cancel otherwise */
      var ov = (verified && verified.order) || {}, pay = ov.payment || {};
      var rows = body.requests.slice(0, 8).map(function (q) {
        var kind = REQUEST_KIND_WORDS[String(q.kind || '')] || 'Request', st = REQUEST_STATE_WORDS[String(q.status || '')] || '';
        var rehearsal = q.filed_live === 0 || q.filed_live === '0' || q.filed_live === false;
        if (rehearsal) st = 'Being reviewed';
        else if (q.status === 'approved' && q.stage && q.stage !== 'review' && REQUEST_STAGE_WORDS[String(q.stage)]) st = REQUEST_STAGE_WORDS[String(q.stage)];
        var when = q.decided_at && q.status !== 'pending' && !rehearsal ? fmtDate(q.decided_at) : fmtDate(q.made_at);
        var res = st === 'Approved' && q.resolution ? String(q.resolution).replace(/^[a-z]/, function (ch) { return ch.toUpperCase(); }) : '';
        if (String(q.kind || '') === 'cancel' && q.status === 'approved' && !rehearsal) {
          st = ov.stage === 'CANCELLED' ? 'Canceled' : 'Approved';
          res = pay.kind === 'card' && pay.refunded ? 'Refunded' : '';
        }
        var tone = rehearsal ? '' : q.status === 'declined' ? ' is-declined' : q.status === 'approved' ? ' is-approved' : '';
        return '<li class="svnty-rd__request"><span class="svnty-rd__request-name">' + esc(String(q.rr || '')) + '</span><span class="svnty-rd__request-kind">' + esc(kind) + '</span>' +
          '<span class="svnty-rd__request-state' + tone + '">' + esc(st + (res ? ' \u00b7 ' + res : '') + (when ? ' \u00b7 ' + when : '')) + '</span></li>';
      }).join('');
      box.innerHTML = '<p class="svnty-rd__requests-head">Requests on this order</p><ul class="svnty-rd__requests-list" role="list">' + rows + '</ul>';
      box.hidden = false;
    }).catch(function (e) {
      if (timer) clearTimeout(timer);
      if (seq !== requestsSeq || !verified || (e && e.message === 'status_401')) return;
      if (!tries) { var wait = Math.min(Math.max((e && e.retryAfter) || 2, 1), 30) * 1000; setTimeout(function () { if (seq === requestsSeq && verified) loadRequests(1); }, wait); return; }
      box.innerHTML = '<p class="svnty-rd__requests-head">Requests on this order</p><p class="svnty-rd__hint">We could not load them right now. <button type="button" class="svnty-rd__link" data-rd-requests-retry>Try again</button></p>';
      box.hidden = false;
    });
  }
  (function () { var b = $('[data-rd-requests]'); if (b) b.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-rd-requests-retry]')) loadRequests(); }); })();
  function fileIntake(kind) {
    if (isCancelOrder(kind)) return fileCancel();   // D12-3: the cancel door; every other pre-ship edit stays the note lane
    var lane = laneFor(kind);
    deskLane = lane; deskReturnName = '';
    fields.lane.value = lane; fields.desk_return.value = '';
    if (!lane) return fileEditNote(kind);   // P22 (I9, FAKE F1): a change of size, color or address before it ships is a filing, awaited
    var res = $('[data-rd-resolution-choice]:checked');
    var pcs = allPieces(), first = pcs[0] || null;
    /* THE REQUEST AS SENT (P27-7, MANY PIECES): `items` carries every piece (its line, the variant she has, the quantity, the action, the
       wanted variant of the same product, its reason and her note); the single-piece fields (lineId, quantity, want, reason) carry the
       first piece for a reader of the older shape; the pickup (v3: mode delivery = the checkout address untouched, mode other = the typed
       address), and the desk's own intake fields beside them, so either reader files the same request. */
    var payload = {
      token: verified.token,
      lane: lane,
      kind: kind,
      lineId: first ? first.lineId : '',
      quantity: first ? first.quantity : 0,
      reason: first ? first.reason : '',
      reasonLabel: first ? first.reasonLabel : '',
      note: String(val('body') || '').slice(0, 500),
      resolution: lane,
      faultyResolution: kind === 'faulty' && res && !res.disabled ? res.value : '',
      want: { variantId: first && first.want ? (first.want.variantId || null) : null, title: first && first.want ? first.want.label : '' },
      items: pcs.map(function (p) {
        return { lineId: p.lineId, variantId: p.variantId, title: p.title + (p.haveParts && p.haveParts.length ? ' (' + p.haveParts.join(' / ') + ')' : ''), quantity: p.quantity, qty: p.quantity,
          action: p.action, targetVariantId: p.want && p.action !== 'replace' ? p.want.variantId : null, reason: p.reason, reasonLabel: p.reasonLabel, note: p.note,
          want: p.want ? { variantId: p.want.variantId || null, handle: p.want.handle || '', title: p.want.label || '', priceDifference: p.want.delta === '' ? null : Number(p.want.delta) } : null };
      }),
      order: orderName().replace(/^#/, ''),
      contact: proofContact(),   // P35-3: '' when the token alone proves the session (core 0.8.2)
      reply_email: replyEmail(),   // P22 (I1): the desk keeps it when the order has no email
      requestId: fields.request_id.value || '',   // P1-8: the same request sent twice files once
      exchange_for: lane === 'exchange' ? pcs.map(function (p) { return p.want && p.want.label ? p.title + ': ' + p.want.label : ''; }).filter(Boolean).join('; ').slice(0, 120) : '',
      pickup: pickupPayload()
    };
    var pa = pickupAddressPayload(); if (pa) payload.pickup_address = pa;
    /* One send = one fresh Turnstile token and its own 12 s wall; a refused token earns one silent retry (contract 3.0). */
    function send(retried) {
      var tokened = false;
      return tsToken().then(function (tok) {
        if (tok) payload.turnstile = tok; else delete payload.turnstile;
        tokened = !!tok;
        var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
        var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, INTAKE_TIMEOUT) : null;
        var opts = {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          cache: 'no-store', credentials: 'same-origin', body: JSON.stringify(payload)
        };
        if (ctrl) opts.signal = ctrl.signal;
        return fetch(ownerUrl().replace(/\/$/, '') + '/intake/return', opts).then(function (r) {
          return r.text().then(function (text) {
            if (timer) clearTimeout(timer);
            var body = null; try { body = JSON.parse(text); } catch (e) {}
            return { status: r.status, ok: r.ok, body: body || {} };
          });
        }, function (e) { if (timer) clearTimeout(timer); throw e; });
      }).then(function (res) {
        if (res.status === 403 && res.body.error === 'turnstile' && !retried && tokened) return send(true);   // P17-1 (P2-9): no token, no second send
        return res;
      });
    }
    return send(false).then(function (res) {
      if (res.ok && res.body.ok === true) {
        // the lane names the return (returnName); the desk's own intake names its request (rr) and may say it joined one already open
        var name = String(res.body.returnName || res.body.rr || '');
        deskReturnName = res.body.dryRun === true ? '' : name;
        deskJoined = res.body.existing === true;
        deskChanged = res.body.changed === true;   // P22: the request filed earlier under this id, not the one typed since
        fields.desk_return.value = res.body.dryRun === true ? 'dry-run' : (name + (deskJoined ? ' (joined, already open)' : ''));
        return res.body;
      }
      var err;
      if (res.status === 401 || res.status === 422) { err = new Error('intake_unverified'); err.status = 401; err.proof = true; throw err; }   // P35-3: the contact was the proof
      // the desk judged the different address and named the fields: the words go under the cells, nothing was filed
      if (res.status === 400 && res.body.error === 'pickup_address') { err = new Error('pickup_rejected'); err.fields = res.body.fields || {}; throw err; }
      // P22 (I3): a request in flight at Bosta refuses every kind: the window's own words (the order found again), never "already filed"
      if (res.status === 409 && res.body.error === 'in_flight') { err = new Error('request_closed'); err.code = 'in_flight'; throw err; }
      if (res.status === 409) { err = new Error('intake_duplicate'); err.returnName = String(res.body.returnName || ''); throw err; }
      if (res.status === 429) throw new Error('intake_rate_limited');
      if (res.status === 503 && res.body.error === 'lane_off') throw new Error('lane_off');   // P22 (I7)
      if (res.status === 403 && res.body.error === 'turnstile') throw new Error('intake_turnstile');
      /* P2-8 (the research lane): a 400 names its trouble (contract 3.5): the window, the quantity, the wanted piece, the pickup
         cell; an unnamed 400 keeps the closed-request words. P34-12: and its reason and line (a replacement sold out names the line) */
      if (res.status === 400) { err = new Error('request_closed'); err.code = String(res.body.error || ''); err.field = String(res.body.field || ''); err.reason = String(res.body.reason || ''); err.lineId = String(res.body.lineId || ''); err.words = String(res.body.words || ''); throw err; }   // P35-3: core's own words ride along
      throw new Error('intake_failed');
    }, function () { throw new Error('intake_failed'); });   // network, 5xx body read, timeout
  }
  /* ---------- THE INBOX (02_architecture/THE_INBOX_2026-08-29.md) ----------
     A SIDE RECORD, filed the moment the request exists, so the desk's Inbox carries the customer's own
     words sorted by category instead of waiting on Shopify's mail. It is never allowed to stand between
     the customer and the confirmation: it is STARTED and never awaited, sent keepalive so the native post
     cannot cancel it, given 8 s, and a failure is a console.debug and nothing else — no message, no delay,
     no second thought. A pre-ship cancel files no return and still files its note. P22 (I9): a change of size, color or address
     before it ships is the exception: its note IS the filing (fileEditNote), awaited, and this side record is never sent for it. */
  var NOTE_TIMEOUT = 8000;
  var NOTE_CATEGORY = { exchange: 'return-exchange', refund: 'return-refund', faulty: 'faulty', cancel: 'pre-ship-edit' };
  var NOTE_HEAD = { exchange: 'Exchange', refund: 'Refund', faulty: 'Faulty', cancel: 'Pre-ship edit' };
  function noteDebug(what, detail) {
    try { if (window.console && typeof console.debug === 'function') console.debug('svnty: ' + what, detail); } catch (e) {}
  }
  function orderName() { return String((verified && verified.order && verified.order.name) || ''); }
  /* P22 (I1, FAKE F3): the email cell as typed (trimmed, 254 at most, may be empty): the lane keeps it only when it reads as an
     email, and the desk replies there when the order carries none */
  function replyEmail() { return String(val('email') || '').trim().slice(0, 254); }
  function noteSubject(kind) {
    var tail, pcs = kind === 'cancel' && !piecesKind() ? [] : allPieces();
    if (pcs.length > 1) tail = pcs.length + ' pieces';
    else if (pcs.length === 1) tail = pcs[0].title + (pcs[0].want && pcs[0].action !== 'replace' ? ' \u00b7 ' + pcs[0].haveParts.join(' / ') + ' \u2192 ' + pcs[0].want.label : '');
    else if (kind === 'cancel') tail = CHANGE_WORDS[editAction.value] || '';
    else tail = '';
    return [NOTE_HEAD[kind] || 'Request', orderName(), tail].filter(Boolean).join(' \u00b7 ').slice(0, 200);
  }
  /* The customer's own note first, then the facts as plain lines: the desk reads it as it stands. */
  function noteBody(kind) {
    var lines = [];
    var typed = String(val('body') || '').trim();
    if (typed) { lines.push(typed); lines.push(''); }
    var pcs = kind === 'cancel' && !piecesKind() ? [] : allPieces();
    if (kind === 'cancel') lines.push('Edit: ' + (CHANGE_WORDS[editAction.value] || 'not chosen'));
    pcs.forEach(function (p, i) { lines.push((pcs.length > 1 ? 'Piece ' + (i + 1) : 'Piece') + ': ' + pieceWords(p) + (p.reason ? ' \u00b7 Reason: ' + p.reasonLabel : '') + (p.note ? ' \u00b7 ' + p.note : '')); });
    if (kind === 'faulty') { var picked0 = $('[data-rd-resolution-choice]:checked'); lines.push('Resolution: ' + (picked0 && !picked0.disabled ? picked0.value : 'reviewed by the team')); }
    if (kind === 'cancel') {
      if (isCancelOrder(kind)) lines.push('Reason: ' + reasonLabelOf(cancelReason()));
      if (addressEdit()) {
        var na = readOther();
        lines.push('New address: ' + [(na.firstName + ' ' + na.lastName).trim(), na.address1, na.address2, na.city, na.province, paDigits(na.zip), egMobile(na.phone) || na.phone].filter(Boolean).join(', '));
      }
    } else {
      var ps = pickupSummary();
      if (ps) lines.push('Pickup: ' + (ps.mode === 'other' ? 'a different address' : 'the delivery address on this order') + (ps.where ? ' \u00b7 ' + ps.where : ''));
    }
    if (deskReturnName) lines.push('Return: ' + deskReturnName);
    return lines.join('\n').slice(0, 3500);
  }
  /* P22: the note, one builder for both roads (the side record below and the awaited edit, fileEditNote) */
  function notePayload(kind) {
    var pv = pickupActive() ? (pickupEffective() === 'other' ? { phone: egMobile(readOther().phone) } : { phone: maskedCheckout() ? '' : String((checkoutAddr && checkoutAddr.phone) || '') }) : null;   // P35-2 SEC-B-01
    var payload = {
      source: 'returns-desk',
      token: verified.token,
      category: NOTE_CATEGORY[kind],
      name: String((nameField && nameField.value) || (verified.order && verified.order.greeting) || '').trim(),
      email: String(val('email') || '').trim(),
      reply_email: replyEmail(),   // P22 (I1)
      requestId: fields.request_id.value || '',   // P22 (the lead, 2026-10-02): the intake's own id, so a retried edit is filed once
      phone: (pv && pv.phone) || normalizePhone(val('Phone')),
      order: orderName(),
      lane: deskLane || '',
      subject: noteSubject(kind),
      body: noteBody(kind)
    };
    if (deskReturnName) payload.returnName = deskReturnName;
    return payload;
  }
  /* P22 (I9, FAKE F1): THE EDIT IS A FILING. A change of size, color or delivery address before Bosta collects the order reaches the
     desk as its URGENT note and nothing else, so the page waits for the lane: the confirmation mounts on a 200 only; a 401 (the token
     lapsed), a 429, a 503 lane_off, any other answer and a network fault each take the page's own words, the form kept. Not keepalive
     (she is waiting on it), its own 12 s wall, and sent once: the chain's side record is never sent for an edit. It carries the
     request's id (the intake's, minted and kept the same way), so a retry after a lost answer is the same filing: the lane answers
     the stored note (changed: true when the body differs) and the page shows that earlier change, never the version typed since. */
  function fileEditNote(kind) {
    if (!verified || !verified.token || !NOTE_CATEGORY[kind]) return Promise.reject(new Error('intake_failed'));
    var opts = { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, cache: 'no-store', credentials: 'omit', body: JSON.stringify(notePayload(kind)) };
    var done = withWall(opts, INTAKE_TIMEOUT);
    return fetch(ownerUrl().replace(/\/$/, '') + '/intake/note', opts).then(function (r) {
      done();
      return r.text().then(function (text) { var body = null; try { body = JSON.parse(text); } catch (e) {} return { status: r.status, ok: r.ok, body: body || {} }; });
    }, function () { done(); throw new Error('intake_failed'); }).then(function (res) {
      if (res.ok && res.body.ok !== false) { deskChanged = res.body.changed === true; return res.body; }   // changed: the lane kept the earlier change under this id
      var err;
      if (res.status === 401 || res.status === 422) { err = new Error('intake_unverified'); err.status = 401; throw err; }
      // P35-3 SEC-B-17 ON THE NOTE LANE (svnty-core 0.8.2 noteGate): a new address from a phone session, refused in core's own words
      if (res.status === 400 && res.body.error === 'address_needs_email') { err = new Error('request_closed'); err.code = 'address_needs_email'; err.words = String(res.body.words || ''); throw err; }
      if (res.status === 429) throw new Error('intake_rate_limited');
      if (res.status === 503 && res.body.error === 'lane_off') throw new Error('lane_off');
      throw new Error('intake_failed');
    });
  }
  function fileNote(kind) {
    try {
      if (!verified || !verified.token) return;
      if (!NOTE_CATEGORY[kind]) return;
      var payload = notePayload(kind);
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, NOTE_TIMEOUT) : null;
      var opts = {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        cache: 'no-store', credentials: 'omit', keepalive: true, body: JSON.stringify(payload)
      };
      if (ctrl) opts.signal = ctrl.signal;
      var sent = fetch(ownerUrl().replace(/\/$/, '') + '/intake/note', opts);
      if (sent && typeof sent.then === 'function') {
        sent.then(function (r) {
          if (timer) clearTimeout(timer);
          if (!r || !r.ok) noteDebug('the desk note was not accepted', r && r.status);
        }, function (e) {
          if (timer) clearTimeout(timer);
          noteDebug('the desk note did not reach the desk', e && e.message);
        });
      }
    } catch (e) { noteDebug('the desk note was not sent', e && e.message); }
  }

  /* ---------- THE CHAIN ----------
     Started by the visible button (type="button") and by Enter in any cell. Nothing here dispatches a
     submit event: the native post is the LAST act, once the request exists at the desk. */
  function startSubmit() {
    if (form.dataset.rdSubmitting === '1') return;
    // P17-1 (P2-2): Enter in a demo cell reaches the chain without the button's click, which bootDemo's capture holds; the fence is here too
    if (DEMO) { submitError('This is the demo view. No request is sent from here, and nothing was filed.', false); if (submitStatus) submitStatus.classList.add('is-calm'); return; }
    if (!verified) { status(DESK ? 'Find your order first.' : 'Live order checks are being switched on: press Find to prepare the email.', !!DESK); $('[data-rd-order]').focus(); return; }
    // MANY PIECES (P27-7): the request's own choice first (what changes, the cancel's box and reason), then each piece by name
    // A CLOSED REQUEST NEVER LEAVES THE PAGE. The card state is the verdict, and it was cut from the window
    // the desk gave at lookup — so this is settled here, before /order, and never re-litigated against a
    // fresh order whose window may be missing. The check then moves itself to a kind still open.
    var checkedKind = $('[data-rd-type] input:checked');
    if (!checkedKind) {
      submitError('Choose what you need first.', true);
      var firstKind = $('[data-rd-type] input:not(:disabled)'); if (firstKind) { try { firstKind.focus(); } catch (e) {} }
      return;
    }
    if (checkedKind.disabled) {
      enforceEnabledKind();
      submitFailure('This request is no longer available for the order\u2019s current delivery state.', false);
      return;
    }
    var rp = requestProblem();
    if (rp) {
      submitError(rp.msg, true);
      if (rp.lines && linesErr) linesErr.textContent = rp.msg;
      if (rp.piece) {
        if (!rp.piece.on) setOn(rp.piece, true);
        if (rp.reason) { var re = rp.piece.el.querySelector('[data-rd-ed-reason-err]'); if (re) re.textContent = 'Choose a reason.'; rp.piece.picker.classList.add('is-invalid'); }
      }
      if (rp.cancelReason) { if (cancelReasonErr) cancelReasonErr.textContent = 'Choose why.'; cancelReasonRoot.classList.add('is-invalid'); }
      if (rp.el === cancelConfirm) { var crow = cancelConfirm.closest('.svnty-rd__toggle'); if (crow) crow.classList.add('is-invalid'); }
      if (rp.el) { try { rp.el.focus({ preventScroll: true }); rp.el.scrollIntoView({ block: 'center', behavior: MOTION }); } catch (e) { try { rp.el.focus(); } catch (e2) {} } }
      return;
    }
    // The pickup cells answer for themselves, by name, before the browser's own bubbles.
    var pickupIssue = pickupProblem();
    if (pickupIssue) {
      submitError(pickupIssue.msg, true);
      if (pickupIssue.el) { try { pickupIssue.el.focus({ preventScroll: true }); } catch (e) { pickupIssue.el.focus(); } }
      return;
    }
    // The consent box is drawn by the page, so its refusal is said by the page too (a native bubble on a 1 px input points at nothing).
    var consent = form.querySelector('[name="contact[Policy consent]"]');
    if (consent && !consent.checked) {
      var consentRow = consent.closest('.svnty-rd__consent'); if (consentRow) consentRow.classList.add('is-invalid');
      submitError('Check the box to accept the return terms.', true);
      try { consent.focus({ preventScroll: true }); } catch (e) { consent.focus(); }
      return;
    }
    /* P35-3 THE NEVER-LOSE RESTORE: a 0.8.1 core needs the contact once more after a refresh; it is asked by name, never with the
       browser's "fill this in first" while the token holds */
    var ask = askWords();
    if (ask) {
      submitError(ask, true);
      var askCell = form.querySelector('[name="contact[' + (askContact === 'email' ? 'email' : 'Phone') + ']"]');
      if (askCell) { try { askCell.focus({ preventScroll: false }); } catch (e) { askCell.focus(); } }
      return;
    }
    /* P22 (I1): the email cell is required only when no valid phone is typed (the lane matched the order with one of the two); P35-3:
       and never while the token proves the session or the contact is asked by name */
    var emailCell = form.querySelector('[name="contact[email]"]');
    if (emailCell) emailCell.required = contactRequired();
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      /* THE PAGE'S OWN WORDS (Part9, the parent's P1): the browser's bubble pointed at a cell inside a closed block and the customer saw
         nothing. The first invalid cell is named by its label; a hidden one is repaired (the quantity) or skipped, never bubbled. */
      var bad = $$('input, select, textarea', form).filter(function (el) { return !el.disabled && typeof el.checkValidity === 'function' && !el.checkValidity(); });
      var vis = bad.filter(function (el) { return el.offsetParent !== null || el.getClientRects().length; });
      if (!vis.length && !bad.length) { /* repaired: fall through to the chain */ }
      else {
        var el = vis[0] || bad[0];
        var lab = el.id ? form.querySelector('label[for="' + el.id + '"]') : null;
        var name = (lab && lab.textContent.trim()) || (el.getAttribute('aria-label') || '').trim() || 'a required cell';
        submitError(el.validity && el.validity.valueMissing ? name + ': fill this in first.' : 'Check ' + name.toLowerCase() + '.', true);
        if (vis[0]) { try { vis[0].focus({ preventScroll: false }); } catch (e) {} }
        return;
      }
    }
    var kind = currentKind(), submitFingerprint = lookupFingerprint(), submitRequestFingerprint = requestFingerprint();
    syncPickupFields(pickupActive());   // the mail's own pickup lines, settled before anything is sent
    fillMailPieces();                   // and the pieces, every one of them
    submitError('');
    form.dataset.rdSubmitting = '1'; form.setAttribute('aria-busy', 'true'); form.inert = true;
    submit.disabled = true; submitLabel.textContent = 'Checking';
    /* THE WALL (Part30, fileIntake's own): the form is inert from here, so a request that never answers would
       leave her looking at a dead card. 12 s, an AbortController where there is one, and the abort lands in the
       catch as `freshness_timeout` - which un-inerts the form and gives her the retry words. */
    var freshCtrl = typeof AbortController === 'function' ? new AbortController() : null;
    var freshTimer = freshCtrl ? setTimeout(function () { try { freshCtrl.abort(); } catch (e) {} }, INTAKE_TIMEOUT) : null;
    function freshDone() { if (freshTimer) { clearTimeout(freshTimer); freshTimer = null; } }
    var freshOpts = {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      cache: 'no-store', body: JSON.stringify({ token: verified.token })
    };
    if (freshCtrl) freshOpts.signal = freshCtrl.signal;
    fetch(DESK.replace(/\/$/, '') + '/order', freshOpts).then(function (r) {
      freshDone();
      return r.json().then(function (body) {
        if (!r.ok) { var err = new Error(body.error || 'freshness_failed'); err.status = r.status; throw err; }
        return body.order;
      });
    }, function () { freshDone(); throw new Error('freshness_timeout'); }).then(function (order) {
      if (nameField && order && typeof order.greeting === 'string') nameField.value = order.greeting.trim();
      if (!piecesStillMatch(order || {})) throw new Error('line_changed');
      if (submitFingerprint !== lookupFingerprint()) throw new Error('contact_changed');
      if (currentKind() !== kind) throw new Error('request_changed');
      if (!requestAllowed(order, kind)) throw new Error('request_closed');
      // P34-12 THE REPLACEMENT NEEDS STOCK: the fresh order is svnty-core's own word on her variant (availableNow = availableForSale); a piece
      // to replace that sold out since the page read it closes the replacement here, before anything is filed
      var sold = replaceGone(order); if (sold.length) { var se = new Error('replace_unavailable'); se.pieces = sold; throw se; }
      return recheckWants();
    }).then(function () {
      if (requestFingerprint() !== submitRequestFingerprint) throw new Error('request_changed');
      submitLabel.textContent = 'Filing';
      return fileIntake(kind);
    }).then(function () {
      // Past this line the return exists at the desk: the mail always follows it, never the reverse.
      // THE INBOX's side record starts here and is never awaited — the mail leaves on the same beat.
      // P22 (I9): an edit was its own note, filed and awaited above; never twice. A STORED request (changed) keeps its own note: the
      // version typed since never reaches the desk as if it were the request
      if ((laneFor(kind) || isCancelOrder(kind)) && !deskChanged) fileNote(kind);
      // THE PAGE ENDS ON ITS OWN CONFIRMATION (R240f): the draft carries the kind, the lane and the request's name for the view; the form
      // is removed, not hidden, so nothing inside it stays focusable behind the panel (the demo's view 5 does the same)
      saveDraft(); form.inert = false; form.removeAttribute('aria-busy');
      form.dataset.rdSubmitting = '0';
      submit.disabled = false; submitLabel.textContent = submitDefaultLabel;
      var tpl = root.querySelector('[data-rd-demo-confirm]');
      if (tpl && tpl.content && form.parentNode) {
        var panel = tpl.content.cloneNode(true);
        form.parentNode.insertBefore(panel, form);
        form.parentNode.removeChild(form);
        var view = root.querySelector('[data-rd-posted]');
        if (view) { view.id = 'rd-order'; try { history.replaceState(null, '', location.pathname + '#rd-order'); } catch (e) {} mountPosted(view); }
        try { view && view.scrollIntoView({ block: 'start', behavior: MOTION }); } catch (e) {}
        landPosted(view, 900);
      } else {
        submitError('Your request is filed. The reply comes by email.', true);
        try { sessionStorage.removeItem(DRAFT_KEY); sessionStorage.removeItem(SESSION_KEY); } catch (e) {}
      }
    }).catch(function (err) {
      /* P35-3: /order had just answered for the token, so a 401 on the filing is the contact: a restored session whose core still wants
         one (an edge that does not read the token's own contact yet) is asked once, by name; a contact asked once and typed wrong says so */
      if (err.status === 401 && err.proof && (tokenProof || askContact) && Date.now() - sessionVerifiedAt < SESSION_TTL_MS) {
        var wasAsked = !!askContact && !tokenProof;
        if (tokenProof) { tokenProof = false; askContact = verifiedBy || 'either'; }
        useAnother = true; syncVerifiedWith();
        var what = askContact === 'email' ? 'email' : askContact === 'phone' ? 'phone' : 'phone or the email';
        submitFailure(wasAsked ? 'That ' + what + ' is not the one this order was verified with. Check it and send again, or find the order again.' : 'Type the ' + what + ' on the order once more to send. Nothing was sent.', false);
      }
      else if (err.status === 401) submitFailure('Your verification expired or the order contact changed. Find the order again.', true);
      else if (err.message === 'freshness_timeout') submitFailure('The store did not answer in time. Nothing was sent. Try again.', false);
      else if (err.message === 'line_changed') submitFailure('This order changed since you checked it. Find the order again.', true);
      else if (err.message === 'contact_changed') submitFailure('The order contact changed while it was being checked. Find the order again.', true);
      else if (err.message === 'request_closed' && err.code === 'quantity') submitFailure('That quantity is more than can still come back from this line. Find the order again to see what is left.', true);
      /* P34-12 THE REPLACEMENT NEEDS STOCK: sold out since the page read it (the fresh order) or refused by the lane (it names the line; a
         refusal naming none closes the replacement for every piece): the claim turns to the full refund, in words, nothing filed */
      else if (err.message === 'replace_unavailable' || (err.message === 'request_closed' && err.code === 'want_unavailable' && err.reason === 'replace')) {
        var soldPs = err.pieces || (err.lineId && pieceOf(err.lineId) ? [pieceOf(err.lineId)] : onPieces());
        soldPs.forEach(function (sp) { sp.soldOut = true; });
        syncReplace(); renderPieces();
        submitFailure(soldSendWords(err.lineId || err.pieces ? soldPs : []), false);
      }
      else if (err.message === 'request_closed' && err.code === 'want_unavailable') submitFailure('The piece you want is no longer available in that option. Choose another one.', false);
      /* P35-3 SEC-B-17 THE LABEL PROOF (svnty-core 0.8.2): a session proven with the phone printed on the parcel label files from the
         delivery address only; core's own words say so, the page turns back to the delivery address (an address edit waits for the
         email), nothing was sent, the form is kept */
      else if (err.message === 'request_closed' && (err.code === 'pickup_needs_email' || err.code === 'address_needs_email')) {
        verifiedBy = 'phone'; saveCells(); syncPickup(); syncSubmitNote();
        submitFailure(err.words || emailGateWords(), false);
      }
      else if (err.message === 'request_closed' && err.code === 'pickup') {
        if (pickupEffective() === 'other') {
          submitFailure('Check the different address: ' + (err.field === 'phone' ? 'the phone does not read as an Egyptian mobile.' : 'one of its cells could not be read.') + ' Nothing was sent.', false);
          if (err.field && PA_KEYS.indexOf(err.field) !== -1) { var m1 = {}; m1[err.field] = 'Check this.'; var b1 = paintOther(m1); if (b1[0]) { try { b1[0].focus(); } catch (e) {} } }
        } else submitFailure('The delivery address on this order could not be used for the pickup' + (err.field === 'phone' ? ' (its phone does not read as an Egyptian mobile)' : '') + '. Choose "a different address" below and type where Bosta collects. Nothing was sent.', false);
      }
      else if (err.message === 'request_closed' && err.code === 'reason') submitFailure('Choose the reason again: that one does not fit this request.', false);
      else if (err.message === 'request_closed' && err.code === 'quantity' && err.field === 'unshipped') submitFailure('Part of that piece has not shipped yet, so it cannot come back. Choose fewer, or find the order again.', true);
      else if (err.message === 'request_closed' && err.code === 'action') submitFailure('The request changed while it was being checked. Review it and send again.', false);
      else if (err.message === 'request_closed') submitFailure('This request is no longer open for the order’s current delivery state. Find the order again to see what it allows.', true);
      /* D12-3 THE CANCEL DOOR: the desk refused in its own words; a shipped order is pointed to the 14-day return once it is delivered, and the
         order is re-found (its state changed under the form); a paused lane sent nothing. P17-24 (desk 0.27.3's note): the desk's
         shipped words already name the 14-day return (and code 45's say it is delivered), so the page adds its sentence only when
         the words it shows do not say it: once is enough */
      else if (err.message === 'cancel_refused') {
        var cw = err.words || (err.reason === 'already_cancelled' ? 'This order is already canceled.' : err.reason === 'courier_down' ? 'We could not reach the courier to check the parcel. Nothing was sent. Try again in a moment.' : 'This order is already with Bosta and can no longer be canceled.');
        if (err.reason === 'shipped' && !/\b14.day/i.test(cw)) cw += ' Once it is delivered, you have 14 days to return or exchange it from this page.';
        submitFailure(cw, err.reason !== 'courier_down');
      }
      else if (err.message === 'cancel_busy') submitFailure('The store is busy. Nothing was sent. Try again shortly.', false);   // P22 (P3-7)
      /* P22 (I7): the desk's Live switch is off and this is not a staff order: nothing was filed, and the words say who handles it */
      else if (err.message === 'lane_off') submitFailure('Requests are being switched on. Write to ' + (root.getAttribute('data-support') || 'onlineshop@svntyeg.com') + ' and we handle it by hand.', false, true);
      else if (err.message === 'intake_turnstile') submitFailure('The security check did not pass. Nothing was sent. Try again.', false);
      else if (err.message === 'target_unavailable') submitFailure((err.piece ? 'The size chosen for ' + err.piece : 'That option') + ' sold out before the request was sent. Choose an available one.', false);
      else if (err.message === 'target_changed' || err.message === 'request_changed') submitFailure('The request changed while it was being checked. Review it and send again.', false);
      else if (err.message === 'target_check_failed') submitFailure('We could not re-check that option. Nothing was sent. Try again.', false);
      else if (err.message === 'intake_duplicate') submitFailure(err.returnName ? 'A piece of this request is already filed as ' + err.returnName + '. We have it.' : 'A piece of this request is already filed with us. We have it.', false, true);
      else if (err.message === 'intake_rate_limited') submitFailure('Too many requests from this device. Try again in a few minutes.', false);
      else if (err.message === 'pickup_rejected') {
        submitFailure('Check the different address: the desk could not read it. Nothing was sent.', false);
        var map = {}; Object.keys(err.fields || {}).forEach(function (k) { if (PA_KEYS.indexOf(k) !== -1) map[k] = String(err.fields[k]).replace(/\.?$/, '.'); });
        var bad = paintOther(map); if (bad[0]) { try { bad[0].focus({ preventScroll: false }); } catch (e) {} }
      }
      else if (err.message === 'intake_failed') submitFailure('We could not confirm the request was filed. No email was sent. Try again: the same request is never filed twice.', false);
      else submitFailure('We could not re-check the order. Nothing was sent. Try again.', false);
    });
  }
  submit.addEventListener('click', startSubmit);
  /* Enter in a cell used to be a native submit — which is exactly what the captcha script rides. It is the
     button's own press now. Order/Phone/email keep their own Enter (they find the order); those handlers
     preventDefault first, and this one stands down when they have. */
  form.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || e.defaultPrevented || e.isComposing) return;
    var el = e.target;
    if (!el || (el.tagName !== 'INPUT' && el.tagName !== 'SELECT')) return;
    var type = String(el.type || '').toLowerCase();
    if (type === 'submit' || type === 'button' || type === 'reset' || type === 'image') return;
    e.preventDefault();
    startSubmit();
  });
  /* THE GATE (R240f): no submit event is ever ours now (the native post is gone); anything that raises one is refused and routed
     back through the chain. */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    startSubmit();
  });

  /* ---------- THE BOOT ----------
     Everything the page can know before the customer touches it: the choices from this tab's draft, then the
     verified order from this tab's session — re-read from the desk, never trusted from storage. A refresh, a
     back/forward, and the walk back from the store all arrive here. Nothing is ever submitted from this path. */
  setFindState('idle');
  syncSubmitNote();
  /* THE PREFILLED LINK (Part24): an automated reply lands the customer here with `?order=515886`. The order cell is
     filled and the cursor waits on the email cell — the contact is never in a link (law 110). The URL's order wins over
     a stale session for another order (restoreVerified drops a session whose order differs from what is on screen). */
  /* P17-18 (the privacy audit's P0-4): the order number rides the fragment (#order=) or, from the mails already sent, the query;
     the section's first script reads it and takes it out of the address bar (window.__svntyArrival), so no analytics tag keeps it.
     The address is read here too, in case that script could not run, and cleaned the same way. */
  function arrivalOrder() {
    var got = (ARRIVAL && ARRIVAL.order) || '';
    try { window.__svntyArrival = null; } catch (e) {}
    try {
      var q = new URLSearchParams(location.search), h = /^#order=/.test(location.hash) ? new URLSearchParams(location.hash.slice(1)) : null;
      if (h && h.has('order')) { got = got || h.get('order'); h.delete('order'); }
      if (q.has('order')) { got = got || q.get('order'); q.delete('order'); }
      if (h || location.search !== (q.toString() ? '?' + q.toString() : '')) {
        var rest = q.toString(), frag = h ? h.toString() : location.hash.slice(1);
        history.replaceState(history.state, '', location.pathname + (rest ? '?' + rest : '') + (frag ? '#' + frag : ''));
      }
    } catch (e) {}
    return String(got || '');
  }
  function prefillOrderFromUrl() {
    var q = arrivalOrder(); if (!q) return false;
    var m = /^\s*#?([0-9\u0660-\u0669\u06F0-\u06F9]{1,12})\s*$/.exec(q); if (!m) return false;
    m[1] = foldDigits(m[1]);
    var el = form.querySelector('[name="contact[Order]"]'); if (!el) return false;
    el.value = m[1];
    var s = readSession(); if (s && String(s.orderName || '') !== m[1]) clearSession();
    return true;
  }
  /* ---------------------------------------------------------------------------------------------
     THE DEMO LANE (SVNTY night build, 2026-09-19; five views, lane N, RT-5 same night).
     The lane this desk talks to (/apps/svnty/returns) is rung 5 of THE BUILD LADDER and does not
     exist yet, so `?demo=N` renders the WHOLE thread from a synthetic order - every step unlocked,
     every card in its real state, the pickup cells prefilled, the want chips live - so the surface
     can be judged tonight at desktop, iPad and iPhone.

     IT IS NOT A FAKE RESULT, and that is the whole design:
       · the order name IS "#DEMO", the status line says DEMO, and a banner says it above the form;
       · contact[Client lookup] carries "demo", never "desk-v1", so no mail could read as verified;
       · the piece is a REAL product of this store (data-demo-*), so the size and colour chips come
         from the live /products/<handle>.js read the desk always uses - no invented catalogue;
       · the governorate list still tries the real lane and still falls back in the open, with its
         own retry button, exactly as it will on the night the lane is late;
       · NOTHING can be sent: the send is stopped in the capture phase, above the module's own
         handler, and says so in words;
       · RT-2: every keystroke is drafted into the demo's OWN storage key, never the live one.

     RT-5 - FIVE VIEWS, not one. `?demo=1` used to reach exactly ONE order state (delivered, in
     window), so four states could not be seen at all: the out-of-window rejection, the pre-ship
     cancel/edit state, a line with a request already open on it, and the confirmation panel the
     customer lands on after a successful send. The switcher in the banner walks all five, and each
     view is a plain URL (`?demo=1` … `?demo=5`) so a frame can be taken of any one of them.
     Delete nothing here when the lane lands - `?demo=` stays the way to see every state.
     --------------------------------------------------------------------------------------------- */
  /* T-8: the tracking page's own sample uses the SAME two numbers, so the pair of demos never tells
     one story about one parcel twice. Keep them equal to assets/svnty-tracking.js
     DEMO_DELIVERED_AGO / DEMO_WINDOW_LEFT. */
  var DEMO_DELIVERED_AGO_DAYS = 5;
  var DEMO_WINDOW_LEFT_DAYS = 9;      // 14 - DEMO_DELIVERED_AGO_DAYS
  var DEMO_VIEWS = [
    { n: 1, label: 'In window',   note: 'Delivered ' + DEMO_DELIVERED_AGO_DAYS + ' days ago, ' + DEMO_WINDOW_LEFT_DAYS + ' of the 14 left: exchange, refund and faulty open; cancel closed and saying why.' },
    { n: 2, label: 'Window closed', note: 'Delivered 20 days ago: the 14-day window is over, so exchange and refund are closed. A faulty or wrong piece is still covered.' },
    { n: 3, label: 'Before it ships', note: 'Not collected by Bosta yet: cancel and edit are open, exchange and refund open on delivery.' },
    { n: 4, label: 'Request already open', note: 'Two pieces on the order; one already has a request filed on it and refuses a second.' },
    { n: 5, label: 'Request sent', note: 'The confirmation panel the customer lands on after a successful send.' }
  ];
  function demoLine(i, over) {
    var handle = root.getAttribute('data-demo-handle') || '';
    var title = root.getAttribute('data-demo-title') || 'A piece from this store';
    var image = root.getAttribute('data-demo-image') || '';
    /* the demo's piece is a REAL variant of a real piece (the section prints it), so the size chips, the swap rail and the
       exchange choice all work on the demo exactly as they will on a real order */
    var vid = root.getAttribute('data-demo-variant') || '';
    var vparts = (root.getAttribute('data-demo-variant-title') || 'M').split(' / ');
    var vnames = (root.getAttribute('data-demo-option-names') || 'Size').split('|');
    var line = {
      lineId: 'demo-' + i, variantId: vid, quantity: 1, handle: handle,
      productTitle: title, variantTitle: vparts.join(' / '), image: image,
      options: vparts.map(function (v, k) { return { name: vnames[k] || 'Option', value: v }; }), world: 'original', openReturn: null
    };
    for (var k in over) { if (Object.prototype.hasOwnProperty.call(over, k)) line[k] = over[k]; }
    return line;
  }
  function demoOrder(view) {
    var now = Date.now(), day = 86400000;
    var stage = 'DELIVERED', canEdit = false, win, lines = [demoLine(1)];
    if (view === 2) {
      /* DELIVERED_CLOSED: the rejection. Exchange and refund closed with "Window closed" on the
         cards; the window panel carries .is-closed; only the faulty path stays open. */
      win = { state: 'DELIVERED_CLOSED', open: false, extended: false, daysLeft: 0,
        deliveredAt: new Date(now - 20 * day).toISOString(),
        closesAt: new Date(now - 6 * day).toISOString() };
    } else if (view === 3) {
      /* PREPARING: not picked up by Bosta yet - cancel/edit open (the one state where they are),
         exchange and refund closed with "After delivery". */
      stage = 'PREPARING'; canEdit = true;
      win = { state: 'PREPARING', open: false, extended: false, daysLeft: null };
    } else {
      win = { state: 'DELIVERED_OPEN', open: true, extended: false, daysLeft: DEMO_WINDOW_LEFT_DAYS,
        deliveredAt: new Date(now - DEMO_DELIVERED_AGO_DAYS * day).toISOString(),
        closesAt: new Date(now + DEMO_WINDOW_LEFT_DAYS * day).toISOString() };
    }
    if (view === 4) lines = [demoLine(1, { openReturn: '#DEMO-R1' }), demoLine(2, { variantTitle: 'L', options: [{ name: 'Size', value: 'L' }] })];
    return {
      token: 'demo',
      order: {
        name: '#DEMO', greeting: 'Demo', stage: stage,
        placedAt: new Date(now - 12 * day).toISOString(),
        canEditBeforePickup: canEdit,
        awbs: stage === 'PREPARING' ? [] : [{ number: 'DEMO' }],
        window: win,
        delivery: {
          firstName: 'Demo', lastName: 'Customer', phone: '01000000000',
          address1: '1 Demo Street', address2: '', city: 'Nasr City',
          province: 'Cairo', provinceCode: 'C', zip: ''
        },
        lines: lines
      }
    };
  }
  /* The banner says what this is, and the switcher walks the five views. Each chip is a real link,
     so a view can be opened, shared, framed and reloaded - not a state trapped in one tab. */
  function demoBanner(view) {
    var wrap = document.createElement('div');
    wrap.className = 'svnty-rd__demo';
    var b = document.createElement('p');
    b.className = 'svnty-rd__demo-line';
    b.setAttribute('role', 'status');
    b.textContent = 'DEMO VIEW ' + view + ' of 5: order #DEMO is not a real order and nothing on this page can be sent. '
      + 'Nothing typed here is remembered on a real visit. The returns lane is not built yet; remove ?demo= to see the live desk.';
    wrap.appendChild(b);
    var row = document.createElement('div');
    row.className = 'svnty-rd__demo-row';
    row.setAttribute('role', 'group');
    row.setAttribute('aria-label', 'Demo views');
    DEMO_VIEWS.forEach(function (v) {
      var a = document.createElement('a');
      a.className = 'svnty-rd__demo-chip' + (v.n === view ? ' is-on' : '');
      a.href = '?demo=' + v.n;
      a.textContent = v.n + '. ' + v.label;
      if (v.n === view) a.setAttribute('aria-current', 'true');
      row.appendChild(a);
    });
    wrap.appendChild(row);
    var note = document.createElement('p');
    note.className = 'svnty-rd__demo-note';
    var current = DEMO_VIEWS.filter(function (v) { return v.n === view; })[0];
    note.textContent = current ? current.note : '';
    wrap.appendChild(note);
    var host = form && form.parentNode ? form.parentNode : root;
    host.insertBefore(wrap, form || host.firstChild);
    return wrap;
  }
  /* View 5: the confirmation panel. It lives in the section's `form.posted_successfully?` branch,
     which Liquid cannot render on a `?demo=` visit, so the section also ships an inert
     <template data-rd-demo-confirm> holding the same words (snippets/svnty-rd-confirm.liquid).
     The form is removed - not hidden - so nothing inside it stays focusable behind the panel. */
  function bootDemoConfirm() {
    var tpl = root.querySelector('[data-rd-demo-confirm]');
    demoBanner(5);
    if (!tpl || !tpl.content || !form) return;
    var panel = tpl.content.cloneNode(true);
    form.parentNode.insertBefore(panel, form);
    form.parentNode.removeChild(form);
    var live = root.querySelector('[data-rd-posted]');
    if (live) {
      // The real panel names the request type from the draft; the demo names the one a walk would have sent.
      Array.prototype.forEach.call(live.querySelectorAll('[data-rd-next-for]'), function (li) {
        li.hidden = li.getAttribute('data-rd-next-for') !== 'exchange';
      });
      var lede = live.querySelector('[data-rd-posted-lede]');
      if (lede) lede.textContent = 'Your exchange is filed as #DEMO-R1. We’ll confirm the pickup by email. (Demo. Nothing was filed and nothing was sent.)';
    }
  }
  function bootDemo(view) {
    if (view === 5) { bootDemoConfirm(); return; }
    demoBanner(view);
    applyVerified(demoOrder(view), false);
    fields.verified.value = 'demo';
    status('DEMO: order #DEMO for Demo. ' + (view === 4 ? 'Two pieces below; one already has a request open.' : 'Your piece is ticked below.'));
    /* Capture phase on the section root: an ancestor's capture listener always runs before the
       target's own, which a second listener on the button itself would not guarantee. */
    root.addEventListener('click', function (e) {
      var hit = e.target && e.target.closest && e.target.closest('[data-rd-submit]');
      if (!hit) return;
      e.preventDefault(); e.stopPropagation();
      submitError('This is the demo view. No request is sent from here, and nothing was filed.', false);
      if (submitStatus) submitStatus.classList.add('is-calm');
    }, true);
  }

  (function boot() {
    try {
      restoreDraft(); syncKind();
      var linked = prefillOrderFromUrl();
      if (!DEMO) restoreCells(linked);                      // P20: what she typed in step 1 is back before anything else happens
      var restoring = DEMO ? false : restoreVerified();   // P17-1 (P2-2): a demo view never re-reads a real session from the lane
      /* P20 THE PLACE: only a refresh or a Back onto a verified order moves the page, and only until her first touch */
      try {
        var navP = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
        var pl = restoring && navP && (navP.type === 'reload' || navP.type === 'back_forward') ? fresh(PLACE_KEY) : null;
        if (pl) {
          placeDue = true; placeHold = true; setTimeout(endPlace, 15000);
          /* the form keeps the height it had, so the theme's own restore finds her place while the steps are still closed: she
             waits on a quiet page, never on the footer, and the steps reopen under her without a jump */
          if (Number(pl.h) > 0) root.style.minHeight = Math.min(Number(pl.h), 30000) + 'px';
        }
      } catch (e) {}
      if (linked && !restoring && !verified) { var em = form.querySelector('[name="contact[email]"]'); if (em) { try { em.focus(); } catch (e) {} } }
      /* DEMO last: it must win the screen over any stale draft or session. */
      if (DEMO) bootDemo(DEMO_VIEW);
    } catch (e) { /* a broken draft or session must never take the form down with it */ }
  })();
})();
